export const DataFRE = [
  {
    ID: 0,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général pour la question des enfants et des conflits armés",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général pour la question des enfants et des conflits armés",
    Title: "Diminution du nombre vérifié d’enfants en détention",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,HT,NG,SO,YE",
    Image: "1POLICY1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=58"
  },
  {
    ID: 1,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général pour la question des enfants et des conflits armés",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général pour la question des enfants et des conflits armés",
    Title: "Augmentation du nombre de plans d’action, de protocoles de transfert et d’autres engagements conclus entre l’ONU et des parties à un conflit pour faire cesser et prévenir les violations graves commises contre des enfants",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=59"
  },
  {
    ID: 2,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général pour la question des enfants et des conflits armés",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général pour la question des enfants et des conflits armés",
    Title: "Diminution du nombre d’enfants recrutés et utilisés par des parties à un conflit armé",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=60"
  },
  {
    ID: 3,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général pour la question des enfants et des conflits armés",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général pour la question des enfants et des conflits armés",
    Title: "Augmentation du nombre d’enfants libérés des forces et groupes armés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=61"
  },
  {
    ID: 4,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question des violences sexuelles commises en période de conflit",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question des violences sexuelles commises en période de conflit",
    Title: "Renforcement de la prise en main nationale des activités visant à prévenir les violences sexuelles liées aux conflits et à rendre justice aux personnes survivantes : le cas de l’Ukraine",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UA",
    Image: "1POLICY5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=72"
  },
  {
    ID: 5,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question des violences sexuelles commises en période de conflit",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question des violences sexuelles commises en période de conflit",
    Title: "Amélioration des services fournis et de l’action judiciaire menée par les autorités nationales en réponse à la violence sexuelle liée aux conflits",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DJ,ER,ET,SO,SD,QQ",
    Image: "1POLICY6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=73"
  },
  {
    ID: 6,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question des violences sexuelles commises en période de conflit",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question des violences sexuelles commises en période de conflit",
    Title: "Renforcement de l’arsenal judiciaire des autorités nationales à l’appui d’une justice axée sur les personnes survivantes et de la lutte contre l’impunité dans les cas de violences sexuelles liées aux conflits",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CO,CF,CD,UA",
    Image: "1POLICY7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=74"
  },
  {
    ID: 7,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question des violences sexuelles commises en période de conflit",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question des violences sexuelles commises en période de conflit",
    Title: "Meilleure application des normes internationales en matière de prévention et de répression des violences sexuelles liées aux conflits",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=74"
  },
  {
    ID: 8,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question de la violence contre les enfants",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question de la violence contre les enfants",
    Title: "Renforcement de la mobilisation du secteur privé en faveur de la protection des enfants contre les violences commises dans le contexte des voyages et du tourisme",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=84"
  },
  {
    ID: 9,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question de la violence contre les enfants",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question de la violence contre les enfants",
    Title: "Revitalisation de l’initiative des pays pionniers (Alliance mondiale pionnière pour l’élimination de la violence contre les enfants) aux fins de l’élimination de la violence contre les enfants d’ici à 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=85"
  },
  {
    ID: 10,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question de la violence contre les enfants",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question de la violence contre les enfants",
    Title: "Les États Membres adoptent des feuilles de route stratégiques visant à accélérer l’action menée pour éliminer la violence contre les enfants d’ici à 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=85"
  },
  {
    ID: 11,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question de la violence contre les enfants",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la Représentante spéciale du Secrétaire général chargée de la question de la violence contre les enfants",
    Title: "L’échange de connaissances entre les États Membres permet d’accélérer l’action visant à faire cesser les violences contre les enfants",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=86"
  },
  {
    ID: 12,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Bureau du Coordonnateur spécial chargé d’améliorer l’action des Nations Unies face à l’exploitation et aux atteintes sexuelles",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau du Coordonnateur spécial chargé d’améliorer l’action des Nations Unies face à l’exploitation et aux atteintes sexuelles",
    Title: "Meilleure prise en compte des mesures de protection dans les plans-cadres de coopération",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des mesures de lutte contre l’exploitation et les atteintes sexuelles, le harcèlement sexuel, la fraude et la corruption ; intégration plus systématique d’une approche centrée sur les victimes",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=99"
  },
  {
    ID: 13,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Bureau du Coordonnateur spécial chargé d’améliorer l’action des Nations Unies face à l’exploitation et aux atteintes sexuelles",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau du Coordonnateur spécial chargé d’améliorer l’action des Nations Unies face à l’exploitation et aux atteintes sexuelles",
    Title: "Une approche coordonnée est mise en place dans le cadre de l’initiative Unité d’action des Nations Unies pour mieux lutter contre l’exploitation et les atteintes sexuelles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des mesures de lutte contre l’exploitation et les atteintes sexuelles, le harcèlement sexuel, la fraude et la corruption ; intégration plus systématique d’une approche centrée sur les victimes",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=100"
  },
  {
    ID: 14,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Bureau du Coordonnateur spécial chargé d’améliorer l’action des Nations Unies face à l’exploitation et aux atteintes sexuelles",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau du Coordonnateur spécial chargé d’améliorer l’action des Nations Unies face à l’exploitation et aux atteintes sexuelles",
    Title: "Les efforts de prévention et de répression portent leurs fruits grâce à l’institutionnalisation de la protection contre l’exploitation et les atteintes sexuelles dans l’ensemble du système des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des mesures de lutte contre l’exploitation et les atteintes sexuelles, le harcèlement sexuel, la fraude et la corruption ; intégration plus systématique d’une approche centrée sur les victimes",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=100"
  },
  {
    ID: 15,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Bureau du Coordonnateur spécial chargé d’améliorer l’action des Nations Unies face à l’exploitation et aux atteintes sexuelles",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau du Coordonnateur spécial chargé d’améliorer l’action des Nations Unies face à l’exploitation et aux atteintes sexuelles",
    Title: "L’approche stratégique suivie dans l’ensemble du système face à l’exploitation et aux atteintes sexuelles est renforcée",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des mesures de lutte contre l’exploitation et les atteintes sexuelles, le harcèlement sexuel, la fraude et la corruption ; intégration plus systématique d’une approche centrée sur les victimes",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=101"
  },
  {
    ID: 16,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Bureau des services d’ombudsman et de médiation des Nations Unies",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau des services d’ombudsman et de médiation des Nations Unies",
    Title: "Mieux gérer les conflits sur le lieu de travail grâce à des activités de renforcement des capacités et des compétences",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=110"
  },
  {
    ID: 17,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Bureau des services d’ombudsman et de médiation des Nations Unies",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau des services d’ombudsman et de médiation des Nations Unies",
    Title: "Le personnel des Nations Unies n’ayant pas la qualité de fonctionnaire a accès à des services de règlement amiable des différends",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=111"
  },
  {
    ID: 18,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Bureau des services d’ombudsman et de médiation des Nations Unies",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau des services d’ombudsman et de médiation des Nations Unies",
    Title: "L’accès aux services est amélioré pour le personnel travaillant sur le terrain",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=112"
  },
  {
    ID: 19,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Bureau des services d’ombudsman et de médiation des Nations Unies",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau des services d’ombudsman et de médiation des Nations Unies",
    Title: "La connaissance de l’existence des services de médiation est améliorée",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=112"
  },
  {
    ID: 20,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Bureau de l’administration de la justice",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de l’administration de la justice",
    Title: "Amélioration des capacités de suivi des affaires portées devant le Tribunal du contentieux administratif des Nations Unies",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=120"
  },
  {
    ID: 21,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Bureau de l’administration de la justice",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de l’administration de la justice",
    Title: "Le système d’administration de la justice est plus transparent grâce à l’utilisation de l’informatique décisionnelle et à la communication d’informations sur l’analyse des tendances",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=121"
  },
  {
    ID: 22,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Bureau de l’administration de la justice",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de l’administration de la justice",
    Title: "On a davantage recours aux conseils juridiques du Bureau de l’aide juridique au personnel",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=122"
  },
  {
    ID: 23,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Bureau de l’administration de la justice",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de l’administration de la justice",
    Title: "Le règlement des affaires portées devant le Tribunal du contentieux administratif des Nations Unies est plus rapide",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=122"
  },
  {
    ID: 24,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Bureau de la déontologie",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la déontologie",
    Title: "Les membres du personnel hésitent moins à demander conseil sur les moyens de se protéger contre les représailles",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=131"
  },
  {
    ID: 25,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Bureau de la déontologie",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la déontologie",
    Title: "Sensibilisation accrue du personnel de terrain aux questions déontologiques et amélioration de l’accès aux services de déontologie Exécution du programme en 2025 et cible pour 2027",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=132"
  },
  {
    ID: 26,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Bureau de la déontologie",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la déontologie",
    Title: "Transparence accrue et meilleure application du principe de responsabilité grâce aux orientations et aux conseils fournis dans le cadre du dispositif de transparence financière",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=133"
  },
  {
    ID: 27,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Bureau de la déontologie",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la déontologie",
    Title: "Meilleure compréhension par le personnel des procédures de protection contre les représailles et respect accru des délais dans leur application",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=134"
  },
  {
    ID: 28,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Système des coordonnatrices et coordonnateurs résidents",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Système des coordonnatrices et coordonnateurs résidents",
    Title: "Promotion, par les gouvernements nationaux, d’approches intégrées afin d’accélérer la réalisation des objectifs de développement durable",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=145"
  },
  {
    ID: 29,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Système des coordonnatrices et coordonnateurs résidents",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Système des coordonnatrices et coordonnateurs résidents",
    Title: "Transparence accrue et meilleure application du principe de responsabilité en ce qui concerne les résultats obtenus par le système des Nations Unies et la contribution à la réalisation des objectifs de développement durable : utilisation d’indicateurs standard dans les plans-cadres de coopération des Nations Unies pour le développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=146"
  },
  {
    ID: 30,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Système des coordonnatrices et coordonnateurs résidents",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Système des coordonnatrices et coordonnateurs résidents",
    Title: "Meilleure efficacité de l’appui de l’Organisation à la réalisation des objectifs de développement durable grâce à des solutions axées sur les données et à l’innovation numérique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=146"
  },
  {
    ID: 31,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Système des coordonnatrices et coordonnateurs résidents",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Système des coordonnatrices et coordonnateurs résidents",
    Title: "Préserver les vies et les moyens de subsistance face aux répercussions socioéconomiques à long terme des crises",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Administration publique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=147"
  },
  {
    ID: 32,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Bureau des Nations Unies pour la jeunesse",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau des Nations Unies pour la jeunesse",
    Title: "Progrès dans la promotion des priorités relatives à la jeunesse et de la participation effective des jeunes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=164"
  },
  {
    ID: 33,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Bureau des Nations Unies pour la jeunesse",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau des Nations Unies pour la jeunesse",
    Title: "La participation des jeunes est facilitée à tous les niveaux : on passe de la quantité à la qualité",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=164"
  },
  {
    ID: 34,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Bureau des Nations Unies pour la jeunesse",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau des Nations Unies pour la jeunesse",
    Title: "On s’emploie à créer une plateforme mondiale d’investissement pour les jeunes afin de développer les programmes en faveur des jeunes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=165"
  },
  {
    ID: 35,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Bureau des Nations Unies pour la jeunesse",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau des Nations Unies pour la jeunesse",
    Title: "La participation des jeunes aux processus de paix et de sécurité est renforcée Projet de plan-programme pour 2027",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=166"
  },
  {
    ID: 36,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Bureau de la protection des données et de la confidentialité",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la protection des données et de la confidentialité",
    Title: "Amélioration de l’état de préparation opérationnelle en matière de gestion de la protection des données et de la confidentialité",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=175"
  },
  {
    ID: 37,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Bureau de la protection des données et de la confidentialité",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la protection des données et de la confidentialité",
    Title: "La protection des données et la confidentialité sont améliorées dans l’ensemble du Secrétariat",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=175"
  },
  {
    ID: 38,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Bureau de la protection des données et de la confidentialité",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la protection des données et de la confidentialité",
    Title: "Les processus opérationnels sont optimisés afin de tenir compte de la politique de protection des données et de confidentialité et d’en garantir le respect dans l’ensemble de l’Organisation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Adoption de cadres juridiques et réglementaires plus adaptés ; réduction du risque de mise en cause de la responsabilité juridique",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=176"
  },
  {
    ID: 39,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Bureau de la protection des données et de la confidentialité",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau de la protection des données et de la confidentialité",
    Title: "Amélioration de la résilience organisationnelle et plus grande maturité en matière de protection des données et de confidentialité programmée à l’ère de l’intelligence artificielle",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=177"
  },
  {
    ID: 40,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Bureau des technologies numériques et émergentes",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau des technologies numériques et émergentes",
    Title: "Les progrès accomplis dans la mise en œuvre du Pacte numérique mondial deviennent visibles pour toutes les parties prenantes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=184"
  },
  {
    ID: 41,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Bureau des technologies numériques et émergentes",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau des technologies numériques et émergentes",
    Title: "Les engagements multipartites pris en faveur du Pacte numérique mondial sont renforcés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=185"
  },
  {
    ID: 42,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Bureau des technologies numériques et émergentes",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau des technologies numériques et émergentes",
    Title: "La coopération en matière de gouvernance internationale de l’intelligence artificielle est renforcée",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=186"
  },
  {
    ID: 43,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "Alliance des civilisations de l’Organisation des Nations Unies",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Alliance des civilisations de l’Organisation des Nations Unies",
    Title: "Les États Membres s’approprient davantage les activités visant à promouvoir une culture de la paix, à entretenir un dialogue interreligieux et interculturel pour favoriser la compréhension mutuelle et à lutter contre toutes les formes d’intolérance religieuse",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=197"
  },
  {
    ID: 44,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "Alliance des civilisations de l’Organisation des Nations Unies",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Alliance des civilisations de l’Organisation des Nations Unies",
    Title: "Les acteurs étatiques et non étatiques sont plus sensibilisés aux tendances contemporaines de l’islamophobie",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=198"
  },
  {
    ID: 45,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "Alliance des civilisations de l’Organisation des Nations Unies",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Alliance des civilisations de l’Organisation des Nations Unies",
    Title: "La coordination dans le système des Nations Unies et la mobilisation des parties prenantes sont renforcées dans le cadre de la lutte contre l’antisémitisme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=199"
  },
  {
    ID: 46,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "Bureau du Groupe des Nations Unies pour le développement durable chargé des évaluations à l’échelle du système",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau du Groupe des Nations Unies pour le développement durable chargé des évaluations à l’échelle du système",
    Title: "Les données factuelles issues d’évaluations menées dans tout le système éclairent les décisions prises dans le cadre de l’Initiative ONU80",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=208"
  },
  {
    ID: 47,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "Bureau du Groupe des Nations Unies pour le développement durable chargé des évaluations à l’échelle du système",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau du Groupe des Nations Unies pour le développement durable chargé des évaluations à l’échelle du système",
    Title: "Accroissement de la disponibilité et de l’utilisation des résultats des évaluations menées à l’échelle du système",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=208"
  },
  {
    ID: 48,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "Bureau du Groupe des Nations Unies pour le développement durable chargé des évaluations à l’échelle du système",
    Programme: "Politiques, direction et coordination d’ensemble",
    Subprogramme: "Bureau du Groupe des Nations Unies pour le développement durable chargé des évaluations à l’échelle du système",
    Title: "Utilisation accrue par les États Membres et les organes intergouvernementaux, aux fins de la prise de décision, des données factuelles issues d’évaluations menées dans tout le système des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.1)&l=fr#page=209"
  },
  {
    ID: 49,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Affaires de l’Assemblée générale et du Conseil économique et social",
    Title: "Multiplication des consultations menées par les cofacilitateurs nommés par la présidence de l’Assemblée générale",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=9"
  },
  {
    ID: 50,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Affaires de l’Assemblée générale et du Conseil économique et social",
    Title: "Informations standardisées sur les travaux des différents organes intergouvernementaux mises à la disposition des représentants",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=10"
  },
  {
    ID: 51,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Affaires de l’Assemblée générale et du Conseil économique et social",
    Title: "Des échanges plus simples et plus intuitifs entre les délégations et le Secrétariat grâce à la plateforme e-deleGATE",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=11"
  },
  {
    ID: 52,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Affaires de l’Assemblée générale et du Conseil économique et social",
    Title: "Un meilleur accès aux modules e-deleGATE pour les organes subsidiaires",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=12"
  },
  {
    ID: 53,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Planification et coordination des services de conférence",
    Title: "Un plus grand nombre de réunions tenues ailleurs qu’au Siège ayant reçu des services",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CA,CR,ET,FR,DE,MA,PA,QA,SA,ES,EI,TH,TM,UY",
    Image: "2DGACM5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=14"
  },
  {
    ID: 54,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Planification et coordination des services de conférence",
    Title: "Portail mondial pour le service des conférences et des réunions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=15"
  },
  {
    ID: 55,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Planification et coordination des services de conférence",
    Title: "Augmentation du nombre de réponses données par les États Membres dans le cadre de l’enquête mondiale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=16"
  },
  {
    ID: 56,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Planification et coordination des services de conférence",
    Title: "Des opérations résilientes grâce à des formations interdisciplinaires dans les services de conférence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=16"
  },
  {
    ID: 57,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Services de documentation",
    Title: "Des documents qui ont continué d’être publiés en temps voulu malgré les contraintes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=21"
  },
  {
    ID: 58,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Services de documentation",
    Title: "Documentation multilingue de qualité grâce à un cadre de gestion de la qualité de la traduction",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=22"
  },
  {
    ID: 59,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Services de documentation",
    Title: "Disponibilité en temps voulu de la documentation destinée aux réunions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=22"
  },
  {
    ID: 60,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Services de documentation",
    Title: "Respect de l’égalité de traitement des langues officielles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=23"
  },
  {
    ID: 61,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Services d’appui aux réunions et de publication",
    Title: "Maintien de la qualité et gains d’efficience pour les organisateurs de réunions grâce à la gestion intégrée à l’échelle mondiale des ressources d’interprétation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=27"
  },
  {
    ID: 62,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Services d’appui aux réunions et de publication",
    Title: "Augmentation du nombre de services d’interprétation fournis pour faire face à la demande croissante des États Membres",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=28"
  },
  {
    ID: 63,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Services d’appui aux réunions et de publication",
    Title: "Des documents et des publications améliorés mis à la disposition des États Membres et du public",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=29"
  },
  {
    ID: 64,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Département de l'Assemblée générale et de la gestion des conférences",
    Programme: "Affaires de l’Assemblée générale et du Conseil économique et social et gestion des conférences",
    Subprogramme: "Services d’appui aux réunions et de publication",
    Title: "Maintien de la couverture des réunions grâce à des technologies de planification des capacités d’interprétation internes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.2)&l=fr#page=30"
  },
  {
    ID: 65,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Prévention, maîtrise et règlement des conflits",
    Title: "Les États Membres et d’autres parties prenantes contribuent à l’étude sur l’avenir de toutes les formes d’opérations de paix des Nations Unies",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=14"
  },
  {
    ID: 66,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Prévention, maîtrise et règlement des conflits",
    Title: "Réduction des menaces contre la paix et la sécurité internationales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,LY,MZ,SD,QQ",
    Image: "3DPPA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=15"
  },
  {
    ID: 67,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Prévention, maîtrise et règlement des conflits",
    Title: "Les organisations régionales et sous-régionales ont accès à un soutien en matière de médiation, de diplomatie préventive et de bons offices",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=16"
  },
  {
    ID: 68,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Prévention, maîtrise et règlement des conflits",
    Title: "Les États Membres ont un meilleur accès à un soutien rapide en matière de médiation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=16"
  },
  {
    ID: 69,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Assistance électorale",
    Title: "Renforcer le leadership des femmes et leur participation aux processus électoraux et politiques",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Femmes et filles",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=19"
  },
  {
    ID: 70,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Assistance électorale",
    Title: "Renforcement de la représentation des femmes dans les processus électoraux et politiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Femmes et filles",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=20"
  },
  {
    ID: 71,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Assistance électorale",
    Title: "Renforcement des capacités des États Membres bénéficiant d’une assistance électorale de l’ONU grâce à des initiatives menées conjointement avec des organisations régionales et sous-régionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=21"
  },
  {
    ID: 72,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Assistance électorale",
    Title: "Réponse rapide et efficace aux demandes d’assistance électorale des États Membres",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=22"
  },
  {
    ID: 73,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Affaires du Conseil de sécurité",
    Title: "Amélioration des méthodes de travail du Conseil de sécurité grâce à une prise en compte plus rapide des commentaires des membres",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=24"
  },
  {
    ID: 74,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Affaires du Conseil de sécurité",
    Title: "Renforcement de la participation des États Membres aux travaux du Conseil de sécurité",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=25"
  },
  {
    ID: 75,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Affaires du Conseil de sécurité",
    Title: "Les États Membres et le public ont plus facilement accès à des informations analytiques récentes et actualisées sur la pratique et les travaux du Conseil de sécurité",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=26"
  },
  {
    ID: 76,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Affaires du Conseil de sécurité",
    Title: "Les membres du Conseil de sécurité reçoivent en temps utile des informations sur l’application des sanctions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=27"
  },
  {
    ID: 77,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Décolonisation",
    Title: "Renforcement de la prise de conscience du public concernant la décolonisation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=30"
  },
  {
    ID: 78,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Décolonisation",
    Title: "Le Comité spécial dispose d’une liste à jour d’experts qualifiés dans le domaine de la décolonisation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=30"
  },
  {
    ID: 79,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Décolonisation",
    Title: "Diffusion plus large d’informations sur la décolonisation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=31"
  },
  {
    ID: 80,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Décolonisation",
    Title: "Le Comité spécial dispose de davantage d’informations sur l’aide apportée aux territoires non autonomes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=31"
  },
  {
    ID: 81,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Question de Palestine",
    Title: "Renforcement de la mobilisation et du soutien des États Membres à l’égard du Comité",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=34"
  },
  {
    ID: 82,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Question de Palestine",
    Title: "Renforcement de l’action du Comité visant à sensibiliser le public à la question de Palestine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=35"
  },
  {
    ID: 83,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Question de Palestine",
    Title: "Amélioration des réunions d’information du Comité et des échanges avec le Conseil de sécurité",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=35"
  },
  {
    ID: 84,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Question de Palestine",
    Title: "Renforcement de la démarche de sensibilisation et de la mobilisation du public par le Comité sur la question de Palestine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=36"
  },
  {
    ID: 85,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de la consolidation de la paix et de l’appui à la paix",
    Title: "Les États Membres ont renforcé leurs stratégies et approches nationales en matière de prévention et de consolidation de la paix",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "TD,MR,PG",
    Image: "3DPPA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=39"
  },
  {
    ID: 86,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de la consolidation de la paix et de l’appui à la paix",
    Title: "Attention accrue portée aux phases de transition des missions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=40"
  },
  {
    ID: 87,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de la consolidation de la paix et de l’appui à la paix",
    Title: "Renforcement des partenariats noués avec les institutions financières internationales pour la mise en place de stratégies de prévention et de consolidation de la paix pilotées par les pays",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=41"
  },
  {
    ID: 88,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de la consolidation de la paix et de l’appui à la paix",
    Title: "Augmentation des investissements dans les initiatives du Fonds pour la consolidation de la paix qui ont un effet mobilisateur",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=42"
  },
  {
    ID: 89,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Coopération entre l’Organisation des Nations Unies et la Ligue des États arabes",
    Title: "Renforcement de la coopération entre la Ligue des États arabes et l’Organisation des Nations Unies en matière de droits des femmes et de protection des enfants en période de conflit armé",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=45"
  },
  {
    ID: 90,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Coopération entre l’Organisation des Nations Unies et la Ligue des États arabes",
    Title: "Progrès réalisés par la Ligue des États arabes en matière de diplomatie préventive, de médiation et d’analyse",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=46"
  },
  {
    ID: 91,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Coopération entre l’Organisation des Nations Unies et la Ligue des États arabes",
    Title: "Amélioration de la communication avec le Secrétariat général et les États membres de la Ligue des États arabes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=46"
  },
  {
    ID: 92,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Département des affaires politiques et de la consolidation de la paix",
    Programme: "Affaires politiques",
    Subprogramme: "Coopération entre l’Organisation des Nations Unies et la Ligue des États arabes",
    Title: "Renforcement du partenariat entre l’ONU et la Ligue des États arabes en vue de faire progresser la prévention des conflits et la pérennisation de la paix dans la région arabe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=48"
  },
  {
    ID: 93,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "Bureau de la Coordonnatrice spéciale des Nations Unies pour le processus de paix au Moyen-Orient",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de la Coordonnatrice spéciale des Nations Unies pour le processus de paix au Moyen-Orient",
    Title: "Bande de Gaza : planification du relèvement fondée sur des données probantes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=72"
  },
  {
    ID: 94,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "Bureau de la Coordonnatrice spéciale des Nations Unies pour le processus de paix au Moyen-Orient",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de la Coordonnatrice spéciale des Nations Unies pour le processus de paix au Moyen-Orient",
    Title: "Progrès en vue de l’établissement d’un gouvernement palestinien unique administrant l’ensemble du Territoire palestinien occupé, dans le cadre d’une solution négociée à deux États",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=73"
  },
  {
    ID: 95,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "Bureau de la Coordonnatrice spéciale des Nations Unies pour le processus de paix au Moyen-Orient",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de la Coordonnatrice spéciale des Nations Unies pour le processus de paix au Moyen-Orient",
    Title: "Vers un cadre politique permettant de régler le conflit israélo-palestinien",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "PS",
    Image: "3DPPA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=74"
  },
  {
    ID: 96,
    BudgetSection: 3,
    Entity: "UNSCO",
    EntityFullName: "Bureau de la Coordonnatrice spéciale des Nations Unies pour le processus de paix au Moyen-Orient",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de la Coordonnatrice spéciale des Nations Unies pour le processus de paix au Moyen-Orient",
    Title: "Progrès en vue de l’application du Plan d’ensemble visant à mettre fin au conflit à Gaza approuvé par le Conseil de sécurité dans sa résolution 2803 (2025)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=75"
  },
  {
    ID: 97,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "Registre de l’Organisation des Nations Unies concernant les dommages causés par la construction du mur dans le Territoire palestinien occupé",
    Programme: "Affaires politiques",
    Subprogramme: "Registre de l’Organisation des Nations Unies concernant les dommages causés par la construction du mur dans le Territoire palestinien occupé",
    Title: "Optimisation du processus d’examen des demandes d’enregistrement de dommages en vue d’en accélérer le traitement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=84"
  },
  {
    ID: 98,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "Registre de l’Organisation des Nations Unies concernant les dommages causés par la construction du mur dans le Territoire palestinien occupé",
    Programme: "Affaires politiques",
    Subprogramme: "Registre de l’Organisation des Nations Unies concernant les dommages causés par la construction du mur dans le Territoire palestinien occupé",
    Title: "Réduction du nombre de demandes non traitées",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=85"
  },
  {
    ID: 99,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "Registre de l’Organisation des Nations Unies concernant les dommages causés par la construction du mur dans le Territoire palestinien occupé",
    Programme: "Affaires politiques",
    Subprogramme: "Registre de l’Organisation des Nations Unies concernant les dommages causés par la construction du mur dans le Territoire palestinien occupé",
    Title: "Amélioration de la procédure de rectification des demandes collectées non conformes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "PS",
    Image: "3DPPA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=86"
  },
  {
    ID: 100,
    BudgetSection: 3,
    Entity: "UNRoD",
    EntityFullName: "Registre de l’Organisation des Nations Unies concernant les dommages causés par la construction du mur dans le Territoire palestinien occupé",
    Programme: "Affaires politiques",
    Subprogramme: "Registre de l’Organisation des Nations Unies concernant les dommages causés par la construction du mur dans le Territoire palestinien occupé",
    Title: "Renforcement de la prise de décision par le Conseil du Bureau grâce à l’harmonisation de la procédure de présentation des demandes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=87"
  },
  {
    ID: 101,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "Bureau des Nations Unies auprès de l’Union africaine",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau des Nations Unies auprès de l’Union africaine",
    Title: "Transition en matière de sécurité en Somalie et renforcement des capacités d’appui à la paix de l’Union africaine",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "3DPPA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=96"
  },
  {
    ID: 102,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "Bureau des Nations Unies auprès de l’Union africaine",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau des Nations Unies auprès de l’Union africaine",
    Title: "Participation accrue des jeunes aux initiatives menées en faveur de la paix et de la sécurité en Afrique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=97"
  },
  {
    ID: 103,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "Bureau des Nations Unies auprès de l’Union africaine",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau des Nations Unies auprès de l’Union africaine",
    Title: "Renforcement de l’action menée conjointement par l’ONU et l’Union africaine pour prévenir les conflits et les régler par la médiation, maintenir la paix et remédier aux causes profondes des conflits",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=98"
  },
  {
    ID: 104,
    BudgetSection: 3,
    Entity: "UNOAU",
    EntityFullName: "Bureau des Nations Unies auprès de l’Union africaine",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau des Nations Unies auprès de l’Union africaine",
    Title: "Renforcement de la participation effective des femmes, de leur leadership et de leur influence dans les processus de paix et de sécurité en Afrique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=98"
  },
  {
    ID: 105,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "Bureau de lutte contre le terrorisme",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de lutte contre le terrorisme",
    Title: "Réseau mondial permettant aux victimes du terrorisme de défendre leurs droits, de contribuer à l’élaboration des politiques et de bénéficier d’une assistance",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=113"
  },
  {
    ID: 106,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "Bureau de lutte contre le terrorisme",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de lutte contre le terrorisme",
    Title: "Les États Membres intensifient leurs efforts de lutte contre l’utilisation d’armes à des fins terroristes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=114"
  },
  {
    ID: 107,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "Bureau de lutte contre le terrorisme",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de lutte contre le terrorisme",
    Title: "Amélioration des capacités nationales de lutte antiterroriste grâce au renforcement de la coordination interorganisations et des compétences des analystes de renseignements en matière de prévention et de lutte contre le terrorisme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=115"
  },
  {
    ID: 108,
    BudgetSection: 3,
    Entity: "OCT",
    EntityFullName: "Bureau de lutte contre le terrorisme",
    Programme: "Affaires politiques",
    Subprogramme: "Bureau de lutte contre le terrorisme",
    Title: "Renforcement des capacités nationales de lutte contre l’utilisation de systèmes de drones aériens à des fins terroristes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.3)&l=fr#page=115"
  },
  {
    ID: 109,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Négociations et délibérations multilatérales sur le désarmement et la limitation des armements",
    Title: "Augmentation du nombre de rapports établis chaque année par les Hautes Parties contractantes à la Convention sur l’interdiction ou la limitation de l’emploi de certaines armes classiques qui peuvent être considérées comme produisant des effets traumatiques excessifs ou comme frappant sans discrimination",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=9"
  },
  {
    ID: 110,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Négociations et délibérations multilatérales sur le désarmement et la limitation des armements",
    Title: "Intensification des délibérations et, à terme, des négociations dans le cadre de la Conférence du désarmement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=10"
  },
  {
    ID: 111,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Négociations et délibérations multilatérales sur le désarmement et la limitation des armements",
    Title: "Prévention d’une course aux armements dans l’espace",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=10"
  },
  {
    ID: 112,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Négociations et délibérations multilatérales sur le désarmement et la limitation des armements",
    Title: "Aborder la question des technologies émergentes dans le domaine des systèmes d’armes létaux autonomes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=11"
  },
  {
    ID: 113,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Armes de destruction massive",
    Title: "Les États Membres de la région Asie-Pacifique recensent les synergies possibles dans l’action qu’ils mènent au titre des instruments visant à répondre à la menace que représente la prolifération ou l’utilisation d’armes biologiques",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "États Membres d’Amérique latine et des Caraïbes",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "4ODA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=16"
  },
  {
    ID: 114,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Armes de destruction massive",
    Title: "Processus visant à parvenir à la création au Moyen-Orient d’une zone exempte d’armes nucléaires et d’autres armes de destruction massive",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,DJ,EG,QG,IR,IQ,JO,KW,LB,LY,MA,OM,QA,SA,SY,TN,AE,PS,YE",
    Image: "4ODA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=16"
  },
  {
    ID: 115,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Armes de destruction massive",
    Title: "Renforcement de l’état de préparation du Mécanisme permettant au Secrétaire général d’enquêter sur les allégations d’emploi d’armes chimiques et biologiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=18"
  },
  {
    ID: 116,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Armes de destruction massive",
    Title: "Le Groupe d’experts scientifiques et techniques de la vérification du désarmement nucléaire contribue à une meilleure compréhension des difficultés techniques et des approches possibles en matière de vérification du désarmement nucléaire",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=18"
  },
  {
    ID: 117,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Armes classiques",
    Title: "Meilleure compréhension de l’impact de l’augmentation globale des dépenses militaires sur la réalisation des objectifs de développement durable, ainsi que propositions visant à l’atténuer",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=24"
  },
  {
    ID: 118,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Armes classiques",
    Title: "Recours accru au mécanisme mondial d’assistance à la gestion des munitions tout au long de leur cycle de vie",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=24"
  },
  {
    ID: 119,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Armes classiques",
    Title: "Prise en compte des progrès réalisés dans la fabrication, la technologie et la conception des armes légères et de petit calibre pour prévenir, combattre et éliminer leur commerce illicite et leur détournement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=25"
  },
  {
    ID: 120,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Armes classiques",
    Title: "Les compétences requises pour faire progresser la mise en œuvre du Programme d’action relatif aux armes légères et de son Instrument international de traçage sont renforcées",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=26"
  },
  {
    ID: 121,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Désarmement régional, renforcement des capacités et sensibilisation",
    Title: "Renforcement des compétences nationales en matière de désarmement pour ce qui est de faire progresser l’action menée dans ce domaine",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SR,ZM",
    Image: "4ODA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=30"
  },
  {
    ID: 122,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Désarmement régional, renforcement des capacités et sensibilisation",
    Title: "Mécanisme mondial relatif aux progrès de l’informatique et des communications dans le contexte de la sécurité internationale et à la promotion du comportement responsable des États dans ce domaine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=31"
  },
  {
    ID: 123,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Négociations et délibérations multilatérales sur le désarmement et la limitation des armements",
    Title: "Renforcement des connaissances techniques en matière de désarmement dans le cadre du Programme de bourses d’études, de formation et de services consultatifs des Nations Unies en matière de désarmement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=35"
  },
  {
    ID: 124,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Information et sensibilisation",
    Title: "Renforcement des moyens d’action des jeunes en matière de désarmement et de non-prolifération",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=35"
  },
  {
    ID: 125,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Information et sensibilisation",
    Title: "Sensibilisation accrue aux questions de désarmement et de non-prolifération",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=36"
  },
  {
    ID: 126,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Désarmement régional",
    Title: "Sensibilisation au Cadre mondial pour la gestion des munitions classiques tout au long de leur cycle de vie et appui à la mise en œuvre de cet instrument aux niveaux régional, sous-régional et national",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=37"
  },
  {
    ID: 127,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Bureau des affaires de désarmement",
    Programme: "Désarmement",
    Subprogramme: "Désarmement régional",
    Title: "Intégration accrue du désarmement dans les cadres nationaux de développement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Disarmament",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion des mesures et initiatives de désarmement, de non-prolifération et de maîtrise des armements",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=fr#page=37"
  },
  {
    ID: 128,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Opérations",
    Title: "Progrès enregistrés dans l’application de l’Accord politique pour la paix et la réconciliation en République centrafricaine conclu en 2019",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF",
    Image: "5DPO1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=8"
  },
  {
    ID: 129,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Opérations",
    Title: "Progrès enregistrés dans l’application de l’Accord revitalisé sur le règlement du conflit en République du Soudan du Sud conclu en 2018",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SS,II",
    Image: "5DPO2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=9"
  },
  {
    ID: 130,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Opérations",
    Title: "Renforcement de la consolidation de la paix à Abyei grâce au Programme conjoint des Coordonnatrices résidentes au Soudan et au Soudan du Sud pour Abyei",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SS,II,SD,QQ",
    Image: "5DPO3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=10"
  },
  {
    ID: 131,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Opérations",
    Title: "Amélioration des processus de désarmement, de démobilisation, de réintégration et de réinstallation ou de rapatriement des combattants étrangers dans l’est de la République démocratique du Congo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD",
    Image: "5DPO4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=11"
  },
  {
    ID: 132,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Questions militaires",
    Title: "Renforcement de la préparation à la transition et au retrait des missions de maintien de la paix des Nations Unies",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration des résultats, de la sûreté et de la sécurité des missions de maintien de la paix, y compris pour ce qui est des transitions sans heurt après l’adoption de résolutions par le Conseil de sécurité",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CY,LB,SS,II,SD,QQ",
    Image: "5DPO5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=14"
  },
  {
    ID: 133,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Questions militaires",
    Title: "Les missions se dotent de capacités de neutralisation des explosifs et munitions pour faire face aux menaces que représentent les engins explosifs improvisés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration des résultats, de la sûreté et de la sécurité des missions de maintien de la paix, y compris pour ce qui est des transitions sans heurt après l’adoption de résolutions par le Conseil de sécurité",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LB",
    Image: "5DPO6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=14"
  },
  {
    ID: 134,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Questions militaires",
    Title: "Les opérations de paix font face aux menaces posées par les systèmes de drones hostiles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration des résultats, de la sûreté et de la sécurité des missions de maintien de la paix, y compris pour ce qui est des transitions sans heurt après l’adoption de résolutions par le Conseil de sécurité",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CD,ML",
    Image: "5DPO7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=15"
  },
  {
    ID: 135,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Questions militaires",
    Title: "Les opérations de paix renforcent le suivi et l’analyse de la mésinformation, de la désinformation et des discours de haine et luttent contre ceux-ci",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration des résultats, de la sûreté et de la sécurité des missions de maintien de la paix, y compris pour ce qui est des transitions sans heurt après l’adoption de résolutions par le Conseil de sécurité",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,LB,ML,SS,II",
    Image: "5DPO8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=16"
  },
  {
    ID: 136,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "État de droit et institutions chargées de la sécurité",
    Title: "Renforcement des capacités nationales et régionales pour ce qui est d’atténuer la menace que représentent les engins explosifs improvisés",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=19"
  },
  {
    ID: 137,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "État de droit et institutions chargées de la sécurité",
    Title: "Amélioration des performances de la police des Nations Unies aux fins d’une meilleure exécution des mandats",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=20"
  },
  {
    ID: 138,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "État de droit et institutions chargées de la sécurité",
    Title: "Les États hôtes sont en mesure de poursuivre et de maintenir les progrès en matière d’état de droit et de réforme des institutions chargées de la sécurité pendant et après la transition des missions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CF,CD,ML,SO",
    Image: "5DPO11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=21"
  },
  {
    ID: 139,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "État de droit et institutions chargées de la sécurité",
    Title: "Renforcement de l’application du principe de responsabilité pour les crimes commis contre des membres du personnel des Nations Unies servant dans des opérations de maintien de la paix",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF,CD,LB,ML",
    Image: "5DPO12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=22"
  },
  {
    ID: 140,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Politiques, évaluation et formation",
    Title: "Renforcement des politiques et des orientations relatives à la protection des civils dans le cadre des opérations de soutien à la paix menées par l’Union africaine",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "5DPO13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=27"
  },
  {
    ID: 141,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Politiques, évaluation et formation",
    Title: "Plateforme en ligne visant à favoriser la collaboration directe entre États Membres sur la préparation du personnel de maintien de la paix",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=28"
  },
  {
    ID: 142,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Politiques, évaluation et formation",
    Title: "Les capacités d’analyse et de planification des bureaux extérieurs s’améliorent, ce qui leur permet de faire face à la dynamique des conflits locaux et de promouvoir des solutions politiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=28"
  },
  {
    ID: 143,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Département des opérations de paix",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Politiques, évaluation et formation",
    Title: "Renforcement de la prévention et de la répression des violences sexuelles liées aux conflits dans les opérations de maintien de la paix",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réduction de la violence sexuelle, notamment du recours à celle-ci comme tactique de guerre et de terreur, et recul de la violence contre les enfants, y compris les violations graves commises contre des enfants en temps de conflit armé",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=29"
  },
  {
    ID: 144,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Organisme des Nations Unies chargé de la surveillance de la trêve",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Organisme des Nations Unies chargé de la surveillance de la trêve",
    Title: "Renforcement des activités d’observation le long de la ligne de cessez-le-feu et dans la zone de séparation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=50"
  },
  {
    ID: 145,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Organisme des Nations Unies chargé de la surveillance de la trêve",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Organisme des Nations Unies chargé de la surveillance de la trêve",
    Title: "Mobilisation accrue à l’appui du mandat et des travaux de l’Organisme des Nations Unies chargé de la surveillance de la trêve",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=51"
  },
  {
    ID: 146,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Organisme des Nations Unies chargé de la surveillance de la trêve",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Organisme des Nations Unies chargé de la surveillance de la trêve",
    Title: "L’Organisation est mieux à même de s’adapter à un environnement opérationnel évolutif",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des résultats, de la sûreté et de la sécurité des missions de maintien de la paix, y compris pour ce qui est des transitions sans heurt après l’adoption de résolutions par le Conseil de sécurité",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=52"
  },
  {
    ID: 147,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Organisme des Nations Unies chargé de la surveillance de la trêve",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Organisme des Nations Unies chargé de la surveillance de la trêve",
    Title: "Renforcement des mécanismes de planification et de coordination dans le sud du Liban",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des résultats, de la sûreté et de la sécurité des missions de maintien de la paix, y compris pour ce qui est des transitions sans heurt après l’adoption de résolutions par le Conseil de sécurité",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=52"
  },
  {
    ID: 148,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Groupe d’observateurs militaires des Nations Unies dans l’Inde et le Pakistan",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Groupe d’observateurs militaires des Nations Unies dans l’Inde et le Pakistan",
    Title: "Nombre de plaintes limité concernant des violations présumées du cessez-le-feu",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=60"
  },
  {
    ID: 149,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Groupe d’observateurs militaires des Nations Unies dans l’Inde et le Pakistan",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Groupe d’observateurs militaires des Nations Unies dans l’Inde et le Pakistan",
    Title: "Meilleure appréciation de la situation grâce à des systèmes d’information géospatiale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=61"
  },
  {
    ID: 150,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Groupe d’observateurs militaires des Nations Unies dans l’Inde et le Pakistan",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Groupe d’observateurs militaires des Nations Unies dans l’Inde et le Pakistan",
    Title: "Présence continue le long de la ligne de contrôle",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=62"
  },
  {
    ID: 151,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Groupe d’observateurs militaires des Nations Unies dans l’Inde et le Pakistan",
    Programme: "Opérations de maintien de la paix",
    Subprogramme: "Groupe d’observateurs militaires des Nations Unies dans l’Inde et le Pakistan",
    Title: "Renforcement de la compréhension mutuelle moyennant le renforcement de la liaison et de la collaboration",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=fr#page=62"
  },
  {
    ID: 152,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "Le Bureau des affaires spatiales",
    Programme: "Utilisations pacifiques de l’espace",
    Subprogramme: "Utilisations pacifiques de l’espace",
    Title: "Amélioration de la planification et de l’état de préparation face aux objets géocroiseurs potentiellement dangereux",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "6COPUOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=fr#page=5"
  },
  {
    ID: 153,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "Le Bureau des affaires spatiales",
    Programme: "Utilisations pacifiques de l’espace",
    Subprogramme: "Utilisations pacifiques de l’espace",
    Title: "Amélioration de l’accès à l’espace",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=fr#page=6"
  },
  {
    ID: 154,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "Le Bureau des affaires spatiales",
    Programme: "Utilisations pacifiques de l’espace",
    Subprogramme: "Utilisations pacifiques de l’espace",
    Title: "Amélioration de l’accès aux solutions spatiales, aux partenariats et au renforcement des capacités et renforcement de la participation à la gouvernance des activités spatiales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "PMA, PDSL, PEID et autres pays en développement",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=fr#page=7"
  },
  {
    ID: 155,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "Le Bureau des affaires spatiales",
    Programme: "Utilisations pacifiques de l’espace",
    Subprogramme: "Utilisations pacifiques de l’espace",
    Title: "Recours accru aux technologies et données spatiales dans la gestion des catastrophes et les interventions d’urgence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Maintien de la paix et de la sécurité internationales",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=fr#page=7"
  },
  {
    ID: 156,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Cour internationale de Justice",
    Programme: "Cour internationale de Justice",
    Subprogramme: "Greffe",
    Title: "Les activités de la Cour sont mieux connues du public",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=fr#page=4"
  },
  {
    ID: 157,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Cour internationale de Justice",
    Programme: "Cour internationale de Justice",
    Subprogramme: "Greffe",
    Title: "Améliorer la transmission et la réception des documents relatifs aux procédures judiciaires",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=fr#page=5"
  },
  {
    ID: 158,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Cour internationale de Justice",
    Programme: "Cour internationale de Justice",
    Subprogramme: "Greffe",
    Title: "Diffuser sur les médias sociaux davantage d’informations concernant la Cour",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=fr#page=5"
  },
  {
    ID: 159,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Cour internationale de Justice",
    Programme: "Cour internationale de Justice",
    Subprogramme: "Greffe",
    Title: "Plus grande publicité donnée aux activités de la Cour, qui sont mieux connues des jeunes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=fr#page=6"
  },
  {
    ID: 160,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Services juridiques fournis à l’ensemble du système des Nations Unies",
    Title: "Cadres juridiques pour la mise en place d’une nouvelle opération des Nations Unies en Haïti et l’appui à la Force multinationale de répression des gangs en Haïti",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Adoption de cadres juridiques et réglementaires plus adaptés ; réduction du risque de mise en cause de la responsabilité juridique",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "8OLA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=10"
  },
  {
    ID: 161,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Services juridiques fournis à l’ensemble du système des Nations Unies",
    Title: "Conclusion d’un accord sur la poursuite des fonctions résiduelles des Chambres extraordinaires au sein des tribunaux cambodgiens",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Adoption de cadres juridiques et réglementaires plus adaptés ; réduction du risque de mise en cause de la responsabilité juridique",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KH",
    Image: "8OLA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=11"
  },
  {
    ID: 162,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Services juridiques fournis à l’ensemble du système des Nations Unies",
    Title: "Un cadre juridique et procédural pour les conférences des Nations Unies, notamment la Conférence des Nations Unies sur l’eau de 2026 visant à accélérer la réalisation de l’objectif de développement durable no 6",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Adoption de cadres juridiques et réglementaires plus adaptés ; réduction du risque de mise en cause de la responsabilité juridique",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SN,AE",
    Image: "8OLA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=12"
  },
  {
    ID: 163,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Services juridiques fournis à l’ensemble du système des Nations Unies",
    Title: "Promotion des réformes et des transitions institutionnelles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Adoption de cadres juridiques et réglementaires plus adaptés ; réduction du risque de mise en cause de la responsabilité juridique",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=12"
  },
  {
    ID: 164,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Services juridiques généraux fournis aux organes et aux programmes des Nations Unies",
    Title: "Accès des bureaux clients aux contrats types",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Adoption de cadres juridiques et réglementaires plus adaptés ; réduction du risque de mise en cause de la responsabilité juridique",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=15"
  },
  {
    ID: 165,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Services juridiques généraux fournis aux organes et aux programmes des Nations Unies",
    Title: "Modernisation du système de gestion des dossiers, ce qui permet aux bureaux clients d’obtenir plus rapidement des avis juridiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Adoption de cadres juridiques et réglementaires plus adaptés ; réduction du risque de mise en cause de la responsabilité juridique",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=16"
  },
  {
    ID: 166,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Services juridiques généraux fournis aux organes et aux programmes des Nations Unies",
    Title: "Les bureaux clients ont accès à une version actualisée des Conditions générales figurant dans les contrats de l’ONU",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Adoption de cadres juridiques et réglementaires plus adaptés ; réduction du risque de mise en cause de la responsabilité juridique",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=16"
  },
  {
    ID: 167,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Services juridiques généraux fournis aux organes et aux programmes des Nations Unies",
    Title: "Les bureaux clients ont accès à un contrat type actualisé concernant la fourniture de services de fret aérien",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Adoption de cadres juridiques et réglementaires plus adaptés ; réduction du risque de mise en cause de la responsabilité juridique",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=17"
  },
  {
    ID: 168,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Développement progressif et codification du droit international",
    Title: "Adoption d’un rapport de fond par le Comité spécial de la Charte des Nations Unies et du raffermissement du rôle de l’Organisation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=19"
  },
  {
    ID: 169,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Développement progressif et codification du droit international",
    Title: "Les candidatures aux programmes de formation en droit international dispensés dans le cadre du programme d’assistance proviennent d’un plus grand nombre d’États",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=19"
  },
  {
    ID: 170,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Développement progressif et codification du droit international",
    Title: "Renforcement de l’accès de la communauté internationale des juristes aux documents à caractère juridique concernant l’Organisation des Nations Unies et les organisations intergouvernementales apparentées présentés dans l’Annuaire juridique des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=20"
  },
  {
    ID: 171,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Développement progressif et codification du droit international",
    Title: "Meilleure compréhension des questions juridiques relatives au règlement des différends auxquels des organisations internationales sont parties",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=21"
  },
  {
    ID: 172,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Droit de la mer et affaires maritimes",
    Title: "Conditions requises pour l’entrée en vigueur de l’Accord sur la diversité biologique marine des zones ne relevant pas de la juridiction nationale remplies",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=23"
  },
  {
    ID: 173,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Droit de la mer et affaires maritimes",
    Title: "Renforcement de la détermination des États Membres à assurer la conservation et l’utilisation durable de l’océan et de ses ressources par l’application du droit international",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=24"
  },
  {
    ID: 174,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Droit de la mer et affaires maritimes",
    Title: "Renforcement des liens entre scientifiques et décideurs pour la protection du milieu marin et la conservation et l’exploitation durable des ressources marines",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=25"
  },
  {
    ID: 175,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Droit de la mer et affaires maritimes",
    Title: "Renforcement du rôle de la Commission des limites du plateau continental et de ses sous-commissions conformément à la Convention des Nations Unies sur le droit de la mer",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=26"
  },
  {
    ID: 176,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Harmonisation, modernisation et unification progressives du droit commercial international",
    Title: "Renforcement des capacités judiciaires en matière d’application des directives fournies dans les textes de la Commission des Nations Unies pour le droit commercial international relatifs au droit de l’insolvabilité",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=30"
  },
  {
    ID: 177,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Harmonisation, modernisation et unification progressives du droit commercial international",
    Title: "Une sécurité juridique renforcée pour les transactions portant sur des données commerciales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=31"
  },
  {
    ID: 178,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Harmonisation, modernisation et unification progressives du droit commercial international",
    Title: "La Commission des Nations Unies pour le droit commercial international examine la question de la pertinence de ses instruments concernant le cadre régissant les marchés publics",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=32"
  },
  {
    ID: 179,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Harmonisation, modernisation et unification progressives du droit commercial international",
    Title: "Mise en œuvre des réformes relatives au règlement des différends entre investisseurs et États dans le cadre d’un mécanisme de convention-cadre multilatérale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=32"
  },
  {
    ID: 180,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Garde, enregistrement et publication des traités",
    Title: "Ouverture à la signature de la Convention des Nations Unies contre la cybercriminalité ; Renforcement de la coopération internationale pour la lutte contre certaines infractions commises au moyen de systèmes d’information et de communication et pour la communication de preuves sous forme électronique d’infractions graves",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=35"
  },
  {
    ID: 181,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Garde, enregistrement et publication des traités",
    Title: "Les États Membres font avancer le débat sur la pratique conventionnelle",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=36"
  },
  {
    ID: 182,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Garde, enregistrement et publication des traités",
    Title: "Les traités et les formalités conventionnelles sont publiés au Recueil des Traités des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=37"
  },
  {
    ID: 183,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Bureau des affaires juridiques",
    Programme: "Affaires juridiques",
    Subprogramme: "Garde, enregistrement et publication des traités",
    Title: "Les États Membres examinent le rôle de la coopération internationale, y compris celle menée dans le cadre de l’emploi de technologies ou du renforcement des capacités, dans le renforcement du régime conventionnel international",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=37"
  },
  {
    ID: 184,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Mécanisme d’enquête indépendant pour le Myanmar",
    Programme: "Affaires juridiques",
    Subprogramme: "Mécanisme d’enquête indépendant pour le Myanmar",
    Title: "Les autorités compétentes ont accès à l’analyse scientifique des informations provenant de sources ouvertes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=64"
  },
  {
    ID: 185,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Mécanisme d’enquête indépendant pour le Myanmar",
    Programme: "Affaires juridiques",
    Subprogramme: "Mécanisme d’enquête indépendant pour le Myanmar",
    Title: "Les victimes, les personnes rescapées, la société civile et les sources d’informations participent aux procédures visant à amener les criminels à répondre de leurs actes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=65"
  },
  {
    ID: 186,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Mécanisme d’enquête indépendant pour le Myanmar",
    Programme: "Affaires juridiques",
    Subprogramme: "Mécanisme d’enquête indépendant pour le Myanmar",
    Title: "Accès accru à des éléments de preuve qui soient le plus recevables possible devant les tribunaux nationaux, régionaux et internationaux",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=66"
  },
  {
    ID: 187,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Mécanisme d’enquête indépendant pour le Myanmar",
    Programme: "Affaires juridiques",
    Subprogramme: "Mécanisme d’enquête indépendant pour le Myanmar",
    Title: "Les témoins et les sources contribuent en toute sécurité aux efforts visant à amener les criminels à répondre de leurs actes et bénéficient du soutien psychosocial nécessaire",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=66"
  },
  {
    ID: 188,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Mécanisme international, impartial et indépendant chargé de faciliter les enquêtes sur les violations les plus graves du droit international commises en République arabe syrienne depuis mars 2011 et d’aider à juger les personnes qui en sont responsables",
    Programme: "Affaires juridiques",
    Subprogramme: "Mécanisme international, impartial et indépendant chargé de faciliter les enquêtes sur les violations les plus graves du droit international commises en République arabe syrienne depuis mars 2011 et d’aider à juger les personnes qui en sont responsables",
    Title: "Mesures en faveur d’une justice transitionnelle dirigée par les Syriens",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=77"
  },
  {
    ID: 189,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Mécanisme international, impartial et indépendant chargé de faciliter les enquêtes sur les violations les plus graves du droit international commises en République arabe syrienne depuis mars 2011 et d’aider à juger les personnes qui en sont responsables",
    Programme: "Affaires juridiques",
    Subprogramme: "Mécanisme international, impartial et indépendant chargé de faciliter les enquêtes sur les violations les plus graves du droit international commises en République arabe syrienne depuis mars 2011 et d’aider à juger les personnes qui en sont responsables",
    Title: "Renforcement de la protection et de l’accompagnement des victimes, des témoins ou d’autres sources coopérant avec le Mécanisme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SY",
    Image: "8OLA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=78"
  },
  {
    ID: 190,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Mécanisme international, impartial et indépendant chargé de faciliter les enquêtes sur les violations les plus graves du droit international commises en République arabe syrienne depuis mars 2011 et d’aider à juger les personnes qui en sont responsables",
    Programme: "Affaires juridiques",
    Subprogramme: "Mécanisme international, impartial et indépendant chargé de faciliter les enquêtes sur les violations les plus graves du droit international commises en République arabe syrienne depuis mars 2011 et d’aider à juger les personnes qui en sont responsables",
    Title: "Une approche intégrée pour une justice inclusive",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SY",
    Image: "8OLA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=78"
  },
  {
    ID: 191,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Mécanisme international, impartial et indépendant chargé de faciliter les enquêtes sur les violations les plus graves du droit international commises en République arabe syrienne depuis mars 2011 et d’aider à juger les personnes qui en sont responsables",
    Programme: "Affaires juridiques",
    Subprogramme: "Mécanisme international, impartial et indépendant chargé de faciliter les enquêtes sur les violations les plus graves du droit international commises en République arabe syrienne depuis mars 2011 et d’aider à juger les personnes qui en sont responsables",
    Title: "Une démarche de recherche de la vérité et de la justice et d’établissement des responsabilités dirigée et prise en main par les Syriens pour les violations les plus graves du droit international commises en République arabe syrienne depuis 2011",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion de la justice et du droit international",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=fr#page=79"
  },
  {
    ID: 192,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Appui aux mécanismes intergouvernementaux et coordination au service du développement durable",
    Title: "Renouvellement des engagements politiques en faveur du Programme de développement durable à l’horizon 2030 à l’occasion du dixième anniversaire de celui-ci",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=19"
  },
  {
    ID: 193,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Appui aux mécanismes intergouvernementaux et coordination au service du développement durable",
    Title: "Renforcement du rôle du Conseil économique et social pour ce qui est d’aider les États Membres à traduire en actes et en politiques nationales les engagements pris lors du Sommet sur les objectifs de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=19"
  },
  {
    ID: 194,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Appui aux mécanismes intergouvernementaux et coordination au service du développement durable",
    Title: "Accélération de la réalisation des objectifs de développement durable grâce à une préparation efficace des examens nationaux volontaires",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=19"
  },
  {
    ID: 195,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Appui aux mécanismes intergouvernementaux et coordination au service du développement durable",
    Title: "Renforcement des orientations données au système des Nations Unies pour le développement par le Conseil économique et social en vue d’améliorer l’exécution des activités opérationnelles de développement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=19"
  },
  {
    ID: 196,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Développement social inclusif",
    Title: "Politiques sociales : un dialogue au sein des instances intergouvernementales alimenté par le World Social Report 2025",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=25"
  },
  {
    ID: 197,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Développement social inclusif",
    Title: "Amélioration de la cohérence de l’action menée par le système des Nations Unies pour répondre aux besoins des peuples autochtones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=25"
  },
  {
    ID: 198,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Développement social inclusif",
    Title: "Accélération du développement social dans le cadre du deuxième Sommet mondial pour le développement social",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=27"
  },
  {
    ID: 199,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Développement social inclusif",
    Title: "Amélioration de la qualité de la vie des personnes âgées grâce au cinquième cycle d’examen et d’évaluation de l’application du Plan d’action international de Madrid sur le vieillissement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=27"
  },
  {
    ID: 200,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Développement durable",
    Title: "Lancement du plan de concrétisation de la Décennie des Nations Unies pour les transports durables (2026-2035)",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=30"
  },
  {
    ID: 201,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Développement durable",
    Title: "Accélération des progrès réalisés en vue d’atteindre l’objectif de développement durable no 14 grâce à la troisième Conférence des Nations Unies sur l’océan",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=31"
  },
  {
    ID: 202,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Développement durable",
    Title: "Accélération de la réalisation de l’objectif de développement durable no 6 grâce à la Conférence des Nations Unies sur l’eau de 2026",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=32"
  },
  {
    ID: 203,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Développement durable",
    Title: "Le Rapport mondial sur le développement durable 2027, guide pour la réalisation du Programme 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=32"
  },
  {
    ID: 204,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Statistiques",
    Title: "Amélioration de la compréhension des statistiques migratoires par les utilisateurs",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=36"
  },
  {
    ID: 205,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Statistiques",
    Title: "Modernisation d’UNdata",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=37"
  },
  {
    ID: 206,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Statistiques",
    Title: "Amélioration de la capacité mondiale à assurer le suivi des progrès accomplis dans la réalisation des objectifs de développement durable sur la base de données d’observation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=38"
  },
  {
    ID: 207,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Statistiques",
    Title: "Mise en œuvre du Système de comptabilité nationale 2025 par les États Membres",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=38"
  },
  {
    ID: 208,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Population",
    Title: "Projections démographiques nationales et régionales établies à l’aide de méthodes probabilistes reconnues au niveau international",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UG",
    Image: "9DESA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=43"
  },
  {
    ID: 209,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Population",
    Title: "Meilleure comparabilité des estimations et des projections de l’urbanisation et de la répartition spatiale pour les objectifs de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=43"
  },
  {
    ID: 210,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Population",
    Title: "Amélioration des outils en ligne pour l’analyse, la projection et la visualisation démographiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=45"
  },
  {
    ID: 211,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Population",
    Title: "Base de données factuelles sur les migrations internationales renforcée pour favoriser l’élaboration des politiques et promouvoir un discours public éclairé",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=45"
  },
  {
    ID: 212,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Politiques et analyse économiques",
    Title: "Meilleurs outils numériques permettant de renforcer les connaissances des responsables gouvernementaux en matière de macroéconomie et de commerce",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=48"
  },
  {
    ID: 213,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Politiques et analyse économiques",
    Title: "Utilisation d’outils de simulation politique avancés aux fins de l’élaboration de politiques fondées sur des données et des éléments probants",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=49"
  },
  {
    ID: 214,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Politiques et analyse économiques",
    Title: "Augmentation de la participation et de l’utilisation de produits analytiques pour l’élaboration de politiques fondées sur des données probantes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=49"
  },
  {
    ID: 215,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Politiques et analyse économiques",
    Title: "Les pays les moins avancés sont préparés à gérer au mieux leur reclassement et la période suivant le reclassement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "9DESA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=49"
  },
  {
    ID: 216,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Institutions et transformation numérique",
    Title: "Les institutions supérieures de contrôle ont évalué la réalisation de l’objectif de développement durable no 13 relatif à l’action climatique",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=55"
  },
  {
    ID: 217,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Institutions et transformation numérique",
    Title: "Application au niveau national des principes de gouvernance efficace au service du développement durable aux fins d’une confiance renforcée dans les institutions publiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=56"
  },
  {
    ID: 218,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Institutions et transformation numérique",
    Title: "Réponse efficace et résiliente visant à faire face aux difficultés futures et à tirer parti des possibilités qui s’offriront pour accélérer le développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=57"
  },
  {
    ID: 219,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Institutions et transformation numérique",
    Title: "Les agents publics appliquent les analyses comportementales et adoptent de bonnes pratiques pour favoriser l’innovation et la transformation numérique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=57"
  },
  {
    ID: 220,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Gestion durable des forêts",
    Title: "Les États Membres commencent à mettre en œuvre le nouveau programme de travail quadriennal (2025-2028) visant à accélérer l’exécution du Plan stratégique des Nations Unies sur les forêts",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=61"
  },
  {
    ID: 221,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Gestion durable des forêts",
    Title: "Portée accrue du Forum des Nations Unies sur les forêts et contribution renforcée des forêts à la réalisation du Programme 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=62"
  },
  {
    ID: 222,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Gestion durable des forêts",
    Title: "Réalisation des objectifs de développement durable grâce au Plan stratégique des Nations Unies sur les forêts (2017-2030)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=63"
  },
  {
    ID: 223,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Gestion durable des forêts",
    Title: "Renforcement des mesures et des engagements pris par l’Arrangement international sur les forêts pour atteindre les Objectifs mondiaux relatifs aux forêts",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=63"
  },
  {
    ID: 224,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Financement du développement durable",
    Title: "Un nouveau cadre de financement, l’Engagement de Séville, adopté comme suite au Programme d’action d’Addis-Abeba",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=66"
  },
  {
    ID: 225,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Financement du développement durable",
    Title: "Participation accrue des États Membres au suivi du financement du développement aux fins d’une plus grande cohérence et d’une meilleure mise en œuvre des décisions prises",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=67"
  },
  {
    ID: 226,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Financement du développement durable",
    Title: "Participation accrue des pays en développement à l’élaboration des normes fiscales internationales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=67"
  },
  {
    ID: 227,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Département des affaires économiques et sociales",
    Programme: "Affaires économiques et sociales",
    Subprogramme: "Financement du développement durable",
    Title: "L’architecture internationale de la dette est mise en place",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=fr#page=67"
  },
  {
    ID: 228,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Pays les moins avancés",
    Title: "Application accélérée et suivi renforcé du Programme d’action de Doha en faveur des pays les moins avancés",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=8"
  },
  {
    ID: 229,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Pays les moins avancés",
    Title: "Un nouveau mécanisme de constitution de stocks alimentaires permet de réduire l’insécurité alimentaire dans les pays les moins avancés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=8"
  },
  {
    ID: 230,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Pays les moins avancés",
    Title: "Renforcement de la résilience face aux chocs extérieurs dans les pays les moins avancés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Relèvement inclusif et durable après une catastrophe ; renforcement de la résilience face aux futurs chocs",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=10"
  },
  {
    ID: 231,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Pays les moins avancés",
    Title: "Les pays les moins avancés renforcent les moyens leur permettant d’être reclassés de façon durable et irréversible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=10"
  },
  {
    ID: 232,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Pays en développement sans littoral",
    Title: "Adoption de la Déclaration politique d’Avaza lors de la troisième Conférence des Nations Unies sur les pays en développement sans littoral",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=13"
  },
  {
    ID: 233,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Pays en développement sans littoral",
    Title: "Initiatives de financement stratégique du développement visant à renforcer la résilience économique des pays en développement sans littoral",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=14"
  },
  {
    ID: 234,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Pays en développement sans littoral",
    Title: "Améliorations obtenues en matière de liberté de transit pour les pays en développement sans littoral",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=15"
  },
  {
    ID: 235,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Pays en développement sans littoral",
    Title: "Intégration du Programme d’action d’Avaza en faveur des pays en développement sans littoral dans les stratégies de développement nationales et sectorielles, les plans-cadres de coopération pour le développement et les plans stratégiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=15"
  },
  {
    ID: 236,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Petits États insulaires en développement",
    Title: "Amélioration de la soutenabilité de la dette des petits États insulaires en développement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=18"
  },
  {
    ID: 237,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Petits États insulaires en développement",
    Title: "Recours à des décisions fondées sur des données pour remédier aux vulnérabilités structurelles des petits États insulaires en développement et accroître leur résilience",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=19"
  },
  {
    ID: 238,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Petits États insulaires en développement",
    Title: "Le cadre de suivi et d’évaluation du Programme d’Antigua-et-Barbuda pour les petits États insulaires en développement est mis à profit par les petits États insulaires en développement pour éclairer leurs stratégies de planification nationales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=20"
  },
  {
    ID: 239,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Petits États insulaires en développement",
    Title: "Établissement de partenariats stratégiques visant à accélérer la mise en œuvre du Programme d’Antigua-et-Barbuda pour les petits États insulaires en développement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la coopération et des partenariats, amélioration de la cohérence et des synergies et réduction des chevauchements grâce à une communication constante",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=20"
  },
  {
    ID: 240,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Activités de mobilisation, de sensibilisation et d’analyse",
    Title: "Renforcement de l’intégration des trois programmes d’action dans les processus intergouvernementaux pertinents",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=24"
  },
  {
    ID: 241,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "Le Bureau de la Haute Représentante pour les pays les moins avancés, les pays en développement sans littoral et les petits États insulaires en développement",
    Programme: "Pays les moins avancés, pays en développement sans littoral et petits États insulaires en développement",
    Subprogramme: "Activités de mobilisation, de sensibilisation et d’analyse",
    Title: "Analyse et suivi en temps réel des trois programmes d’action visant à éclairer l’élaboration des politiques, la planification et la prise de décision",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=fr#page=24"
  },
  {
    ID: 242,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Gestion des données et des connaissances pour des politiques fondées sur des données factuelles et activités de sensibilisation à l’appui de l’Agenda 2063",
    Title: "Les décideurs africains ont utilisé des méthodes d’analyse intégrées afin de promouvoir la paix et le développement à long terme",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: " ",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=9"
  },
  {
    ID: 243,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Gestion des données et des connaissances pour des politiques fondées sur des données factuelles et activités de sensibilisation à l’appui de l’Agenda 2063",
    Title: "Des solutions numériques pour transformer les systèmes financiers et gérer la dette en Afrique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=10"
  },
  {
    ID: 244,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Gestion des données et des connaissances pour des politiques fondées sur des données factuelles et activités de sensibilisation à l’appui de l’Agenda 2063",
    Title: "Des écosystèmes de politiques pour doter la main-d’œuvre africaine des compétences dont elle a besoin dans une économie numérique mondiale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=11"
  },
  {
    ID: 245,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Gestion des données et des connaissances pour des politiques fondées sur des données factuelles et activités de sensibilisation à l’appui de l’Agenda 2063",
    Title: "Des politiques renforcées en matière d’éducation et de perfectionnement des compétences des jeunes afin de lutter contre l’insécurité alimentaire et de promouvoir la résilience climatique en Afrique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=11"
  },
  {
    ID: 246,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Coordination régionale de l’appui des Nations Unies à la mise en œuvre intégrée du Programme de développement durable à l’horizon 2030 et de l’Agenda 2063",
    Title: "Adoption de la stratégie de mobilisation de ressources nationales afin de financer le deuxième plan décennal de mise en œuvre de l’Agenda 2063",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=15"
  },
  {
    ID: 247,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Coordination régionale de l’appui des Nations Unies à la mise en œuvre intégrée du Programme de développement durable à l’horizon 2030 et de l’Agenda 2063",
    Title: "Stratégies à long terme pour la gestion de la dette en Afrique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=15"
  },
  {
    ID: 248,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Coordination régionale de l’appui des Nations Unies à la mise en œuvre intégrée du Programme de développement durable à l’horizon 2030 et de l’Agenda 2063",
    Title: "Des institutions publiques plus réactives et plus responsables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: "Administration publique",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=16"
  },
  {
    ID: 249,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Coordination régionale de l’appui des Nations Unies à la mise en œuvre intégrée du Programme de développement durable à l’horizon 2030 et de l’Agenda 2063",
    Title: "Les États Membres africains élaborent des politiques de lutte contre les effets des changements climatiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=16"
  },
  {
    ID: 250,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Activités d’information et de sensibilisation à l’appui de l’Agenda 2063",
    Title: "Un partenariat médiatique touchant 130 millions de personnes met en avant les perspectives africaines sur l’intelligence artificielle et l’emploi numérique",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=19"
  },
  {
    ID: 251,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Activités d’information et de sensibilisation à l’appui de l’Agenda 2063",
    Title: "Échanges avec le grand public concernant le fardeau de la dette de l’Afrique et les solutions potentielles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=20"
  },
  {
    ID: 252,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Activités d’information et de sensibilisation à l’appui de l’Agenda 2063",
    Title: "Renforcement de la sensibilisation, par les partenaires médiatiques, aux questions relatives à l’éducation, à l’emploi décent et à la protection sociale en Afrique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement de la coopération et des partenariats, amélioration de la cohérence et des synergies et réduction des chevauchements grâce à une communication constante",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=21"
  },
  {
    ID: 253,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "Bureau de la Conseillère spéciale pour l'Afrique",
    Programme: "Appui du système des Nations Unies à l’Agenda 2063 de l’Union africaine : L’Afrique que nous voulons",
    Subprogramme: "Activités d’information et de sensibilisation à l’appui de l’Agenda 2063",
    Title: "Visibilité accrue des solutions portées par les jeunes pour la résilience climatique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "États Membres d’Afrique",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Renforcement de la coopération et des partenariats, amélioration de la cohérence et des synergies et réduction des chevauchements grâce à une communication constante",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=fr#page=21"
  },
  {
    ID: 254,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Mondialisation, interdépendance et développement",
    Title: "Les perspectives en matière de commerce et de développement éclairent les débats menés à l’échelle mondiale et les mesures qui en découlent",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "PMA, PDSL, PEID et autres pays en développement",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=13"
  },
  {
    ID: 255,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Mondialisation, interdépendance et développement",
    Title: "Amélioration de la transparence des données sur la dette dans les pays en développement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EC,EG,QG,JO",
    Image: "12UNCTAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=13"
  },
  {
    ID: 256,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Mondialisation, interdépendance et développement",
    Title: "Les économies en développement conçoivent des politiques de transformation industrielle et structurelle durables grâce à la coopération Sud-Sud et à la coopération triangulaire",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KZ,MY,PK,TR",
    Image: "12UNCTAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=15"
  },
  {
    ID: 257,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Mondialisation, interdépendance et développement",
    Title: "Les pays emprunteurs administrent leur dette de manière plus efficace et plus durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=15"
  },
  {
    ID: 258,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Investissement et entreprises",
    Title: "Des écosystèmes entrepreneuriaux renforcés pour un développement inclusif et novateur des entreprises",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: " ",
    SpecificResult: "Entrepreneuriat et amélioration de la compétitivité des microentreprises et des petites et moyennes entreprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=19"
  },
  {
    ID: 259,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Investissement et entreprises",
    Title: "Accélération des investissements en faveur des objectifs de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=19"
  },
  {
    ID: 260,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Investissement et entreprises",
    Title: "Instauration par les États membres d’un climat propice aux affaires et aux investissements",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=22"
  },
  {
    ID: 261,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Investissement et entreprises",
    Title: "Adoption accrue de pratiques d’investissement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=22"
  },
  {
    ID: 262,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Commerce international et produits de base",
    Title: "Amélioration de la sûreté des biens de consommation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=28"
  },
  {
    ID: 263,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Commerce international et produits de base",
    Title: "Mise en œuvre renforcée des contributions déterminées au niveau national grâce aux politiques commerciales mises en place par les pays en développement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GM",
    Image: "12UNCTAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=29"
  },
  {
    ID: 264,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Commerce international et produits de base",
    Title: "Les États membres exploitent les minéraux critiques essentiels à la transition énergétique aux fins du développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NA,ZM",
    Image: "12UNCTAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=30"
  },
  {
    ID: 265,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Commerce international et produits de base",
    Title: "Des données à jour sur les mesures non tarifaires pour améliorer les pratiques réglementaires et favoriser le développement économique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=30"
  },
  {
    ID: 266,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Technologie et logistique",
    Title: "Les pays en développement font progresser l’étude théorique et la mise en place de parcs de la science, de la technologie et de l’innovation au service du développement durable",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "PMA, PDSL, PEID et autres pays en développement",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,MN,MZ,UZ",
    Image: "12UNCTAD13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=37"
  },
  {
    ID: 267,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Technologie et logistique",
    Title: "Meilleure disponibilité de statistiques sur l’économie numérique dans les pays en développement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=38"
  },
  {
    ID: 268,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Technologie et logistique",
    Title: "Amélioration de l’efficacité et de la durabilité des procédures commerciales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "PMA, PDSL, PEID et autres pays en développement",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JM,VC,TJ,TL,VU,ZW",
    Image: "12UNCTAD15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=39"
  },
  {
    ID: 269,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Technologie et logistique",
    Title: "Renforcement de l’inclusion dans la facilitation du commerce",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Femmes et filles",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=39"
  },
  {
    ID: 270,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Afrique, pays les moins avancés et programmes spéciaux",
    Title: "Les pays les moins avancés définissent une position commune sur les règles d’origine et des priorités communes en vue de la quatorzième Conférence ministérielle de l’Organisation mondiale du commerce",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "12UNCTAD17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=45"
  },
  {
    ID: 271,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Afrique, pays les moins avancés et programmes spéciaux",
    Title: "Renforcement des capacités statistiques des pays les moins avancés et d’autres pays en développement en vue de l’adoption d’une nouvelle approche en matière d’élaboration de politiques globales de diversification économique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,ET,KE,NG",
    Image: "12UNCTAD18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=46"
  },
  {
    ID: 272,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Afrique, pays les moins avancés et programmes spéciaux",
    Title: "Renforcement de la capacité des petits États insulaires en développement d’accroître les capacités productives",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,KM,DO,MV,JM,VC,TT",
    Image: "12UNCTAD19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=46"
  },
  {
    ID: 273,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conférence des Nations Unies sur le commerce et le développement",
    Programme: "Commerce et développement",
    Subprogramme: "Afrique, pays les moins avancés et programmes spéciaux",
    Title: "Les pays les moins avancés sont en mesure d’élaborer et de mettre en œuvre des politiques commerciales inclusives et cohérentes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BF,TD,TZ",
    Image: "12UNCTAD20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=fr#page=47"
  },
  {
    ID: 274,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Centre du commerce international",
    Programme: "Centre du commerce international",
    Subprogramme: "Aspects opérationnels de la promotion du commerce et du développement des exportations",
    Title: "Renforcement des possibilités offertes aux start-ups créées par des jeunes et aux jeunes entrepreneurs en matière d’innovation, de débouchés et d’emploi en Afrique et en Amérique latine",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Entrepreneuriat et amélioration de la compétitivité des microentreprises et des petites et moyennes entreprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,UG",
    Image: "13ITC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=fr#page=5"
  },
  {
    ID: 275,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Centre du commerce international",
    Programme: "Centre du commerce international",
    Subprogramme: "Aspects opérationnels de la promotion du commerce et du développement des exportations",
    Title: "Renforcement des services fournis par les organisations locales d’appui aux entreprises pour aider les petites entreprises à tirer parti de la Zone de libre-échange continentale africaine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "PMA, PDSL, PEID et autres pays en développement",
    SpecificResult: "Entrepreneuriat et amélioration de la compétitivité des microentreprises et des petites et moyennes entreprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "13ITC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=fr#page=6"
  },
  {
    ID: 276,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Centre du commerce international",
    Programme: "Centre du commerce international",
    Subprogramme: "Aspects opérationnels de la promotion du commerce et du développement des exportations",
    Title: "Passage progressif à des pratiques durables dans les petites et moyennes entreprises du secteur du textile et de l’habillement en Afrique et dans la région Asie-Pacifique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "PMA, PDSL, PEID et autres pays en développement",
    SpecificResult: "Entrepreneuriat et amélioration de la compétitivité des microentreprises et des petites et moyennes entreprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "13ITC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=fr#page=8"
  },
  {
    ID: 277,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Centre du commerce international",
    Programme: "Centre du commerce international",
    Subprogramme: "Aspects opérationnels de la promotion du commerce et du développement des exportations",
    Title: "Renforcement de la compétitivité à l’exportation des petites et moyennes entreprises d’Europe orientale et d’Asie centrale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: " ",
    SpecificResult: "Entrepreneuriat et amélioration de la compétitivité des microentreprises et des petites et moyennes entreprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,KZ,KG,TJ,UZ",
    Image: "13ITC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=fr#page=8"
  },
  {
    ID: 278,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Action climatique",
    Title: "Les villes s’engagent à atteindre des cibles en matière de refroidissement durable",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=11"
  },
  {
    ID: 279,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Action climatique",
    Title: "Élaboration par les États Membres de documents d’orientation et de plans d’action nationaux en matière de réduction des émissions de méthane",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=12"
  },
  {
    ID: 280,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Action climatique",
    Title: "Adoption par les États Membres d’écotechnologies au service de l’atténuation des changements climatiques et de l’adaptation à ces changements",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=13"
  },
  {
    ID: 281,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Action climatique",
    Title: "Adoption par les pouvoirs publics aux niveaux national et infranational de stratégies et de politiques d’adaptation aux changements climatiques, notamment des plans nationaux d’adaptation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=13"
  },
  {
    ID: 282,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Transformations numériques à l’appui de l’action environnementale",
    Title: "Les pouvoirs publics et les décideurs ont désormais accès à un portail environnemental reposant sur l’intelligence artificielle",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=16"
  },
  {
    ID: 283,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Transformations numériques à l’appui de l’action environnementale",
    Title: "Renforcement de l’interopérabilité des données mondiales relatives à l’environnement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=17"
  },
  {
    ID: 284,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Transformations numériques à l’appui de l’action environnementale",
    Title: "Renforcement des capacités numériques qui favorisent la durabilité environnementale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=18"
  },
  {
    ID: 285,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Transformations numériques à l’appui de l’action environnementale",
    Title: "La prise de décisions de politique générale est éclairée par le Tableau de bord pour le suivi de l’état de l’environnement mondial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=18"
  },
  {
    ID: 286,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Action en faveur de la nature",
    Title: "Les États Membres s’engagent à protéger la biodiversité marine au-delà des frontières nationales",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=21"
  },
  {
    ID: 287,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Action en faveur de la nature",
    Title: "Les institutions du secteur public tiennent compte de l’apport économique de la biodiversité et des services écosystémiques dans leurs décisions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=21"
  },
  {
    ID: 288,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Action en faveur de la nature",
    Title: "Des écosystèmes des récifs côtiers et des populations locales plus résilients",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Relèvement inclusif et durable après une catastrophe ; renforcement de la résilience face aux futurs chocs",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=21"
  },
  {
    ID: 289,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Action en faveur de la nature",
    Title: "Expansion des écosystèmes gérés de manière durable et restaurés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=21"
  },
  {
    ID: 290,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Droit et gouvernance de l’environnement",
    Title: "Les États Membres mettent en place des cadres juridiques et des stratégies nationales pour lutter contre le trafic de déchets illicites",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=25"
  },
  {
    ID: 291,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Droit et gouvernance de l’environnement",
    Title: "Réduction de la production et de la consommation d’hydrofluorocarbones grâce à la mise en œuvre de l’Amendement de Kigali au Protocole de Montréal relatif à des substances qui appauvrissent la couche d’ozone",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=26"
  },
  {
    ID: 292,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Droit et gouvernance de l’environnement",
    Title: "Les acteurs juridiques s’emploient à mieux faire appliquer et respecter le droit de l’environnement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Promotion du droit international et consolidation des mécanismes de règlement des différends internationaux",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=28"
  },
  {
    ID: 293,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Droit et gouvernance de l’environnement",
    Title: "Les objectifs environnementaux sont intégrés dans les cadres politiques et juridiques nationaux",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=28"
  },
  {
    ID: 294,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Mesures relatives aux produits chimiques et à la pollution",
    Title: "Réduction des produits chimiques préoccupants et de leurs déchets",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=30"
  },
  {
    ID: 295,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Mesures relatives aux produits chimiques et à la pollution",
    Title: "Adoption de politiques et de pratiques visant à soutenir les approches fondées sur l’économie circulaire dans les secteurs à fort impact afin de réduire la pollution",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=32"
  },
  {
    ID: 296,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Mesures relatives aux produits chimiques et à la pollution",
    Title: "Adoption de politiques et de stratégies visant à agir sur les dimensions environnementales de la résistance aux antimicrobiens",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=32"
  },
  {
    ID: 297,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Mesures relatives aux produits chimiques et à la pollution",
    Title: "Les États Membres adoptent des politiques, des lois ou des réglementations relatives à la gestion des produits chimiques et des déchets dans des secteurs clés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=32"
  },
  {
    ID: 298,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Finances et transformations économiques",
    Title: "Les compagnies d’assurance s’engagent à intégrer des pratiques durables dans leurs pratiques de fonctionnement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la coopération et des partenariats, amélioration de la cohérence et des synergies et réduction des chevauchements grâce à une communication constante",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=35"
  },
  {
    ID: 299,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Finances et transformations économiques",
    Title: "Un plus grand nombre d’outils et de mesures qui incitent les gouvernements, les entreprises et les consommateurs à faire des choix et à adopter des comportements en faveur de la durabilité environnementale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=35"
  },
  {
    ID: 300,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Finances et transformations économiques",
    Title: "Accélérer les progrès vers des modes de consommation et de production durables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=38"
  },
  {
    ID: 301,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Finances et transformations économiques",
    Title: "Les États Membres adoptent des politiques visant à développer la finance durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=38"
  },
  {
    ID: 302,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Interface science-politiques",
    Title: "Les pays appliquent le Système de comptabilité environnementale et économique",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=40"
  },
  {
    ID: 303,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Interface science-politiques",
    Title: "Amélioration de la surveillance et de la collecte des déchets d’équipements électriques et électroniques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=40"
  },
  {
    ID: 304,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Interface science-politiques",
    Title: "Une interface science-politiques renforcée en Amérique latine et dans les Caraïbes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE",
    Image: "14UNEP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=43"
  },
  {
    ID: 305,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programme des Nations Unies pour l'environnement",
    Programme: "Environnement",
    Subprogramme: "Interface science-politiques",
    Title: "Les pouvoirs publics et les institutions s’appuient sur les connaissances, les données, les statistiques et les évaluations du PNUE pour faciliter l’élaboration de politiques éclairées",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=fr#page=43"
  },
  {
    ID: 306,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Logement, terres, services de base et environnement urbain",
    Title: "La mobilité durable intégrée et les programmes de logements propices à l’utilisation des transports en commun : des leviers au service d’un meilleur accès à des transports publics sûrs et équitables dans les villes, en particulier dans les périphéries urbaines",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,KE,NG,UG",
    Image: "15UN-Habitat1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=14"
  },
  {
    ID: 307,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Logement, terres, services de base et environnement urbain",
    Title: "Villes et pays s’engagent à fournir un logement convenable pour toutes et tous et à combattre le sans-abrisme et l’exclusion liée au logement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,KM,CU,MX",
    Image: "15UN-Habitat2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=14"
  },
  {
    ID: 308,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Logement, terres, services de base et environnement urbain",
    Title: "Renforcement de la sécurité des droits fonciers",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NP",
    Image: "15UN-Habitat3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=17"
  },
  {
    ID: 309,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Logement, terres, services de base et environnement urbain",
    Title: "Amélioration de l’accès à un logement convenable, à des terres et à des services de base",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=17"
  },
  {
    ID: 310,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Planification, politiques de financement, ancrage local et gouvernance",
    Title: "Réformes du droit de l’urbanisme : renforcement des mécanismes de gouvernance à plusieurs niveaux en vue de l’avènement de villes résilientes et durables",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BW,SL,ZW",
    Image: "15UN-Habitat5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=21"
  },
  {
    ID: 311,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Planification, politiques de financement, ancrage local et gouvernance",
    Title: "Modernisation des systèmes de recettes propres pour des administrations locales plus performantes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=23"
  },
  {
    ID: 312,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Planification, politiques de financement, ancrage local et gouvernance",
    Title: "Transformation des systèmes et des territoires à la faveur de la transposition des objectifs de développement durable au niveau local",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=23"
  },
  {
    ID: 313,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Connaissances, données, transition numérique et renforcement des capacités",
    Title: "Accès des urbanistes à des connaissances pratiques et à des orientations en plusieurs langues en vue de l’accélération de la réalisation du Nouveau Programme pour les villes et des objectifs de développement durable",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=27"
  },
  {
    ID: 314,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Connaissances, données, transition numérique et renforcement des capacités",
    Title: "Transformation numérique au service d’un développement urbain durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=28"
  },
  {
    ID: 315,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Connaissances, données, transition numérique et renforcement des capacités",
    Title: "Les autorités nationales et locales renforcent et améliorent la production de données ventilées et utiles à l’élaboration des politiques dans les domaines du logement, des terres et des services de base (résultat cumulé)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=28"
  },
  {
    ID: 316,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Partenariats, coalitions, mobilisation et communication",
    Title: "Le Forum mondial des parties prenantes, un espace de dialogue au service d’un développement urbain inclusif et responsable",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=33"
  },
  {
    ID: 317,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Partenariats, coalitions, mobilisation et communication",
    Title: "Le Forum urbain mondial permet de faire avancer la concrétisation des engagements ayant été pris à l’échelle mondiale pour garantir l’accès de toutes et de tous à un logement convenable, à des terres et à des services de base",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=33"
  },
  {
    ID: 318,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Renforcement de l’action climatique et amélioration de l’environnement urbain",
    Title: "Les contributions déterminées au niveau national intègrent de plus en plus souvent un volet urbain",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=36"
  },
  {
    ID: 319,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Renforcement de l’action climatique et amélioration de l’environnement urbain",
    Title: "Des plans urbains pour l’action climatique sont mis en place en vue de renforcer la résilience des personnes les plus vulnérables",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Relèvement inclusif et durable après une catastrophe ; renforcement de la résilience face aux futurs chocs",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=36"
  },
  {
    ID: 320,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Prévention et gestion efficaces des crises urbaines",
    Title: "Intégration durable des populations déplacées dans les zones urbaines en Somalie",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SO",
    Image: "15UN-Habitat15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=40"
  },
  {
    ID: 321,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programme des Nations Unies pour les établissements humains",
    Programme: "Établissements humains",
    Subprogramme: "Prévention et gestion efficaces des crises urbaines",
    Title: "Approches intégrées et participatives de l’aménagement urbain et du développement inclusif",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SO",
    Image: "15UN-Habitat16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=fr#page=40"
  },
  {
    ID: 322,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Lutte contre la criminalité transnationale organisée",
    Title: "Renforcement de la coopération internationale pour la lutte contre la cybercriminalité et la communication de preuves d’infractions graves",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=23"
  },
  {
    ID: 323,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Lutte contre la criminalité transnationale organisée",
    Title: "Amélioration de l’enregistrement et de la traçabilité des armes à feu et de leurs pièces, éléments et munitions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "HN,SN",
    Image: "16UNODC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=24"
  },
  {
    ID: 324,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Lutte contre la criminalité transnationale organisée",
    Title: "Amélioration de la détection des trafics aériens, maritimes et terrestres",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=25"
  },
  {
    ID: 325,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Lutte contre la criminalité transnationale organisée",
    Title: "Renforcement des mesures normatives, politiques et institutionnelles de lutte contre la criminalité organisée à l’échelle mondiale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=25"
  },
  {
    ID: 326,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Approche globale et équilibrée de la lutte contre le problème mondial de la drogue",
    Title: "Renforcement de la capacité des États Membres de désorganiser les réseaux criminels impliqués dans le trafic de drogue grâce à une meilleure coopération internationale fondée sur des cas concrets",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,BR,CV,CL,CI,DE,PE",
    Image: "16UNODC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=29"
  },
  {
    ID: 327,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Approche globale et équilibrée de la lutte contre le problème mondial de la drogue",
    Title: "Des États Membres d’Afrique subsaharienne mettent en œuvre des interventions renforcées en matière de santé et de développement dans le cadre de la lutte contre le problème mondial de la drogue",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "16UNODC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=29"
  },
  {
    ID: 328,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Approche globale et équilibrée de la lutte contre le problème mondial de la drogue",
    Title: "Des lacunes dans la fourniture de services au niveau mondial sont comblées par de nouvelles initiatives en matière de santé et de développement menées au niveau national",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=31"
  },
  {
    ID: 329,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Approche globale et équilibrée de la lutte contre le problème mondial de la drogue",
    Title: "Le personnel des laboratoires de police scientifique dispose de capacités d’analyse et d’identification des drogues de synthèse et des précurseurs chimiques utilisés dans leur fabrication",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=31"
  },
  {
    ID: 330,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Lutte contre la corruption",
    Title: "Les États Membres mènent des enquêtes, engagent des poursuites et statuent sur des affaires complexes de corruption internationale",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DO,KE,MY,PA,TZ,VN",
    Image: "16UNODC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=35"
  },
  {
    ID: 331,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Lutte contre la corruption",
    Title: "Les États utilisent davantage les informations sur la propriété effective dans le cadre de la lutte contre la corruption",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GT,HN,PY,PH,VN,ZM",
    Image: "16UNODC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=36"
  },
  {
    ID: 332,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Lutte contre la corruption",
    Title: "La coopération est renforcée entre les États au niveau régional pour lutter contre la corruption",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=37"
  },
  {
    ID: 333,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Lutte contre la corruption",
    Title: "Les États se dotent de cadres juridiques et politiques efficaces pour lutter contre la corruption, conformément à la Convention des Nations Unies contre la corruption",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=37"
  },
  {
    ID: 334,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prévention du terrorisme",
    Title: "Renforcement des mesures de justice pénale en vue de lutter contre le financement du terrorisme en Côte d’Ivoire",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI",
    Image: "16UNODC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=40"
  },
  {
    ID: 335,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prévention du terrorisme",
    Title: "Changements institutionnels en Afrique australe pour mettre en place des systèmes de justice pénale solides et responsables et lutter contre le terrorisme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MZ",
    Image: "16UNODC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=41"
  },
  {
    ID: 336,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prévention du terrorisme",
    Title: "Les femmes fonctionnaires contribuent davantage au renforcement des systèmes de justice pénale contre le terrorisme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Femmes et filles",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=42"
  },
  {
    ID: 337,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prévention du terrorisme",
    Title: "Les États sont mieux préparés à lutter contre le terrorisme radiologique et nucléaire, conformément à la Convention internationale pour la répression des actes de terrorisme nucléaire",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=42"
  },
  {
    ID: 338,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Justice",
    Title: "Amélioration de la conformité des systèmes pénitentiaires nationaux aux normes internationales afin de favoriser la réinsertion",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=45"
  },
  {
    ID: 339,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Justice",
    Title: "L’action pour la prévention du crime et la réforme de la justice pénale est menée dans le plein respect des droits humains",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=45"
  },
  {
    ID: 340,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Justice",
    Title: "Les enfants et les jeunes ont un rôle dans la prévention de la participation d’enfants à la criminalité et à la violence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=48"
  },
  {
    ID: 341,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Justice",
    Title: "Les États prennent davantage en main les initiatives en matière de prévention de la criminalité et de justice pénale grâce à des partenariats institutionnels",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=48"
  },
  {
    ID: 342,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Recherche, analyse des tendances et criminalistique",
    Title: "Renforcement des capacités et des compétences des agents des services de détection et de répression et des membres du personnel des services de criminalistique des Amériques en matière d’enquête sur les scènes de crime et d’examen des documents de sécurité contrefaits et frauduleux",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,CL,CR,DO,EC,SV,GT,GY,HN,JM,PA,PY,PE,TT,UY",
    Image: "16UNODC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=51"
  },
  {
    ID: 343,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Recherche, analyse des tendances et criminalistique",
    Title: "Les laboratoires d’analyse de drogues et de toxicologie des États Membres contrôlent leur activité dans le cadre des pratiques d’assurance de la qualité",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=51"
  },
  {
    ID: 344,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Recherche, analyse des tendances et criminalistique",
    Title: "Un meilleur accès aux données dont les États Membres ont besoin pour comprendre et combattre la traite des personnes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=53"
  },
  {
    ID: 345,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Recherche, analyse des tendances et criminalistique",
    Title: "Les États Membres s’appuient de plus en plus sur les travaux de recherche de l’ONUDC pour élaborer leurs politiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=53"
  },
  {
    ID: 346,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Appui en matière de politiques",
    Title: "Des victimes de la traite bénéficient d’un appui complet et centré sur leurs besoins grâce au fonds de contributions volontaires des Nations Unies en faveur des victimes de la traite des personnes, en particulier des femmes et des enfants",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Femmes et filles",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=55"
  },
  {
    ID: 347,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Appui en matière de politiques",
    Title: "Les jeunes participent activement aux processus de prise de décision en matière de drogue, de criminalité et de corruption",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=57"
  },
  {
    ID: 348,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Appui en matière de politiques",
    Title: "Des initiatives de partenariat public-privé sont mises en œuvre dans le cadre de la Convention des Nations Unies contre la cybercriminalité",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DO,NG",
    Image: "16UNODC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=57"
  },
  {
    ID: 349,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Appui en matière de politiques",
    Title: "Le public est mieux sensibilisé aux menaces que représentent la drogue, la criminalité, la corruption et le terrorisme grâce à des contenus ciblés sur les médias sociaux",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=57"
  },
  {
    ID: 350,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Coopération technique et appui opérationnel",
    Title: "L’obligation de rendre compte et l’efficacité du système judiciaire ont été renforcées en Haïti",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "16UNODC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=60"
  },
  {
    ID: 351,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Coopération technique et appui opérationnel",
    Title: "Traiter les problèmes de sécurité en mer à l’aide de systèmes renforcés de gestion de la sécurité maritime",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,KM,KE,MG,MU,MZ,NA,SC,TZ",
    Image: "16UNODC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=61"
  },
  {
    ID: 352,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Coopération technique et appui opérationnel",
    Title: "La transparence et l’efficacité en matière de gestion des actifs sont renforcées afin d’améliorer la prévention de la criminalité et la confiance publique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "MZ",
    Image: "16UNODC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=63"
  },
  {
    ID: 353,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Coopération technique et appui opérationnel",
    Title: "Des activités de prévention et de lutte contre la criminalité organisée sont menées sur les terres et les territoires habituellement occupés par les peuples autochtones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du respect de l’état de droit ; renforcement de la prévention de la criminalité et de la justice pénale ; réduction de la corruption ; prévention et répression du terrorisme",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR",
    Image: "16UNODC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=63"
  },
  {
    ID: 354,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prestation de services de secrétariat et d’appui fonctionnel à la Commission des stupéfiants, à la Commission pour la prévention du crime et la justice pénale et au Congrès des Nations Unies pour la prévention du crime et la justice pénale",
    Title: "Les travaux de préparation du quinzième Congrès des Nations Unies pour la prévention du crime et la justice pénale ont avancé",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT,CR,ET,MA,TH",
    Image: "16UNODC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=66"
  },
  {
    ID: 355,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prestation de services de secrétariat et d’appui fonctionnel à la Commission des stupéfiants, à la Commission pour la prévention du crime et la justice pénale et au Congrès des Nations Unies pour la prévention du crime et la justice pénale",
    Title: "Renforcement de la mise en œuvre des engagements internationaux en matière de prévention du crime et de justice pénale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=66"
  },
  {
    ID: 356,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prestation de services de secrétariat et d’appui fonctionnel à la Commission des stupéfiants, à la Commission pour la prévention du crime et la justice pénale et au Congrès des Nations Unies pour la prévention du crime et la justice pénale",
    Title: "Accélération de l’action menée en faveur de la prévention de la criminalité, de la justice pénale et de l’état de droit grâce à l’adoption et à la mise en œuvre de la déclaration d’Abou Dhabi",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=66"
  },
  {
    ID: 357,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prestation de services de secrétariat et d’appui fonctionnel à la Commission des stupéfiants, à la Commission pour la prévention du crime et la justice pénale et au Congrès des Nations Unies pour la prévention du crime et la justice pénale",
    Title: "Accélérer la mise en œuvre des engagements internationaux en matière de politique antidrogue en vue d’aborder et de combattre efficacement le problème mondial de la drogue",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement du multilatéralisme",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=66"
  },
  {
    ID: 358,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prestation de services de secrétariat et d’appui fonctionnel à l’Organe international de contrôle des stupéfiants",
    Title: "Bon fonctionnement du système international d’estimations et d’évaluations pour le commerce licite de stupéfiants et de substances psychotropes à des fins médicales et scientifiques",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=72"
  },
  {
    ID: 359,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prestation de services de secrétariat et d’appui fonctionnel à l’Organe international de contrôle des stupéfiants",
    Title: "Réduction du trafic de nouvelles substances psychoactives et d’opioïdes synthétiques à usage non médical très puissants",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=74"
  },
  {
    ID: 360,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prestation de services de secrétariat et d’appui fonctionnel à l’Organe international de contrôle des stupéfiants",
    Title: "Renforcement de la capacité des États Membres de garantir une disponibilité suffisante des substances placées sous contrôle international destinées à un usage médical ou scientifique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=74"
  },
  {
    ID: 361,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Office des Nations Unies contre les Drogues et le Crime",
    Programme: "Contrôle international des drogues, prévention du crime et du terrorisme et justice pénale",
    Subprogramme: "Prestation de services de secrétariat et d’appui fonctionnel à l’Organe international de contrôle des stupéfiants",
    Title: "Réduction du volume de précurseurs chimiques et de produits chimiques non placés sous contrôle disponibles pour la fabrication illicite de drogues",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contrôle des drogues, prévention du crime et lutte contre la criminalité organisée et le terrorisme international sous toutes ses formes et dans toutes ses manifestations",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des contrôles liés à la circulation de drogues, de marchandises illicites et à la traite des personnes ; réduction des flux financiers illicites",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=fr#page=74"
  },
  {
    ID: 362,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entité des Nations Unies pour l'égalité des sexes et l'autonomisation des femmes",
    Programme: "ONU-Femmes",
    Subprogramme: "Appui aux mécanismes intergouvernementaux, coordination et partenariats stratégiques",
    Title: "Mesures prioritaires définies et adoptées pour accélérer la mise en œuvre du Programme d’action de Beijing",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=fr#page=8"
  },
  {
    ID: 363,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entité des Nations Unies pour l'égalité des sexes et l'autonomisation des femmes",
    Programme: "ONU-Femmes",
    Subprogramme: "Appui aux mécanismes intergouvernementaux, coordination et partenariats stratégiques",
    Title: "Renforcer les normes et les règles mondiales relatives à l’égalité des genres et à l’avancement de toutes les femmes et de toutes les filles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=fr#page=9"
  },
  {
    ID: 364,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entité des Nations Unies pour l'égalité des sexes et l'autonomisation des femmes",
    Programme: "ONU-Femmes",
    Subprogramme: "Appui aux mécanismes intergouvernementaux, coordination et partenariats stratégiques",
    Title: "Prendre en compte les questions de genre dans les plans-cadres de coopération des Nations Unies pour le développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: " ",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=fr#page=10"
  },
  {
    ID: 365,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entité des Nations Unies pour l'égalité des sexes et l'autonomisation des femmes",
    Programme: "ONU-Femmes",
    Subprogramme: "Appui aux mécanismes intergouvernementaux, coordination et partenariats stratégiques",
    Title: "Renforcer la prise en compte des questions de genre à l’aide du Plan d’action à l’échelle du système des Nations Unies pour l’égalité des sexes et l’avancement des femmes 3.0",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=fr#page=10"
  },
  {
    ID: 366,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entité des Nations Unies pour l'égalité des sexes et l'autonomisation des femmes",
    Programme: "ONU-Femmes",
    Subprogramme: "Politiques et programmes",
    Title: "Utilisation par les États Membres de données sur l’emploi du temps pour élaborer des politiques fondées sur des données factuelles visant à reconnaître, réduire et redistribuer le travail domestique non rémunéré",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=fr#page=13"
  },
  {
    ID: 367,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entité des Nations Unies pour l'égalité des sexes et l'autonomisation des femmes",
    Programme: "ONU-Femmes",
    Subprogramme: "Politiques et programmes",
    Title: "Les gouvernements prennent, dans l’application d’une politique budgétaire et d’une budgétisation tenant compte des questions de genre, des dispositions propres à promouvoir l’égalité des genres",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: " ",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=fr#page=14"
  },
  {
    ID: 368,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entité des Nations Unies pour l'égalité des sexes et l'autonomisation des femmes",
    Programme: "ONU-Femmes",
    Subprogramme: "Politiques et programmes",
    Title: "Les pays adoptent des plans d’action nationaux de prévention de la violence à l’égard des femmes et des filles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: " ",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=fr#page=16"
  },
  {
    ID: 369,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entité des Nations Unies pour l'égalité des sexes et l'autonomisation des femmes",
    Programme: "ONU-Femmes",
    Subprogramme: "Politiques et programmes",
    Title: "Les gouvernements réalisent des progrès dans la réforme des lois discriminatoires",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=fr#page=16"
  },
  {
    ID: 370,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Politiques macroéconomiques, financement et gouvernance",
    Title: "Renforcement de la gestion de la dette et stratégies de financement durable dans les petits États insulaires en développement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM",
    Image: "18ECA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=15"
  },
  {
    ID: 371,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Politiques macroéconomiques, financement et gouvernance",
    Title: "Les États membres de la Commission adoptent des approches novatrices à des fins de mobilisation de ressources intérieures et de capitaux extérieurs privés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BW,ET,GN,MR,UG,TZ",
    Image: "18ECA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=15"
  },
  {
    ID: 372,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Politiques macroéconomiques, financement et gouvernance",
    Title: "Amélioration des prévisions macroéconomiques et de la planification du développement aux fins d’une croissance inclusive et durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BW",
    Image: "18ECA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=16"
  },
  {
    ID: 373,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Politiques macroéconomiques, financement et gouvernance",
    Title: "Améliorer la gouvernance économique et financière afin de renforcer la transformation structurelle et le développement inclusif",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,ET,GN,UG,ZM",
    Image: "18ECA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=17"
  },
  {
    ID: 374,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Intégration régionale et commerce",
    Title: "L’Éthiopie est mieux préparée à commercer dans le cadre de la Zone de libre-échange continentale africaine",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ET",
    Image: "18ECA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=21"
  },
  {
    ID: 375,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Intégration régionale et commerce",
    Title: "Stratégies commerciales durables permettant d’atténuer l’impact des changements climatiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=22"
  },
  {
    ID: 376,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Intégration régionale et commerce",
    Title: "Les États membres de la Commission adoptent des mesures pour réduire les risques liés aux investissements dans les chaînes de valeur régionales et les zones économiques spéciales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=22"
  },
  {
    ID: 377,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Intégration régionale et commerce",
    Title: "Le secteur privé tire parti de l’amélioration des conditions politiques et institutionnelles nationales pour participer au commerce intra-africain dans le cadre de la Zone de libre-échange continentale africaine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=23"
  },
  {
    ID: 378,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Technologie, innovation, connectivité et développement des infrastructures",
    Title: "Les États Membres ont accès à un outil de simulation des politiques fiscales destiné à faciliter l’élaboration de politiques fondées sur des données factuelles en faveur d’une connectivité d’un coût abordable, d’une croissance économique inclusive et de la création d’emplois en Afrique",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=27"
  },
  {
    ID: 379,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Technologie, innovation, connectivité et développement des infrastructures",
    Title: "Utilisation accrue des nouvelles technologies par les États membres, renforcée par des cadres réglementaires solides",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=28"
  },
  {
    ID: 380,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Technologie, innovation, connectivité et développement des infrastructures",
    Title: "Les États membres de la CEA tirent parti de la technologie et de l’innovation pour gérer leurs infrastructures de transport et leurs infrastructures énergétiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,GH,KE,MG",
    Image: "18ECA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=29"
  },
  {
    ID: 381,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Technologie, innovation, connectivité et développement des infrastructures",
    Title: "Les stratégies et les politiques en matière de développement des infrastructures sont renforcées",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SZ,GM",
    Image: "18ECA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=29"
  },
  {
    ID: 382,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Données et statistiques",
    Title: "Les membres de la CEA produisent et utilisent de meilleures statistiques économiques pour élaborer leurs politiques d’intégration régionale",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=34"
  },
  {
    ID: 383,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Données et statistiques",
    Title: "Progrès accomplis dans la mise en place de cadres intégrés de l’information statistique et géospatiale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ER,GH,NA",
    Image: "18ECA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=35"
  },
  {
    ID: 384,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Données et statistiques",
    Title: "Amélioration des systèmes d’enregistrement des faits d’état civil et de statistiques de l’état civil",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,KE,NA,TZ",
    Image: "18ECA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=35"
  },
  {
    ID: 385,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Données et statistiques",
    Title: "Des systèmes statistiques nationaux renforcés permettent de régulièrement générer des produits statistiques innovants, qui, mis au service de l’élaboration de politiques, favorise une prise de décision fondée sur des données probantes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=36"
  },
  {
    ID: 386,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Changements climatiques, sécurité alimentaire et ressources naturelles",
    Title: "Les membres de la CEA renforcent les cadres politiques et institutionnels visant à rendre les chaînes de valeur agricoles résilientes face aux changements climatiques",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI,GH,ZM,ZW",
    Image: "18ECA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=42"
  },
  {
    ID: 387,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Changements climatiques, sécurité alimentaire et ressources naturelles",
    Title: "Les États membres de la CEA élaborent et mettent en œuvre des cadres nationaux et régionaux d’action et de coopération pour favoriser l’utilisation durable des ressources naturelles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=43"
  },
  {
    ID: 388,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Changements climatiques, sécurité alimentaire et ressources naturelles",
    Title: "Des systèmes agroalimentaires résilients et inclusifs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=43"
  },
  {
    ID: 389,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Changements climatiques, sécurité alimentaire et ressources naturelles",
    Title: "Renforcement de l’ambition et de l’action climatiques en Afrique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=44"
  },
  {
    ID: 390,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Autonomisation économique des femmes et des jeunes",
    Title: "Renforcement de la collecte, du suivi et de la communication de données sur l’égalité des genres et l’autonomisation des femmes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,SS,II",
    Image: "18ECA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=50"
  },
  {
    ID: 391,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Autonomisation économique des femmes et des jeunes",
    Title: "Prise en compte par les États membres de la CEA des questions de genre dans leur politique budgétaire",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "ET,KE,RW,UG,TZ",
    Image: "18ECA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=50"
  },
  {
    ID: 392,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Autonomisation économique des femmes et des jeunes",
    Title: "Les États membres de la CEA prennent des mesures pour améliorer l’inclusion des femmes sur le plan financier",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "GM,SL",
    Image: "18ECA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=51"
  },
  {
    ID: 393,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Autonomisation économique des femmes et des jeunes",
    Title: "Les membres de la CEA tirent parti de la transition numérique pour aider les jeunes entrepreneurs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Entrepreneuriat et amélioration de la compétitivité des microentreprises et des petites et moyennes entreprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ZA",
    Image: "18ECA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=52"
  },
  {
    ID: 394,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique du Nord",
    Title: "Les États membres de la CEA prennent des mesures pour développer la finance durable",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,SL",
    Image: "18ECA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=55"
  },
  {
    ID: 395,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique du Nord",
    Title: "Les États membres de la CEA mobilisent des financements pour réaliser le développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LY",
    Image: "18ECA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=56"
  },
  {
    ID: 396,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique du Nord",
    Title: "Les États membres de la CEA augmentent la productivité, la diversification et la valeur ajoutée pour accélérer la croissance inclusive et durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Entrepreneuriat et amélioration de la compétitivité des microentreprises et des petites et moyennes entreprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=56"
  },
  {
    ID: 397,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique du Nord",
    Title: "Les États membres de la CEA prennent des mesures pour maximiser la participation de la diaspora, une autre source de financement du développement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=57"
  },
  {
    ID: 398,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique de l’Ouest",
    Title: "Les États de l’Afrique de l’Ouest membres de la CEA intègrent l’analyse des chaînes de valeur agricoles dans leurs dispositifs de planification",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=60"
  },
  {
    ID: 399,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique de l’Ouest",
    Title: "Les États membres de la CEA évaluent la soutenabilité de la dette et élaborent des stratégies budgétaires à plus long terme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SL",
    Image: "18ECA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=61"
  },
  {
    ID: 400,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique de l’Ouest",
    Title: "Renforcement de la mise en œuvre de stratégies nationales relatives à la Zone de libre-échange continentale africaine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CV,GH,LR",
    Image: "18ECA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=62"
  },
  {
    ID: 401,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique de l’Ouest",
    Title: "Renforcement des systèmes nationaux de budgétisation et de suivi visant à valoriser le dividende démographique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=63"
  },
  {
    ID: 402,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique centrale",
    Title: "Sao Tomé-et-Principe a élaboré et homologué ses premiers comptes satellites du tourisme",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ST",
    Image: "18ECA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=66"
  },
  {
    ID: 403,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique centrale",
    Title: "Les États membres de la CEA développent des zones économiques spéciales pour une diversification économique durable et inclusive",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CM,CG,CD,GA",
    Image: "18ECA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=67"
  },
  {
    ID: 404,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique centrale",
    Title: "Les pays d’Afrique centrale membres de la CEA améliorent l’évaluation et la capitalisation des actifs naturels",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CG,ST",
    Image: "18ECA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=67"
  },
  {
    ID: 405,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique centrale",
    Title: "Renforcement des systèmes de facilitation du commerce et des capacités institutionnelles visant à accélérer l’intégration économique régionale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,CM,CF,TD,GQ,CD,GA,CG,RW,ST",
    Image: "18ECA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=68"
  },
  {
    ID: 406,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique de l’Est",
    Title: "La Somalie lance le plan Vision 2060 à l’horizon du centenaire et ratifie l’Accord portant création de la Zone de libre-échange continentale africaine",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "18ECA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=72"
  },
  {
    ID: 407,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique de l’Est",
    Title: "Les États membres de la CEA et les organisations régionales élaborent des stratégies de promotion de l’investissement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=72"
  },
  {
    ID: 408,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique de l’Est",
    Title: "Les États membres de la CEA mettent en œuvre des cadres régionaux liés au tourisme et à l’économie bleue",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=73"
  },
  {
    ID: 409,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique de l’Est",
    Title: "Renforcement de la connectivité et des infrastructures en vue d’une plus grande intégration régionale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=74"
  },
  {
    ID: 410,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique australe",
    Title: "Accélération des échanges commerciaux intrarégionaux et des investissements dans la région de la SADC grâce aux technologies numériques",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,CD,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,TZ,ZM,ZW",
    Image: "18ECA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=78"
  },
  {
    ID: 411,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique australe",
    Title: "Accélérer la transition vers des économies plus durables en Afrique australe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=78"
  },
  {
    ID: 412,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique australe",
    Title: "Industrialisation qui profite à tous par le développement des chaînes de valeur en Afrique australe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=79"
  },
  {
    ID: 413,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales en Afrique australe",
    Title: "Accélération de la mise en œuvre de l’Accord portant création de la Zone de libre-échange continentale africaine et d’autres accords commerciaux en Afrique australe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=80"
  },
  {
    ID: 414,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Développement économique et planification",
    Title: "Les États membres de la CEA abandonnent progressivement les approches fragmentées en matière de protection sociale au profit d’approches intégrées grâce à l’élaboration de stratégies nationales de protection sociale",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CM,SN,ZW",
    Image: "18ECA45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=83"
  },
  {
    ID: 415,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Développement économique et planification",
    Title: "Les États membres de la CEA mettent en place une main-d’œuvre prête pour l’avenir",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=84"
  },
  {
    ID: 416,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Développement économique et planification",
    Title: "Renforcement de la planification et du financement du développement au niveau local",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=85"
  },
  {
    ID: 417,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Développement économique et planification",
    Title: "Amélioration des systèmes de formation dans l’administration publique afin de renforcer la planification du développement national",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DJ",
    Image: "18ECA48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=86"
  },
  {
    ID: 418,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Pauvreté et politiques socioéconomiques",
    Title: "Les États membres de la CEA ont défini une position commune pour l’Afrique concernant les priorités en matière de développement social",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=89"
  },
  {
    ID: 419,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Pauvreté et politiques socioéconomiques",
    Title: "Amélioration des systèmes de protection sociale pour les plus vulnérables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GH,NA,SN,TZ",
    Image: "18ECA50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=90"
  },
  {
    ID: 420,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Pauvreté et politiques socioéconomiques",
    Title: "Renforcement des examens nationaux et régionaux des dispositifs relatifs à la démographie, l’objectif étant de promouvoir le développement durable et de ne laisser personne de côté",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=90"
  },
  {
    ID: 421,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Commission économique pour l'Afrique",
    Programme: "Développement économique et social en Afrique",
    Subprogramme: "Pauvreté et politiques socioéconomiques",
    Title: "Renforcement des politiques de l’emploi fondées sur des données probantes en vue de la valorisation du dividende démographique de l’Afrique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement de l’Afrique",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "États Membres d’Afrique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=A/81/6(Sect.18)&l=fr#page=91"
  },
  {
    ID: 422,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Politique macroéconomique, réduction de la pauvreté et financement du développement",
    Title: "Prise en compte des priorités des pays de l’Asie et du Pacifique dans le programme mondial de financement du développement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: "Administration publique",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=19"
  },
  {
    ID: 423,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Politique macroéconomique, réduction de la pauvreté et financement du développement",
    Title: "Amélioration de l’élaboration des politiques macroéconomiques et des politiques de financement du développement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SD,QQ,BT,KH,MV,MN,PK,LK",
    Image: "19ESCAP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=20"
  },
  {
    ID: 424,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Politique macroéconomique, réduction de la pauvreté et financement du développement",
    Title: "Lancement par les États membres de nouvelles initiatives et réformes politiques visant à accélérer le financement du développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SD,QQ,BT,KH,LK",
    Image: "19ESCAP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=21"
  },
  {
    ID: 425,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Politique macroéconomique, réduction de la pauvreté et financement du développement",
    Title: "Conception, évaluation et mise en œuvre par les États membres de politiques macroéconomiques visant à accélérer les progrès réalisés en vue d’atteindre un développement résilient face aux changements climatiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Relèvement inclusif et durable après une catastrophe ; renforcement de la résilience face aux futurs chocs",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=22"
  },
  {
    ID: 426,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Commerce, investissement et innovation",
    Title: "Amélioration des négociations d’accords commerciaux par les pays grâce à des analyses sur mesure",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: "Administration publique",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=26"
  },
  {
    ID: 427,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Commerce, investissement et innovation",
    Title: "Amélioration de la durabilité et de l’efficacité des processus commerciaux par le renforcement des mesures de facilitation du commerce numérique et durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=27"
  },
  {
    ID: 428,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Commerce, investissement et innovation",
    Title: "Engagement des organismes de promotion de l’investissement à promouvoir l’égalité des genres au moyen d’investissements étrangers directs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=27"
  },
  {
    ID: 429,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Commerce, investissement et innovation",
    Title: "Amélioration de l’accès aux possibilités de transfert de technologie et aux connaissances sur les technologies émergentes et innovantes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=28"
  },
  {
    ID: 430,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Transports",
    Title: "Les États membres intègrent de plus en plus les modalités de transports bénéficiant à tous dans leurs processus de planification et d’élaboration des politiques afin de rendre les systèmes de transport plus accessibles et socialement inclusifs dans les villes de la région de l’Asie et du Pacifique",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: " ",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AZ,LA,MN,NP,FJ,KI,PG,SB,TL",
    Image: "19ESCAP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=32"
  },
  {
    ID: 431,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Transports",
    Title: "Amélioration de l’efficacité et de la résilience de la connectivité des transports et des réseaux logistiques en Asie et dans le Pacifique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Entrepreneuriat et amélioration de la compétitivité des microentreprises et des petites et moyennes entreprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=33"
  },
  {
    ID: 432,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Transports",
    Title: "Accélération de la transition vers des modes de transport à faible taux d’émission",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=34"
  },
  {
    ID: 433,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Transports",
    Title: "Renforcement de la coopération régionale aux fins du développement de transports durables, résilients et inclusifs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: " ",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=34"
  },
  {
    ID: 434,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Environnement et développement, et réduction et gestion des risques de catastrophe",
    Title: "Intensification de l’action climatique",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BT,PG",
    Image: "19ESCAP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=38"
  },
  {
    ID: 435,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Environnement et développement, et réduction et gestion des risques de catastrophe",
    Title: "Les États membres d’Asie et du Pacifique renforcent leur coopération pour faire progresser les approches participatives en matière d’environnement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=39"
  },
  {
    ID: 436,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Environnement et développement, et réduction et gestion des risques de catastrophe",
    Title: "Renforcement de la coopération régionale en matière d’action climatique fondée sur l’océan, notamment au moyen d’approches écosystémiques et de solutions fondées sur la nature",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=39"
  },
  {
    ID: 437,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Environnement et développement, et réduction et gestion des risques de catastrophe",
    Title: "Renforcement et amélioration de la coopération, des initiatives et des partenariats régionaux en matière de développement urbain durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement de la coopération et des partenariats, amélioration de la cohérence et des synergies et réduction des chevauchements grâce à une communication constante",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=40"
  },
  {
    ID: 438,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Technologies numériques et applications spatiales",
    Title: "Renforcement de la mise en œuvre de l’initiative « Alertes précoces pour tous »",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Relèvement inclusif et durable après une catastrophe ; renforcement de la résilience face aux futurs chocs",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=44"
  },
  {
    ID: 439,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Technologies numériques et applications spatiales",
    Title: "Recours accru aux innovations numériques aux fins d’une adaptation transformatrice aux changements climatiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,LA",
    Image: "19ESCAP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=45"
  },
  {
    ID: 440,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Technologies numériques et applications spatiales",
    Title: "Extension des applications géospatiales par les pays en situation particulière aux fins de la réalisation du Programme 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=45"
  },
  {
    ID: 441,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Technologies numériques et applications spatiales",
    Title: "Renforcement de la coopération régionale en vue de tirer parti des technologies émergentes, en particulier l’intelligence artificielle",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=46"
  },
  {
    ID: 442,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Développement social",
    Title: "Renforcement du dialogue et de la coopération à l’échelle régionale concernant les migrations sûres, ordonnées et régulières en Asie et dans le Pacifique et examen conjoint de la question",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=51"
  },
  {
    ID: 443,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Développement social",
    Title: "Les États membres élaborent des mesures de politique générale visant à valoriser l’économie des services à la personne et à investir dans celle-ci",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LA,TL",
    Image: "19ESCAP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=51"
  },
  {
    ID: 444,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Développement social",
    Title: "Renforcement de la capacité nationale à élaborer des politiques inclusives en matière de vieillissement de la population",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=52"
  },
  {
    ID: 445,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Développement social",
    Title: "Les États membres définissent des trajectoires nationales en matière de politiques de protection sociale tenant compte de la résilience climatique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=53"
  },
  {
    ID: 446,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Statistiques",
    Title: "Exploiter les données pour faire progresser l’enregistrement des faits d’état civil",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=56"
  },
  {
    ID: 447,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Statistiques",
    Title: "Amélioration de la gouvernance des données par les organismes nationaux de statistique dans la région de l’Asie et du Pacifique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=57"
  },
  {
    ID: 448,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Statistiques",
    Title: "Mise en place de plateformes nationales sur les objectifs de développement durable en vue de suivre les progrès accomplis sur la voie de la réalisation du Programme de développement durable à l’horizon 2030 en Asie et dans le Pacifique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=58"
  },
  {
    ID: 449,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Statistiques",
    Title: "Renforcement des systèmes statistiques nationaux grâce à une approche associant l’ensemble de la société",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: "Administration publique",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=59"
  },
  {
    ID: 450,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développemen: Activités sous-régionales de développement dans le Pacifique",
    Title: "Renforcement des capacités des gouvernements des pays du Pacifique à intégrer la valorisation économique des biens et services écosystémiques dans l’élaboration des politiques et la planification",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=62"
  },
  {
    ID: 451,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développemen: Activités sous-régionales de développement dans le Pacifique",
    Title: "Des pistes d’action sont définies en vue de l’intégration du Programme d’Antigua-et-Barbuda pour les petits États insulaires en développement dans les stratégies nationales de développement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=63"
  },
  {
    ID: 452,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développemen: Activités sous-régionales de développement dans le Pacifique",
    Title: "Des indicateurs de base sont produits et utilisés de façon plus efficace pour les besoins des rapports nationaux, régionaux et mondiaux",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=64"
  },
  {
    ID: 453,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développemen: Activités sous-régionales de développement dans le Pacifique",
    Title: "La voix du Pacifique est davantage prise en compte afin que l’indice de vulnérabilité multidimensionnelle établi par l’ONU soit mieux adapté aux besoins de la région",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=64"
  },
  {
    ID: 454,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie de l’Est et du Nord-Est",
    Title: "Renforcement du partage des connaissances à l’appui de l’action climatique au niveau local",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=67"
  },
  {
    ID: 455,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie de l’Est et du Nord-Est",
    Title: "Gestion efficace du transport et du transit ferroviaires transfrontaliers",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Entrepreneuriat et amélioration de la compétitivité des microentreprises et des petites et moyennes entreprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,KR,RU,KU",
    Image: "19ESCAP34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=68"
  },
  {
    ID: 456,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie de l’Est et du Nord-Est",
    Title: "Renforcement de la collaboration transfrontière en matière de lutte contre la désertification et la dégradation des terres en Asie de l’Est et du Nord-Est",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=69"
  },
  {
    ID: 457,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie de l’Est et du Nord-Est",
    Title: "Renforcement de la collaboration concernant les aires marines protégées en Asie de l’Est et du Nord-Est",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=69"
  },
  {
    ID: 458,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Nord et en Asie centrale",
    Title: "Renforcement des échanges commerciaux grâce aux recommandations formulées par les États membres d’Asie du Nord et d’Asie centrale",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: "Administration publique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=72"
  },
  {
    ID: 459,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Nord et en Asie centrale",
    Title: "Les instruments de coopération du Programme spécial des Nations Unies pour les pays d’Asie centrale sont renforcés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Entrepreneuriat et amélioration de la compétitivité des microentreprises et des petites et moyennes entreprises",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=73"
  },
  {
    ID: 460,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Nord et en Asie centrale",
    Title: "Les États membres élaborent des politiques en faveur de la transformation numérique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=74"
  },
  {
    ID: 461,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Nord et en Asie centrale",
    Title: "Les États membres intensifient la coopération sous-régionale en matière de modernisation des réseaux électriques et d’intégration des énergies renouvelables en Asie du Nord et en Asie centrale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=75"
  },
  {
    ID: 462,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Sud et du Sud-Ouest",
    Title: "Renforcement de la coopération multipartite concernant le lien entre l’eau et les changements climatiques en Asie du Sud",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=78"
  },
  {
    ID: 463,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Sud et du Sud-Ouest",
    Title: "Accélération de la transition vers des solutions énergétiques durables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=78"
  },
  {
    ID: 464,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Sud et du Sud-Ouest",
    Title: "Efforts visant à réduire la fracture numérique pour ne laisser personne de côté en Asie du Sud et du Sud-Ouest",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=79"
  },
  {
    ID: 465,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Sud et du Sud-Ouest",
    Title: "Renforcement de la connectivité des échanges commerciaux transfrontaliers en Asie du Sud et du Sud-Ouest, en mettant l’accent sur les femmes chefs d’entreprise et les start-ups dans les zones frontalières",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: "Femmes et filles",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=80"
  },
  {
    ID: 466,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Sud-Est",
    Title: "Dialogue multipartite intégré au service du développement durable en Asie du Sud-Est",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: " ",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=82"
  },
  {
    ID: 467,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Sud-Est",
    Title: "Harmonisation des politiques et des réglementations en matière d’investissement en vue de la réalisation des objectifs de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=83"
  },
  {
    ID: 468,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Sud-Est",
    Title: "Mobilisation des jeunes en faveur de la réalisation des objectifs de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=84"
  },
  {
    ID: 469,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Activités sous-régionales de développement: Activités sous-régionales de développement en Asie du Sud-Est",
    Title: "Renforcement du dialogue et de la coopération régionaux sur la transformation numérique au service du développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "États Membres d'Asie et du Pacifique",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "19ESCAP48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=84"
  },
  {
    ID: 470,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Énergie",
    Title: "Renforcement des politiques en matière de transition énergétique",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KH,FJ,FM,TO,VN",
    Image: "19ESCAP49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=88"
  },
  {
    ID: 471,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Énergie",
    Title: "Adoption de plans d’action nationaux en matière de refroidissement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "VN",
    Image: "19ESCAP50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=89"
  },
  {
    ID: 472,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Énergie",
    Title: "Renforcement de la coopération entre les États membres de la région Asie-Pacifique dans le cadre de projets sur la connectivité électrique transfrontière",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=89"
  },
  {
    ID: 473,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Commission économique et sociale pour l'Asie et le Pacifique",
    Programme: "Développement économique et social en Asie et dans le Pacifique",
    Subprogramme: "Énergie",
    Title: "Adoption au niveau intergouvernemental de nouveaux jalons visant à renforcer la connectivité des réseaux électriques régionaux",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d'Asie et du Pacifique",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=fr#page=90"
  },
  {
    ID: 474,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Environnement",
    Title: "Les États membres ont recours à des approches prospectives pour formuler des recommandations en matière de politiques environnementales afin de combler les lacunes et de répondre aux enjeux émergents",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=16"
  },
  {
    ID: 475,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Environnement",
    Title: "Base de données modernisée sur les polluants permettant de prendre rapidement des décisions fondées sur des faits",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=17"
  },
  {
    ID: 476,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Environnement",
    Title: "Renforcement de la base paneuropéenne de connaissances sur l’environnement en vue de l’élaboration de politiques éclairées",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=17"
  },
  {
    ID: 477,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Environnement",
    Title: "Amélioration de la communication des données relatives aux émissions atmosphériques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=18"
  },
  {
    ID: 478,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Transports",
    Title: "Application de l’annexe 11 de la Convention douanière relative au transport international de marchandises sous le couvert de carnets TIR grâce à un logiciel open source",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=22"
  },
  {
    ID: 479,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Transports",
    Title: "Augmentation du nombre d’adhésions aux principales conventions en matière de sécurité routière, constituant une première étape vers la réduction du nombre de décès et de blessures dus à des accidents de la route au niveau mondial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=23"
  },
  {
    ID: 480,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Transports",
    Title: "Renforcement du cadre réglementaire destiné à garantir la viabilité des systèmes de transport intérieur",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=24"
  },
  {
    ID: 481,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Transports",
    Title: "Accélération de la dématérialisation des procédures découlant des instruments juridiques relatifs aux transports intérieurs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=24"
  },
  {
    ID: 482,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Statistiques",
    Title: "Les États membres adoptent de meilleures normes statistiques mondiales",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=28"
  },
  {
    ID: 483,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Statistiques",
    Title: "Utilisation de la base de données statistiques de la Commission économique pour l’Europe pour l’amélioration de la recherche et de la prise de décision",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=29"
  },
  {
    ID: 484,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Statistiques",
    Title: "Amélioration de la communication des données pour le suivi de la réalisation des objectifs de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=30"
  },
  {
    ID: 485,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Statistiques",
    Title: "Amélioration de la disponibilité et de l’accessibilité des statistiques relatives aux changements climatiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=30"
  },
  {
    ID: 486,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Coopération et intégration économiques",
    Title: "Adoption de la Charte de l’innovation transformatrice de la CEE par les États membres",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=33"
  },
  {
    ID: 487,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Coopération et intégration économiques",
    Title: "Un plus grand nombre de projets d’infrastructure en partenariat public-privé sont jugés conformes aux objectifs de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=33"
  },
  {
    ID: 488,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Coopération et intégration économiques",
    Title: "Amélioration des politiques et initiatives ayant trait à l’innovation à l’appui du développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=34"
  },
  {
    ID: 489,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Coopération et intégration économiques",
    Title: "Cohérence des partenariats public-privé avec les normes et lignes directrices de la CEE sur les partenariats public-privé à l’appui des objectifs de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=35"
  },
  {
    ID: 490,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Énergie durable",
    Title: "Renforcement de la coopération transfrontière en matière de connectivité énergétique",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=38"
  },
  {
    ID: 491,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Énergie durable",
    Title: "Une gestion des ressources naturelles plus durable et plus résiliente, fondée sur la Classification-cadre des Nations Unies pour les ressources",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=38"
  },
  {
    ID: 492,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Énergie durable",
    Title: "Adoption accrue de la mobilité électrique aux fins d’une transition énergétique durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=39"
  },
  {
    ID: 493,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Énergie durable",
    Title: "Réduction des émissions de gaz à effet de serre dans les secteurs à forte intensité d’émissions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Relèvement inclusif et durable après une catastrophe ; renforcement de la résilience face aux futurs chocs",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=40"
  },
  {
    ID: 494,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Commerce",
    Title: "Les plans d’action en faveur de l’égalité des genres adoptés favorisent la mise en place d’infrastructures inclusives de contrôle de la qualité pour le commerce",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=43"
  },
  {
    ID: 495,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Commerce",
    Title: "Accélération de la dématérialisation du commerce",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=44"
  },
  {
    ID: 496,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Commerce",
    Title: "Amélioration de la transparence et de la traçabilité des chaînes de valeur dans les secteurs critiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=44"
  },
  {
    ID: 497,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Commerce",
    Title: "Les normes de qualité des produits agricoles sont révisées en vue de réduire les pertes et le gaspillage de denrées alimentaires",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=45"
  },
  {
    ID: 498,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Forêts et industrie forestière",
    Title: "Meilleure intégration des solutions de foresterie urbaine durables dans la planification nationale",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=48"
  },
  {
    ID: 499,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Forêts et industrie forestière",
    Title: "Planification et action fondées sur des données probantes au service de la production et de la consommation durables des produits forestiers",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=49"
  },
  {
    ID: 500,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Forêts et industrie forestière",
    Title: "Amélioration de l’accès aux données sur les forêts et l’industrie forestière",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=50"
  },
  {
    ID: 501,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Forêts et industrie forestière",
    Title: "Planification prospective au service d’une industrie forestière résiliente et durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=50"
  },
  {
    ID: 502,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Logement, aménagement du territoire et population",
    Title: "Les États membres s’engagent à promouvoir des logements abordables et durables",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=53"
  },
  {
    ID: 503,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Logement, aménagement du territoire et population",
    Title: "Des politiques plus inclusives, qui tiennent davantage compte de l’âge, permettant de saisir les possibilités offertes par le vieillissement des personnes et de la population et de faire face aux problèmes qu’il pose",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=54"
  },
  {
    ID: 504,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Logement, aménagement du territoire et population",
    Title: "Accélération de la territorialisation des objectifs de développement durable par les autorités locales et régionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=54"
  },
  {
    ID: 505,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Commission économique pour l'Europe",
    Programme: "Développement économique en Europe",
    Subprogramme: "Logement, aménagement du territoire et population",
    Title: "Cadre politique régional anticipatif sur le vieillissement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=fr#page=55"
  },
  {
    ID: 506,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Commerce international, intégration et infrastructures",
    Title: "Mise en place d’un tableau d’entrées-sorties régional destiné à éclairer l’élaboration de politiques fondées sur des données d’observation en Amérique latine et dans les Caraïbes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=18"
  },
  {
    ID: 507,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Commerce international, intégration et infrastructures",
    Title: "Renforcement de la coordination des politiques en matière de commerce de denrées alimentaires durable et résilient, de systèmes de transport et de logistique pour une meilleure sécurité alimentaire à l’échelle régionale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=18"
  },
  {
    ID: 508,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Commerce international, intégration et infrastructures",
    Title: "Politiques favorisant l’intégration physique complète et accessible et améliorant les infrastructures, les transports et la logistique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=19"
  },
  {
    ID: 509,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Commerce international, intégration et infrastructures",
    Title: "Diversification des exportations des États membres grâce à l’augmentation des exportations de services fournis par voie numérique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=20"
  },
  {
    ID: 510,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Production et innovation",
    Title: "Meilleure prise en compte des questions de genre dans les politiques territoriales de développement productif",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UY",
    Image: "21ECLAC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=24"
  },
  {
    ID: 511,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Production et innovation",
    Title: "Multiplication et renforcement des initiatives groupées et d’autres initiatives d’articulation productive territoriale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=24"
  },
  {
    ID: 512,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Production et innovation",
    Title: "Amélioration des politiques de développement productif visant à stimuler la croissance de la productivité dans les secteurs clés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=25"
  },
  {
    ID: 513,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Production et innovation",
    Title: "Politiques de développement productif favorisant des appareils productifs plus sophistiqués et plus diversifiés et une transformation structurelle au service de l’égalité",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=26"
  },
  {
    ID: 514,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Politiques macroéconomiques et croissance",
    Title: "Le Costa Rica encourage le développement des contrats à impact social afin de renforcer la mobilisation des ressources intérieures",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR",
    Image: "21ECLAC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=29"
  },
  {
    ID: 515,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Politiques macroéconomiques et croissance",
    Title: "Politiques macroéconomiques et politiques de financement du développement favorisant la croissance économique, les investissements, la viabilité budgétaire et la résilience climatique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=29"
  },
  {
    ID: 516,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Politiques macroéconomiques et croissance",
    Title: "Renforcement de l’élaboration des politiques en matière de dépenses fiscales en faveur de la réalisation des objectifs de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=30"
  },
  {
    ID: 517,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Politiques macroéconomiques et croissance",
    Title: "Renforcement de la mobilisation des ressources publiques intérieures conformément aux objectifs de l’Engagement de Séville",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=31"
  },
  {
    ID: 518,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Développement social et égalité sociale",
    Title: "Le Paraguay met en place le registre social des ménages, contribuant ainsi à renforcer son système de protection sociale",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PY",
    Image: "21ECLAC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=33"
  },
  {
    ID: 519,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Développement social et égalité sociale",
    Title: "Élargissement des systèmes de protection sociale aux travailleurs du secteur informel et aux travailleurs indépendants",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=34"
  },
  {
    ID: 520,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Développement social et égalité sociale",
    Title: "Amélioration des politiques en faveur de l’inclusion professionnelle tenant compte des effets des changements climatiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=35"
  },
  {
    ID: 521,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Développement social et égalité sociale",
    Title: "Conception de moyens d’action intersectoriels en faveur de l’inclusion et de la transformation numériques visant à réduire les inégalités",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=35"
  },
  {
    ID: 522,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Égalité des genres et autonomie des femmes",
    Title: "Une décennie d’action en vue d’une égalité effective des genres et de l’édification d’une société du soin",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=38"
  },
  {
    ID: 523,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Égalité des genres et autonomie des femmes",
    Title: "Progrès dans la production de statistiques genrées sur les budgets-temps et les soins non rémunérés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=38"
  },
  {
    ID: 524,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Égalité des genres et autonomie des femmes",
    Title: "Prise en compte des questions de genre dans les politiques étrangères et la coopération internationale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=39"
  },
  {
    ID: 525,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Égalité des genres et autonomie des femmes",
    Title: "Les pays évaluent les retombées des investissements dans les politiques de soins",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=40"
  },
  {
    ID: 526,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Population et développement",
    Title: "L’État plurinational de Bolivie publie les résultats de son recensement de la population et des logements",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BO",
    Image: "21ECLAC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=43"
  },
  {
    ID: 527,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Population et développement",
    Title: "Renforcement de l’analyse démographique au service des politiques publiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=43"
  },
  {
    ID: 528,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Population et développement",
    Title: "Mise en œuvre au niveau national du Plan d’action international de Madrid sur le vieillissement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=44"
  },
  {
    ID: 529,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Population et développement",
    Title: "Les pays établissent leurs propres estimations et projections actualisées concernant la population et la population active",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=45"
  },
  {
    ID: 530,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Développement durable et établissements humains",
    Title: "Renforcement des systèmes d’évaluation de l’impact environnemental en Amérique latine",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=48"
  },
  {
    ID: 531,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Développement durable et établissements humains",
    Title: "Élaboration de stratégies sur les modes de consommation et de production durables, y compris l’économie circulaire, visant à améliorer la performance environnementale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=49"
  },
  {
    ID: 532,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Développement durable et établissements humains",
    Title: "Amélioration des simulations des effets possibles des changements climatiques afin que les lignes d’action et les choix d’investissement soient définis en bonne connaissance de cause",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=50"
  },
  {
    ID: 533,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Développement durable et établissements humains",
    Title: "Élaboration d’objectifs nationaux prioritaires sur la base d’un cadre commun pour la mise en œuvre de l’Accord d’Escazú",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=50"
  },
  {
    ID: 534,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Ressources naturelles",
    Title: "Renforcement du dialogue politique et de la gouvernance régionale dans le secteur minier",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=53"
  },
  {
    ID: 535,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Ressources naturelles",
    Title: "Fourniture, par les pays de la région, de minéraux essentiels à la transition énergétique, une attention accrue étant portée à la durabilité économique, sociale et environnementale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=54"
  },
  {
    ID: 536,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Ressources naturelles",
    Title: "Nouvelles initiatives visant à promouvoir la transition énergétique en Amérique latine et dans les Caraïbes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=54"
  },
  {
    ID: 537,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Ressources naturelles",
    Title: "Renforcement de la gouvernance de l’océan et des politiques connexes visant à favoriser l’exploitation et la gestion durables de l’océan dans la région",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=55"
  },
  {
    ID: 538,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Planification et administration publique au service du développement",
    Title: "Adoption du Programme régional sur la gouvernance de la planification et de la gestion publique du développement durable en Amérique latine et dans les Caraïbes, destiné à orienter la planification stratégique à long terme",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=58"
  },
  {
    ID: 539,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Planification et administration publique au service du développement",
    Title: "Politiques de développement intégrées pour la construction de territoires plus résilients et, partant, l’accélération de la mise en œuvre du Programme 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=59"
  },
  {
    ID: 540,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Planification et administration publique au service du développement",
    Title: "Amélioration des capacités techniques, opérationnelles, politiques et prospectives des institutions publiques en vue de gérer les transformations et de relever des défis complexes dans des environnements en constante évolution",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=59"
  },
  {
    ID: 541,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Planification et administration publique au service du développement",
    Title: "Les États membres élaborent des plans de développement nationaux et infranationaux à long terme qui intègrent les quatre domaines stratégiques du Programme régional sur la gouvernance de la planification et de la gestion publique du développement durable en Amérique latine et dans les Caraïbes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=60"
  },
  {
    ID: 542,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Statistiques",
    Title: "Des données de meilleure qualité pour éclairer les politiques en matière de pauvreté, d’inégalités, d’emploi, d’éducation et de conditions de vie",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=63"
  },
  {
    ID: 543,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Statistiques",
    Title: "Renforcement de la mise en œuvre du Cadre intégré des Nations Unies pour l’information géospatiale au niveau national",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=64"
  },
  {
    ID: 544,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Statistiques",
    Title: "Meilleure utilisation des registres administratifs au profit de la production de statistiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=65"
  },
  {
    ID: 545,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Statistiques",
    Title: "Modernisation des systèmes statistiques nationaux destinés à mesurer l’activité économique dans les pays d’Amérique latine et des Caraïbes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=65"
  },
  {
    ID: 546,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Activités sous-régionales en Amérique centrale, à Cuba, en Haïti, au Mexique et en République dominicaine",
    Title: "Les pays renforcent un développement productif fondé sur les chaînes de valeur",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=68"
  },
  {
    ID: 547,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Activités sous-régionales en Amérique centrale, à Cuba, en Haïti, au Mexique et en République dominicaine",
    Title: "Accélération de la mise en œuvre des objectifs de développement durable par la correction de lacunes structurelles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=69"
  },
  {
    ID: 548,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Activités sous-régionales en Amérique centrale, à Cuba, en Haïti, au Mexique et en République dominicaine",
    Title: "Amélioration de la gouvernance anticipative en vue d’éclairer l’élaboration des politiques dans la sous-région",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=70"
  },
  {
    ID: 549,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Activités sous-régionales en Amérique centrale, à Cuba, en Haïti, au Mexique et en République dominicaine",
    Title: "Amélioration des stratégies publiques visant à favoriser le développement productif dans certaines régions et certains secteurs au niveau infranational",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=70"
  },
  {
    ID: 550,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Activités sous-régionales dans les Caraïbes",
    Title: "Élaboration d’une stratégie intégrée de gestion des ressources naturelles consacrée aux algues sargasses dans les Caraïbes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=73"
  },
  {
    ID: 551,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Activités sous-régionales dans les Caraïbes",
    Title: "Inclusion numérique dans les Caraïbes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=73"
  },
  {
    ID: 552,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Activités sous-régionales dans les Caraïbes",
    Title: "Intégration du Programme d’Antigua-et-Barbuda pour les petits États insulaires en développement dans les processus et programmes nationaux de développement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=74"
  },
  {
    ID: 553,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Activités sous-régionales dans les Caraïbes",
    Title: "Diversification économique grâce au renforcement de la coopération Sud-Sud avec les économies d’Amérique latine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement de la coopération et des partenariats, amélioration de la cohérence et des synergies et réduction des chevauchements grâce à une communication constante",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=75"
  },
  {
    ID: 554,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Appui aux mécanismes et organismes de coopération et d’intégration régionales et sous-régionales",
    Title: "Consensus régional sur la mesure du développement durable au-delà du produit intérieur brut",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement de la coopération et des partenariats, amélioration de la cohérence et des synergies et réduction des chevauchements grâce à une communication constante",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=78"
  },
  {
    ID: 555,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Appui aux mécanismes et organismes de coopération et d’intégration régionales et sous-régionales",
    Title: "Renforcement des initiatives multipartites dans le cadre de la coopération Sud-Sud et de la coopération triangulaire",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=79"
  },
  {
    ID: 556,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Appui aux mécanismes et organismes de coopération et d’intégration régionales et sous-régionales",
    Title: "Les pays d’Amérique latine et des Caraïbes se concertent avec des acteurs extrarégionaux au sujet de la coopération Sud-Sud et de la coopération triangulaire",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=80"
  },
  {
    ID: 557,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Commission économique pour l'Amérique latine et les Caraïbes",
    Programme: "Développement économique et social en Amérique latine et dans les Caraïbes",
    Subprogramme: "Appui aux mécanismes et organismes de coopération et d’intégration régionales et sous-régionales",
    Title: "Renforcement de la coopération Sud-Sud et de la coopération triangulaire ainsi que de l’intégration régionale, conformément à l’Engagement de Séville",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d’Amérique latine et des Caraïbes",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=fr#page=80"
  },
  {
    ID: 558,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Changements climatiques et durabilité des ressources naturelles",
    Title: "Les pays arabes les moins avancés opèrent la transition vers des systèmes énergétiques fiables, durables et modernes, à un coût abordable, grâce à la mise en œuvre d’outils financiers et de modèles économiques visant à atténuer les risques",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=12"
  },
  {
    ID: 559,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Changements climatiques et durabilité des ressources naturelles",
    Title: "Une transition vers des systèmes alimentaires durables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Renforcement des cadres réglementaires et de la gouvernance environnementale ; intensification de l’action climatique en faveur du développement durable",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "22ESCWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=13"
  },
  {
    ID: 560,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Changements climatiques et durabilité des ressources naturelles",
    Title: "Les États membres définissent des mesures prioritaires communes de lutte contre les tempêtes de sable et de poussière",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Relèvement inclusif et durable après une catastrophe ; renforcement de la résilience face aux futurs chocs",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=14"
  },
  {
    ID: 561,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Changements climatiques et durabilité des ressources naturelles",
    Title: "Amélioration de la résilience des bassins d’eaux de surface et d’eaux souterraines dans la région arabe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Climat et environnement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=14"
  },
  {
    ID: 562,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Justice de genre, populations et développement inclusif",
    Title: "Les jeunes de la région arabe ont accès à des possibilités d’emploi",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=18"
  },
  {
    ID: 563,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Justice de genre, populations et développement inclusif",
    Title: "Les États membres adoptent une approche multidimensionnelle de la réduction de la pauvreté",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Renforcement de la capacité à rendre compte des progrès accomplis dans la réalisation des ODD ; amélioration, en nombre et en qualité, des examens nationaux volontaires",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=18"
  },
  {
    ID: 564,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Justice de genre, populations et développement inclusif",
    Title: "Les États membres utilisent l’apprentissage automatique pour prévoir les besoins budgétaires en matière de programmation de l’aide sociale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=19"
  },
  {
    ID: 565,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Justice de genre, populations et développement inclusif",
    Title: "Les États membres définissent et mettent en œuvre des mesures prioritaires visant à favoriser l’autonomisation économique des personnes handicapées",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Réalisation d’un développement plus inclusif permettant de ne laisser personne de côté ; élimination de la pauvreté et réduction des inégalités ; réduction de la discrimination à l’égard des femmes et des filles et renforcement de l’égalité des genres",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=20"
  },
  {
    ID: 566,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Prospérité économique partagée",
    Title: "La Jordanie et la Tunisie ont élaboré des politiques macrobudgétaires visant à améliorer le financement du secteur social et la viabilité budgétaire",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=23"
  },
  {
    ID: 567,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Prospérité économique partagée",
    Title: "L’amélioration de la soutenabilité de la dette permet d’accroître l’investissement dans les priorités de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration des informations sur les populations, les migrations, l’enregistrement des faits d’état civil et la démographie, notamment les statistiques ventilées par sexe",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=24"
  },
  {
    ID: 568,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Prospérité économique partagée",
    Title: "Les États membres signent des accords commerciaux bilatéraux extrarégionaux",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Secteur privé, y compris les microentreprises et les petites et moyennes entreprises",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=24"
  },
  {
    ID: 569,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Prospérité économique partagée",
    Title: "Les pays arabes réalisent des études d’impact macroéconomiques pour la diversification économique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=25"
  },
  {
    ID: 570,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Statistiques, société de l’information et technologie",
    Title: "Renforcement des comptes nationaux dans la région arabe pour une élaboration de politiques fondées sur des données probantes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=28"
  },
  {
    ID: 571,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Statistiques, société de l’information et technologie",
    Title: "Les données géostatistiques améliorent la prise de décisions et la planification du développement dans la région arabe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=29"
  },
  {
    ID: 572,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Statistiques, société de l’information et technologie",
    Title: "Les États membres arabes, y compris les pays classés dans la catégorie des pays les moins avancés, produisent des statistiques sur le commerce extérieur",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration des indicateurs de mesure et des statistiques à l’appui de politiques de développement durable fondées sur des données probantes",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=29"
  },
  {
    ID: 573,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Statistiques, société de l’information et technologie",
    Title: "Les décideurs politiques utilisent la plateforme régionale intégrée de données pour élaborer des politiques fondées sur des données probantes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=30"
  },
  {
    ID: 574,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Coordination de l’action relative au Programme 2030 et aux objectifs de développement durable",
    Title: "Les États membres s’accordent sur une position commune en vue de négocier la déclaration politique du deuxième Sommet mondial pour le développement social",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=34"
  },
  {
    ID: 575,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Coordination de l’action relative au Programme 2030 et aux objectifs de développement durable",
    Title: "Le secteur privé investit davantage dans les priorités régionales et nationales en matière de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Approfondissement de la compréhension des besoins financiers, amélioration des solutions envisagées pour assurer le financement de dépenses d’équipement durables et engagement accru en faveur du financement des projets durables",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=35"
  },
  {
    ID: 576,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Coordination de l’action relative au Programme 2030 et aux objectifs de développement durable",
    Title: "Les États membres corrigent les lacunes mises en évidence en matière de politiques publiques liées à la mise en œuvre du Programme 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=35"
  },
  {
    ID: 577,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Coordination de l’action relative au Programme 2030 et aux objectifs de développement durable",
    Title: "Une perspective régionale permet de définir des solutions de développement régional à moyen et à long terme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=36"
  },
  {
    ID: 578,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Gouvernance et prévention des conflits",
    Title: "Oman met en œuvre une planification du développement local fondée sur des données factuelles",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "OM",
    Image: "22ESCWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=39"
  },
  {
    ID: 579,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Gouvernance et prévention des conflits",
    Title: "Les systèmes d’administration publique se modernisent pour une gouvernance publique efficace et transparente et pour le développement socioéconomique",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Renforcement des institutions, état de droit et prévention des conflits",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=39"
  },
  {
    ID: 580,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Gouvernance et prévention des conflits",
    Title: "Les États membres élaborent et appliquent des politiques de développement résilientes face à la fragilité et aux chocs soudains",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=40"
  },
  {
    ID: 581,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Commission économique et sociale pour l'Asie occidentale",
    Programme: "Développement économique et social en Asie occidentale",
    Subprogramme: "Gouvernance et prévention des conflits",
    Title: "Renforcement de la gouvernance en matière de concurrence pour des marchés transparents et inclusifs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: "États Membres d’Europe, d’Asie centrale et d’Asie occidentale",
    SpecificResult: "Amélioration du commerce et de la compétitivité par le renforcement des capacités et par la réduction des obstacles dans ce domaine, notamment grâce au commerce électronique et à l’économie numérique",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=fr#page=41"
  },
  {
    ID: 582,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Intégration des droits humains",
    Title: "Intégration des normes et règles relatives aux droits humains dans les analyses communes de pays et les plans-cadres de coopération des Nations Unies pour le développement durable",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=18"
  },
  {
    ID: 583,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Intégration des droits humains",
    Title: "Les normes internationales relatives aux droits humains concernant les droits économiques, sociaux et culturels sont prises en compte lors de l’établissement des budgets des États",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=19"
  },
  {
    ID: 584,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Intégration des droits humains",
    Title: "Renforcement de la promotion et de la protection des droits humains dans les politiques et pratiques nationales grâce à la plateforme de connaissances sur les droits économiques, sociaux et culturels",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=20"
  },
  {
    ID: 585,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Intégration des droits humains",
    Title: "Les États Membres adoptent des lois antiterroristes et les mesures d’application y afférentes qui sont conformes aux droits énoncés dans la Déclaration universelle des droits de l’homme et aux obligations qui leur incombent au titre du droit international des droits humains, et qui sont mises en œuvre dans le plein respect de ces droits et de ces obligations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=21"
  },
  {
    ID: 586,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Droit au développement",
    Title: "Les États Membres et les autres parties prenantes sont en mesure de mettre en œuvre le droit au développement dans le cadre de la réalisation des objectifs de développement durable",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=23"
  },
  {
    ID: 587,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Droit au développement",
    Title: "Politiques et pratiques de lutte contre la corruption visant à remédier aux effets négatifs de la corruption sur la jouissance des droits humains",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=24"
  },
  {
    ID: 588,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Droit au développement",
    Title: "Renforcement de la promotion et de la protection du droit au développement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=25"
  },
  {
    ID: 589,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Droit au développement",
    Title: "Promotion accrue du droit au développement aux niveaux régional et national",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "PMA, PDSL, PEID et autres pays en développement",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=26"
  },
  {
    ID: 590,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Recherche et analyse",
    Title: "Les États Membres encouragent l’adoption de lois, de politiques et de pratiques relatives à la drogue qui soient compatibles avec le droit international des droits humains",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CO,PK",
    Image: "24UHCHR9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=29"
  },
  {
    ID: 591,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Recherche et analyse",
    Title: "Les jeunes défenseurs des droits humains membres d’une communauté autochtone, appartenant à une minorité ou d’ascendance africaine approfondissent leur connaissance des droits humains",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=29"
  },
  {
    ID: 592,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Recherche et analyse",
    Title: "Meilleure compréhension par les États Membres et les autres parties prenantes des incidences des technologies numériques sur les droits humains",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=30"
  },
  {
    ID: 593,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Intégration des droits humains, droit au développement et recherche et analyse: Recherche et analyse",
    Title: "Les États Membres adoptent et mettent en œuvre des politiques et des mesures de lutte contre le racisme, fondées sur des données factuelles, qui renforcent l’égalité, la non-discrimination, la tolérance et la jouissance de tous les droits humains",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=31"
  },
  {
    ID: 594,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Appui aux organes créés en vertu d’instruments internationaux relatifs aux droits de l’homme",
    Title: "Adoption accrue par les organes conventionnels de listes de points à traiter et de listes préalables de points à traiter",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=33"
  },
  {
    ID: 595,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Appui aux organes créés en vertu d’instruments internationaux relatifs aux droits de l’homme",
    Title: "Renforcement de la coopération internationale à l’appui des mécanismes nationaux d’application, d’établissement de rapports et de suivi",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=34"
  },
  {
    ID: 596,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Appui aux organes créés en vertu d’instruments internationaux relatifs aux droits de l’homme",
    Title: "Amélioration de l’accès des États Parties et des parties prenantes aux recommandations des organes créés en vertu d’instruments internationaux afin de faciliter leur application",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=35"
  },
  {
    ID: 597,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Appui aux organes créés en vertu d’instruments internationaux relatifs aux droits de l’homme",
    Title: "Un guichet unique permettant d’accéder aux informations concernant les travaux des organes conventionnels",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=36"
  },
  {
    ID: 598,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Services consultatifs, coopération technique et activités hors Siège",
    Title: "Les enquêtes menées à la demande du Conseil des droits de l’homme contribuent aux processus d’application du principe de responsabilité en fournissant des analyses complètes, indépendantes et fondées sur des données factuelles concernant les violations des droits humains et les infractions au droit international humanitaire et au droit international des droits humains",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=40"
  },
  {
    ID: 599,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Services consultatifs, coopération technique et activités hors Siège",
    Title: "Renforcement de l’efficacité des institutions nationales des droits humains conformément aux Principes de Paris",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=41"
  },
  {
    ID: 600,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Services consultatifs, coopération technique et activités hors Siège",
    Title: "Renforcement de la coopération technique pour ce qui est de soutenir les États Membres qui sont membres de la Communauté des Caraïbes dans leurs efforts de promotion, de protection et de réalisation des droits humains",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "États Membres d’Amérique latine et des Caraïbes",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,DM,GD,GY,HT,JM,MS,LC,KN,VC,SR,TT,AI,BM,VG,KY,TC",
    Image: "24UHCHR19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=42"
  },
  {
    ID: 601,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Services consultatifs, coopération technique et activités hors Siège",
    Title: "Les États Membres et les autres parties prenantes prennent des mesures pour remédier aux situations relatives aux droits humains aux niveaux national et régional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=43"
  },
  {
    ID: 602,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Appui au Conseil des droits de l’homme et à ses mécanismes et organes subsidiaires",
    Title: "Efficacité accrue des procédures spéciales aux niveaux mondial, régional et national",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=47"
  },
  {
    ID: 603,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Appui au Conseil des droits de l’homme et à ses mécanismes et organes subsidiaires",
    Title: "Contribution accrue des institutions nationales des droits humains à l’Examen périodique universel",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=48"
  },
  {
    ID: 604,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Appui au Conseil des droits de l’homme et à ses mécanismes et organes subsidiaires",
    Title: "Participation accrue des équipes de pays des Nations Unies à l’Examen périodique universel",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la protection et de l’exercice des droits humains ; réduction des inégalités et des discriminations ; intégration plus poussée du droit au développement",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=48"
  },
  {
    ID: 605,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Appui au Conseil des droits de l’homme et à ses mécanismes et organes subsidiaires",
    Title: "Meilleur accès des personnes handicapées aux travaux du Conseil des droits de l’homme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promotion des droits humains",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=49"
  },
  {
    ID: 606,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Bureau de la Défenseuse des droits des victimes",
    Title: "Mise en œuvre renforcée, dans l’ensemble du système, de la stratégie du Secrétaire général consistant à placer les droits et la dignité des victimes au centre de l’action menée pour prévenir et combattre l’exploitation et les atteintes sexuelles",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Femmes et filles",
    SpecificResult: "Renforcement des mesures de lutte contre l’exploitation et les atteintes sexuelles, le harcèlement sexuel, la fraude et la corruption ; intégration plus systématique d’une approche centrée sur les victimes",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=122"
  },
  {
    ID: 607,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Haut-Commissariat des Nations Unies aux droits de l'homme",
    Programme: "Droits humains",
    Subprogramme: "Bureau de la Défenseuse des droits des victimes",
    Title: "Amélioration du soutien aux victimes grâce à la mise à profit des diverses expériences et des connaissances des spécialistes des droits des victimes dans les contextes du maintien de la paix, de l’aide humanitaire et du développement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promotion des droits humains",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Femmes et filles",
    SpecificResult: "Renforcement des mesures de lutte contre l’exploitation et les atteintes sexuelles, le harcèlement sexuel, la fraude et la corruption ; intégration plus systématique d’une approche centrée sur les victimes",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ET,HT,ML,UA",
    Image: "24UHCHR26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=fr#page=122"
  },
  {
    ID: 608,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Haut-Commissariat des Nations Unies pour les réfugiés",
    Programme: "Réfugiés : protection internationale, solutions durables et assistance",
    Subprogramme: "Réfugiés : protection internationale, solutions durables et assistance",
    Title: "Le Forum mondial sur les réfugiés s’engage à promouvoir le partage des responsabilités et le soutien aux réfugiés et aux communautés d’accueil",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=fr#page=6"
  },
  {
    ID: 609,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Haut-Commissariat des Nations Unies pour les réfugiés",
    Programme: "Réfugiés : protection internationale, solutions durables et assistance",
    Subprogramme: "Réfugiés : protection internationale, solutions durables et assistance",
    Title: "Augmentation de la présence des partenaires nationaux et locaux dans les plans d’intervention en faveur des réfugiés au niveau mondial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=fr#page=7"
  },
  {
    ID: 610,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Haut-Commissariat des Nations Unies pour les réfugiés",
    Programme: "Réfugiés : protection internationale, solutions durables et assistance",
    Subprogramme: "Réfugiés : protection internationale, solutions durables et assistance",
    Title: "Renforcement de la protection des réfugiés et des demandeurs d’asile, qui ont plus facilement accès aux services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=fr#page=8"
  },
  {
    ID: 611,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Haut-Commissariat des Nations Unies pour les réfugiés",
    Programme: "Réfugiés : protection internationale, solutions durables et assistance",
    Subprogramme: "Réfugiés : protection internationale, solutions durables et assistance",
    Title: "Plus grande adhésion aux conventions internationales relatives à l’apatridie",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=fr#page=8"
  },
  {
    ID: 612,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine soient protégés en promouvant la réalisation des droits que leur reconnaît le droit international",
    Title: "Les réfugiés de Palestine en situation de handicap bénéficient d’un meilleur accès aux services de réadaptation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=8"
  },
  {
    ID: 613,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine soient protégés en promouvant la réalisation des droits que leur reconnaît le droit international",
    Title: "Rendre l’accès des réfugiés de Palestine aux services de l’Office plus digne et plus sûr",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=9"
  },
  {
    ID: 614,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine soient protégés en promouvant la réalisation des droits que leur reconnaît le droit international",
    Title: "Renforcer la protection des réfugiés de Palestine contre la violence fondée sur le genre",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Femmes et filles",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=9"
  },
  {
    ID: 615,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine soient protégés en promouvant la réalisation des droits que leur reconnaît le droit international",
    Title: "Améliorer l’efficacité des services sociaux fournis aux réfugiés de Palestine vulnérables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=10"
  },
  {
    ID: 616,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine aient un accès universel à des soins de santé primaires de qualité et un accès ciblé aux soins secondaires et tertiaires, de sorte que leur état de santé s’améliore",
    Title: "Améliorer la maîtrise des maladies non transmissibles parmi les réfugiés de Palestine",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=12"
  },
  {
    ID: 617,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine aient un accès universel à des soins de santé primaires de qualité et un accès ciblé aux soins secondaires et tertiaires, de sorte que leur état de santé s’améliore",
    Title: "Accroître l’accès des réfugiés de Palestine aux soins préconceptionnels et à des services de planification des naissances",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Femmes et filles",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=13"
  },
  {
    ID: 618,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine aient un accès universel à des soins de santé primaires de qualité et un accès ciblé aux soins secondaires et tertiaires, de sorte que leur état de santé s’améliore",
    Title: "Maîtriser les maladies infectieuses parmi les populations de réfugiés de Palestine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=14"
  },
  {
    ID: 619,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine aient un accès universel à des soins de santé primaires de qualité et un accès ciblé aux soins secondaires et tertiaires, de sorte que leur état de santé s’améliore",
    Title: "Assurer un accès durable aux services de santé mentale et de soutien psychosocial pour les réfugiés de Palestine reconnus comme ayant des besoins",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=15"
  },
  {
    ID: 620,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine aient accès à une éducation de qualité, inclusive et équitable",
    Title: "Poursuite de la scolarisation des enfants réfugiés de Palestine dans l’enseignement primaire",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=16"
  },
  {
    ID: 621,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine aient accès à une éducation de qualité, inclusive et équitable",
    Title: "Rendre plus sûr et plus inclusif l’environnement d’apprentissage des élèves inscrits dans les écoles de l’Office",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=17"
  },
  {
    ID: 622,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine aient accès à une éducation de qualité, inclusive et équitable",
    Title: "Protéger le développement social et émotionnel des enfants réfugiés de Palestine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=18"
  },
  {
    ID: 623,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine aient accès à une éducation de qualité, inclusive et équitable",
    Title: "Généralisation de l’apprentissage mixte et adapté dans l’ensemble des zones d’opération de l’UNRWA",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=19"
  },
  {
    ID: 624,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine aient accès durablement à des emplois décents et à des sources de revenus, plus nombreux, si possible, grâce au savoir-faire qu’ils ont acquis, à l’apport d’une aide aux entreprises et à un accès équitable aux marchés du travail",
    Title: "Créer des possibilités d’emploi grâce à des travaux d’amélioration des infrastructures et d’aménagement des camps",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=21"
  },
  {
    ID: 625,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine aient accès durablement à des emplois décents et à des sources de revenus, plus nombreux, si possible, grâce au savoir-faire qu’ils ont acquis, à l’apport d’une aide aux entreprises et à un accès équitable aux marchés du travail",
    Title: "Créer des perspectives d’emploi dans le secteur privé",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=22"
  },
  {
    ID: 626,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine aient accès durablement à des emplois décents et à des sources de revenus, plus nombreux, si possible, grâce au savoir-faire qu’ils ont acquis, à l’apport d’une aide aux entreprises et à un accès équitable aux marchés du travail",
    Title: "Améliorer les possibilités d’emploi des jeunes grâce à la formation professionnelle",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=22"
  },
  {
    ID: 627,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine aient accès durablement à des emplois décents et à des sources de revenus, plus nombreux, si possible, grâce au savoir-faire qu’ils ont acquis, à l’apport d’une aide aux entreprises et à un accès équitable aux marchés du travail",
    Title: "Élargissement de l’accès aux services financiers inclusifs pour les femmes réfugiées de Palestine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Femmes et filles",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=23"
  },
  {
    ID: 628,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine aient accès à des infrastructures offrant des services de base et des services publics dans des camps où sécurité et durabilité sont assurées et où santé et dignité sont préservées",
    Title: "Réduction des risques sanitaires liés à l’eau et à l’assainissement pour les réfugiés de Palestine vivant dans les camps",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=26"
  },
  {
    ID: 629,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine aient accès à des infrastructures offrant des services de base et des services publics dans des camps où sécurité et durabilité sont assurées et où santé et dignité sont préservées",
    Title: "Promouvoir la sécurité et la dignité des réfugiés de Palestine qui vivent dans des camps",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=27"
  },
  {
    ID: 630,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine aient accès à des infrastructures offrant des services de base et des services publics dans des camps où sécurité et durabilité sont assurées et où santé et dignité sont préservées",
    Title: "Améliorer la qualité de l’eau pour les réfugiés de Palestine",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=27"
  },
  {
    ID: 631,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine aient accès à des infrastructures offrant des services de base et des services publics dans des camps où sécurité et durabilité sont assurées et où santé et dignité sont préservées",
    Title: "Améliorer les conditions de vie des réfugiés de Palestine résidant dans des camps",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=28"
  },
  {
    ID: 632,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine les plus vulnérables bénéficient d’une assistance sociale plus efficace et mieux ciblée",
    Title: "Améliorer l’accès à l’emploi pour les jeunes réfugiés de Palestine vulnérables",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=30"
  },
  {
    ID: 633,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine les plus vulnérables bénéficient d’une assistance sociale plus efficace et mieux ciblée",
    Title: "Garantir l’accès à des soins hospitaliers abordables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=30"
  },
  {
    ID: 634,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine les plus vulnérables bénéficient d’une assistance sociale plus efficace et mieux ciblée",
    Title: "Protéger les transferts sociaux destinés aux réfugiés de Palestine les plus vulnérables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=31"
  },
  {
    ID: 635,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Faire en sorte que les réfugiés de Palestine les plus vulnérables bénéficient d’une assistance sociale plus efficace et mieux ciblée",
    Title: "Améliorer la résilience des ménages bénéficiaires de transferts sociaux",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=32"
  },
  {
    ID: 636,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine soient correctement enregistrés et à ce que les informations sur leur statut soient conservées en sécurité",
    Title: "Les dossiers familiaux historiques sont conservés en sécurité grâce à la numérisation à grande échelle",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,LU,PS,SY",
    Image: "26UNRWA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=33"
  },
  {
    ID: 637,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Office de secours et de travaux des Nations Unies pour les réfugiés de Palestine dans le Proche-Orient",
    Programme: "Réfugiés de Palestine",
    Subprogramme: "Veiller à ce que les réfugiés de Palestine soient correctement enregistrés et à ce que les informations sur leur statut soient conservées en sécurité",
    Title: "Les réfugiés de Palestine enregistrés bénéficient d’un meilleur accès numérique à leurs dossiers et aux services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la protection des droits des réfugiés, amélioration de leurs conditions de vie, en particulier sur le plan de la santé et de l’éducation, et amélioration de la réactivité et du partage du fardeau",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=fr#page=34"
  },
  {
    ID: 638,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Analyse des politiques",
    Title: "Des consultations menées par les acteurs locaux ont aidé à déterminer les priorités, le financement et la préparation de l’action humanitaire",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,PH,SO",
    Image: "27OCHA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=9"
  },
  {
    ID: 639,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Analyse des politiques",
    Title: "Participation plus active des populations à l’action humanitaire de sorte que la réponse apportée à leurs besoins soit plus efficace",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,NE,PH,SS,II,SO",
    Image: "27OCHA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=10"
  },
  {
    ID: 640,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Analyse des politiques",
    Title: "Amélioration de l’apprentissage collectif grâce à l’intégration des perspectives locales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=10"
  },
  {
    ID: 641,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Analyse des politiques",
    Title: "Des interventions humanitaires plus efficaces et plus structurées pour les populations touchées",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=11"
  },
  {
    ID: 642,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Coordination de l’action humanitaire et des interventions d’urgence",
    Title: "Atteindre les personnes dans le besoin malgré de graves déficits de financement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=14"
  },
  {
    ID: 643,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Coordination de l’action humanitaire et des interventions d’urgence",
    Title: "Participation plus active des acteurs locaux et nationaux aux mécanismes de coordination de l’action humanitaire",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=14"
  },
  {
    ID: 644,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Coordination de l’action humanitaire et des interventions d’urgence",
    Title: "Renforcement des stratégies d’anticipation et des systèmes d’alerte précoce et d’action rapide",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=15"
  },
  {
    ID: 645,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Coordination de l’action humanitaire et des interventions d’urgence",
    Title: "Renforcement de l’action diplomatique menée à l’échelle du système pour défendre les principes humanitaires, garantir l’accès humanitaire et protéger les civils",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=16"
  },
  {
    ID: 646,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Services d’appui d’urgence",
    Title: "Renforcement de l’intervention internationale en cas d’urgence grâce à des orientations actualisées",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=19"
  },
  {
    ID: 647,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Services d’appui d’urgence",
    Title: "Des partenariats avec le secteur privé renforcés dans le cadre d’une action humanitaire collective",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SD,QQ,SB",
    Image: "27OCHA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=19"
  },
  {
    ID: 648,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Services d’appui d’urgence",
    Title: "Les personnes touchées par la crise ont reçu une aide humanitaire d’urgence au lendemain d’une catastrophe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=20"
  },
  {
    ID: 649,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Services d’appui d’urgence",
    Title: "Amélioration de la capacité d’intervention mondiale des équipes de recherche et de sauvetage en milieu urbain",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=21"
  },
  {
    ID: 650,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Information et mobilisation dans les situations d’urgence humanitaire",
    Title: "Les populations touchées par des crises ont bénéficié d’interventions humanitaires fondées sur des données",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=23"
  },
  {
    ID: 651,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Information et mobilisation dans les situations d’urgence humanitaire",
    Title: "Des services de réseau et de connexion fiables pour les intervenants humanitaires",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=24"
  },
  {
    ID: 652,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Information et mobilisation dans les situations d’urgence humanitaire",
    Title: "Amélioration de l’accès aux données et informations essentielles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la cohérence, de la rapidité, de l’efficacité et de la portée des interventions humanitaires ; réduction sensible des risques de catastrophe",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=25"
  },
  {
    ID: 653,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Bureau de la coordination des affaires humanitaires",
    Programme: "Aide humanitaire",
    Subprogramme: "Information et mobilisation dans les situations d’urgence humanitaire",
    Title: "Meilleure sensibilisation du public aux crises humanitaires",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=25"
  },
  {
    ID: 654,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Bureau des Nations Unies pour la prévention des catastrophes",
    Programme: "Aide humanitaire",
    Subprogramme: "Bureau des Nations Unies pour la réduction des risques de catastrophe",
    Title: "Les États Membres et les parties prenantes évaluent les progrès accomplis dans la mise en œuvre du Cadre de Sendai et émettent des recommandations pour le renforcement de la réduction des risques de catastrophe",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Relèvement inclusif et durable après une catastrophe ; renforcement de la résilience face aux futurs chocs",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=47"
  },
  {
    ID: 655,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Bureau des Nations Unies pour la prévention des catastrophes",
    Programme: "Aide humanitaire",
    Subprogramme: "Bureau des Nations Unies pour la réduction des risques de catastrophe",
    Title: "Renforcement des systèmes d’alerte précoce multidangers qui profitent aux plus vulnérables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Relèvement inclusif et durable après une catastrophe ; renforcement de la résilience face aux futurs chocs",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=47"
  },
  {
    ID: 656,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Bureau des Nations Unies pour la prévention des catastrophes",
    Programme: "Aide humanitaire",
    Subprogramme: "Bureau des Nations Unies pour la réduction des risques de catastrophe",
    Title: "Mise en place de stratégies nationales de financement de la réduction des risques de catastrophe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Relèvement inclusif et durable après une catastrophe ; renforcement de la résilience face aux futurs chocs",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=48"
  },
  {
    ID: 657,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Bureau des Nations Unies pour la prévention des catastrophes",
    Programme: "Aide humanitaire",
    Subprogramme: "Bureau des Nations Unies pour la réduction des risques de catastrophe",
    Title: "Évaluation, renforcement et institutionnalisation de l’action menée par les gouvernements pour préparer un relèvement résilient intégrant le principe « reconstruire en mieux »",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Efficacité de la coordination des opérations d’assistance humanitaire et appui en faveur des réfugiés",
    Beneficiary: "Administration publique",
    BeneficiaryTwo: " ",
    SpecificResult: "Relèvement inclusif et durable après une catastrophe ; renforcement de la résilience face aux futurs chocs",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=fr#page=49"
  },
  {
    ID: 658,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services relatifs aux campagnes et aux opérations dans les pays",
    Title: "Renforcement de la mobilisation du public sur les questions prioritaires de l’ONU",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=7"
  },
  {
    ID: 659,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services relatifs aux campagnes et aux opérations dans les pays",
    Title: "Intensification de l’action menée pour réaliser le Programme de développement durable à l’horizon 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=7"
  },
  {
    ID: 660,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services relatifs aux campagnes et aux opérations dans les pays",
    Title: "Meilleure compréhension et mobilisation accrue du public à l’égard des questions essentielles liées aux objectifs de développement durable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la coopération et multiplication des échanges d’informations et de meilleures pratiques au service de la réalisation des ODD",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=8"
  },
  {
    ID: 661,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services relatifs aux campagnes et aux opérations dans les pays",
    Title: "Accès élargi aux documents de sensibilisation et aux messages sur les questions prioritaires",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la coopération et des partenariats, amélioration de la cohérence et des synergies et réduction des chevauchements grâce à une communication constante",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=9"
  },
  {
    ID: 662,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services d’information",
    Title: "Augmentation de l’audience de la couverture médiatique offerte par l’ONU",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=11"
  },
  {
    ID: 663,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services d’information",
    Title: "Augmentation de l’intérêt du public à l’aide de formats et d’outils de blog en direct",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=12"
  },
  {
    ID: 664,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services d’information",
    Title: "Augmentation de l’intérêt et du soutien du public à l’égard des célébrations internationales organisées par l’ONU",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=12"
  },
  {
    ID: 665,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services d’information",
    Title: "Accès amélioré et rapide à ONU Info à l’échelle mondiale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=13"
  },
  {
    ID: 666,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services de diffusion et de partage du savoir",
    Title: "Renforcement du soutien et de l’action au niveau mondial en faveur des travaux de l’Organisation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement de la coopération et des partenariats, amélioration de la cohérence et des synergies et réduction des chevauchements grâce à une communication constante",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=15"
  },
  {
    ID: 667,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services de diffusion et de partage du savoir",
    Title: "Les jeunes journalistes ont accès aux travaux de l’ONU et en ont une meilleure compréhension",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement de la coopération et des partenariats, amélioration de la cohérence et des synergies et réduction des chevauchements grâce à une communication constante",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=16"
  },
  {
    ID: 668,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services de diffusion et de partage du savoir",
    Title: "Progression vers les objectifs de développement durable grâce aux établissements d’enseignement supérieur",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Développement durable",
    Beneficiary: "Jeunes",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Renforcement de la coopération et des partenariats, amélioration de la cohérence et des synergies et réduction des chevauchements grâce à une communication constante",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=17"
  },
  {
    ID: 669,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Département de la communication globale",
    Programme: "Communication globale",
    Subprogramme: "Services de diffusion et de partage du savoir",
    Title: "Augmentation du nombre de visiteurs au Siège de l’Organisation grâce à des visites guidées thématiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Communauté internationale",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=fr#page=18"
  },
  {
    ID: 670,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Progiciel de gestion intégré",
    Title: "Umoja, un levier de transformation numérique au service d’une efficience accrue et d’une prise de décision plus efficace",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=10"
  },
  {
    ID: 671,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Progiciel de gestion intégré",
    Title: "Production d’informations exploitables sur la base de données tirées de NextGen Umoja Analytics",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=10"
  },
  {
    ID: 672,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Progiciel de gestion intégré",
    Title: "Facilitation de la prise de décisions grâce aux améliorations apportées aux portails des États Membres",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=11"
  },
  {
    ID: 673,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Progiciel de gestion intégré",
    Title: "Mise en service du progiciel de gestion intégré de nouvelle génération (NextGen ERP)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=12"
  },
  {
    ID: 674,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination",
    Title: "Appui au bon déroulement des travaux de la Cinquième Commission grâce à des informations plus complètes et à des rapports rationalisés",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=14"
  },
  {
    ID: 675,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination",
    Title: "Meilleur accès à l’information, notamment à l’information d’avant-session, pour les membres de la Cinquième Commission et du Comité du programme et de la coordination",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=14"
  },
  {
    ID: 676,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination",
    Title: "Des procédures simplifiées et rationalisées et des services de meilleure qualité pour les participantes et participants aux séances et réunions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=15"
  },
  {
    ID: 677,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination",
    Title: "Renforcement des services d’appui concernant les processus liés aux élections et aux nominations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=16"
  },
  {
    ID: 678,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Services consultatifs de gestion",
    Title: "Traitement rapide des demandes de contrôle hiérarchique",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=18"
  },
  {
    ID: 679,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Services consultatifs de gestion",
    Title: "Intégration du système de gestion de la résilience institutionnelle dans les entités des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=19"
  },
  {
    ID: 680,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Services consultatifs de gestion",
    Title: "Recommandations du Comité des marchés du Siège acceptées par les fonctionnaires habilités",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=19"
  },
  {
    ID: 681,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Progiciel de gestion intégré, services à la Cinquième Commission de l’Assemblée générale et au Comité du programme et de la coordination, et services consultatifs de gestion: Services consultatifs de gestion",
    Title: "Meilleure compréhension, par le personnel, du système de justice formel de l’Organisation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=20"
  },
  {
    ID: 682,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Finances",
    Title: "Meilleur accès à des informations centralisées sur le recouvrement des coûts destinées à faciliter la prise de décisions par les entités du Secrétariat",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=23"
  },
  {
    ID: 683,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Finances",
    Title: "Amélioration de l’expérience des clients grâce aux systèmes de paiement internationaux",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=24"
  },
  {
    ID: 684,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Finances",
    Title: "Application des révisions approuvées des Normes comptables internationales du secteur public et analyse d’impact des modifications à venir",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=24"
  },
  {
    ID: 685,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Finances",
    Title: "Renforcement du cadre réglementaire afférent à la gestion financière à la faveur de l’établissement ou de l’actualisation d’instruments directifs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Adoption de cadres juridiques et réglementaires plus adaptés ; réduction du risque de mise en cause de la responsabilité juridique",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=25"
  },
  {
    ID: 686,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Finances des missions",
    Title: "Renforcement du contrôle de la gestion des biens et de l’application du principe de responsabilité en la matière",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=28"
  },
  {
    ID: 687,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Finances des missions",
    Title: "Coordination et échanges en vue de la création de synergies et de la normalisation dans le domaine de la gestion des installations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=29"
  },
  {
    ID: 688,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Finances des missions",
    Title: "Qualité et bon rapport coût-efficacité des grands projets de construction de l’Organisation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=30"
  },
  {
    ID: 689,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Finances des missions",
    Title: "Établir de manière plus transparente et plus efficace les prévisions budgétaires pour les missions politiques spéciales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=30"
  },
  {
    ID: 690,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Planification des programmes et établissement du budget",
    Title: "Aboutissement des délibérations budgétaires sur l’Initiative ONU80 dans un délai serré",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=34"
  },
  {
    ID: 691,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Planification des programmes et établissement du budget",
    Title: "Plus grande transparence de la communication avec les États Membres concernant l’examen des incidences sur le budget-programme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=34"
  },
  {
    ID: 692,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Planification des programmes et établissement du budget",
    Title: "Amélioration de la qualité des informations figurant dans le système pilote d’information budgétaire afin de faciliter la prise de décisions par les États Membres",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=35"
  },
  {
    ID: 693,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Planification des programmes, finances et budget: Planification des programmes et établissement du budget",
    Title: "Des prévisions budgétaires témoignant de gains d’efficience dans toutes les entités du Secrétariat",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=36"
  },
  {
    ID: 694,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Ressources humaines: Stratégies et politiques",
    Title: "Les membres du personnel, les cadres et la direction ont su gérer les changements organisationnels",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=40"
  },
  {
    ID: 695,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Ressources humaines: Stratégies et politiques",
    Title: "Réduction du nombre d’États Membres non représentés ou sous-représentés selon le système des fourchettes souhaitables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=40"
  },
  {
    ID: 696,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Ressources humaines: Stratégies et politiques",
    Title: "Un système de sélection du personnel équitable, efficace, efficient et souple",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=41"
  },
  {
    ID: 697,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Ressources humaines: Stratégies et politiques",
    Title: "Une démarche globale axée sur les jeunes talents qui renforce la capacité de l’Organisation d’attirer, de former et de retenir des personnes talentueuses en début de carrière",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=42"
  },
  {
    ID: 698,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Ressources humaines: Droit administratif",
    Title: "Recours accru aux outils de contrôle pour les questions de conduite et de discipline",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des mesures de lutte contre l’exploitation et les atteintes sexuelles, le harcèlement sexuel, la fraude et la corruption ; intégration plus systématique d’une approche centrée sur les victimes",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=44"
  },
  {
    ID: 699,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Ressources humaines: Droit administratif",
    Title: "Modification du cadre réglementaire du Secrétariat et des méthodes de gestion sur la base des jugements du Tribunal du contentieux administratif des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Adoption de cadres juridiques et réglementaires plus adaptés ; réduction du risque de mise en cause de la responsabilité juridique",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=45"
  },
  {
    ID: 700,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Ressources humaines: Droit administratif",
    Title: "Plus grande aptitude de la haute direction à prendre des décisions concernant le traitement des questions de déontologie et de discipline",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=46"
  },
  {
    ID: 701,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Ressources humaines: Droit administratif",
    Title: "Renforcement de la responsabilité grâce à un examen et un règlement efficaces et cohérents des affaires disciplinaires",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=46"
  },
  {
    ID: 702,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Transformation opérationnelle et questions de responsabilité",
    Title: "Résoudre les problèmes à l’aide de l’intelligence artificielle générative et gagner ainsi en efficacité",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=49"
  },
  {
    ID: 703,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Transformation opérationnelle et questions de responsabilité",
    Title: "Les petites entités recourent davantage à l’évaluation interne pour orienter la prise de décisions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=49"
  },
  {
    ID: 704,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Transformation opérationnelle et questions de responsabilité",
    Title: "Renforcement de la prise de décisions fondées sur des données grâce aux améliorations constamment apportées au tableau de bord de gestion",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=50"
  },
  {
    ID: 705,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Transformation opérationnelle et questions de responsabilité",
    Title: "Application en temps voulu des recommandations des organes de contrôle",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=50"
  },
  {
    ID: 706,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Éradication du racisme sur le lieu de travail",
    Title: "Lutter contre les manifestations interpersonnelles, institutionnelles et systémiques du racisme dans l’Organisation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=53"
  },
  {
    ID: 707,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Éradication du racisme sur le lieu de travail",
    Title: "Le dispositif d’application du principe de responsabilité est renforcé pour traiter les allégations de racisme sur le lieu de travail",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=54"
  },
  {
    ID: 708,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Éradication du racisme sur le lieu de travail",
    Title: "Amélioration de la transparence institutionnelle en matière de diversité",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=55"
  },
  {
    ID: 709,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Département des stratégies et politiques de gestion et de la conformité",
    Programme: "Département des stratégies et politiques de gestion et de la conformité",
    Subprogramme: "Éradication du racisme sur le lieu de travail",
    Title: "Une meilleure connaissance des questions liées à l’éradication du racisme et de la discrimination raciale sur le lieu de travail",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=fr#page=56"
  },
  {
    ID: 710,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Appui en matière de ressources humaines",
    Title: "Les entités du Secrétariat bénéficient d’un appui opérationnel complet en matière de ressources humaines, ainsi que d’orientations pour la restructuration et la réduction des effectifs",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=7"
  },
  {
    ID: 711,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Appui en matière de ressources humaines",
    Title: "Amélioration de la gestion de la performance dans l’ensemble du Secrétariat",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=8"
  },
  {
    ID: 712,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Appui en matière de ressources humaines",
    Title: "Amélioration de l’établissement et de la gestion des listes d’aptitude dans l’ensemble du Secrétariat",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=9"
  },
  {
    ID: 713,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Appui en matière de ressources humaines",
    Title: "Amélioration du recrutement de personnel fourni à titre gracieux",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=9"
  },
  {
    ID: 714,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Renforcement des capacités et formation opérationnelle",
    Title: "Le personnel des Nations Unies, les États Membres, les candidats à des postes et les responsables de postes à pourvoir ont accès à une plateforme centralisée consacrée aux compétences linguistiques et à l’aptitude à la communication",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=12"
  },
  {
    ID: 715,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Renforcement des capacités et formation opérationnelle",
    Title: "UNTold: apprentissage collectif et innovation dans l’ensemble du système des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=13"
  },
  {
    ID: 716,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Renforcement des capacités et formation opérationnelle",
    Title: "Renforcement des capacités de l’Organisation en matière d’innovation, d’analyse des données, de transformation numérique, de prospective stratégique et de sciences du comportement",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=13"
  },
  {
    ID: 717,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Renforcement des capacités et formation opérationnelle",
    Title: "Existence d’un plus grand nombre de directives administratives et opérationnelles et amélioration de l’accessibilité de ces directives",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=14"
  },
  {
    ID: 718,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Gestion des soins et sécurité et santé au travail",
    Title: "Amélioration de l’état de préparation à la prévention et à l’atténuation des risques liés aux maladies transmissibles qui touchent le personnel des Nations Unies",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=16"
  },
  {
    ID: 719,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Gestion des soins et sécurité et santé au travail",
    Title: "Le personnel des Nations Unies recourt aux services de santé préventive pour améliorer sa santé et son bien-être",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=17"
  },
  {
    ID: 720,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Gestion des soins et sécurité et santé au travail",
    Title: "Amélioration de la qualité des soins prodigués aux patients",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=18"
  },
  {
    ID: 721,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités d’appui: Gestion des soins et sécurité et santé au travail",
    Title: "Amélioration de l’accès aux services numériques d’aide à la santé mentale pour le personnel de maintien de la paix",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des résultats, de la sûreté et de la sécurité des missions de maintien de la paix, y compris pour ce qui est des transitions sans heurt après l’adoption de résolutions par le Conseil de sécurité",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=19"
  },
  {
    ID: 722,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Gestion de la chaîne d’approvisionnement: Gestion intégrée de la chaîne d’approvisionnement",
    Title: "Rapatriement sûr et rapide du personnel en tenue, conformément aux plans d’urgence des missions",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des résultats, de la sûreté et de la sécurité des missions de maintien de la paix, y compris pour ce qui est des transitions sans heurt après l’adoption de résolutions par le Conseil de sécurité",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=21"
  },
  {
    ID: 723,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Gestion de la chaîne d’approvisionnement: Gestion intégrée de la chaîne d’approvisionnement",
    Title: "Diversification des participants aux perspectives commerciales offertes par les Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Femmes et filles",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=22"
  },
  {
    ID: 724,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Gestion de la chaîne d’approvisionnement: Gestion intégrée de la chaîne d’approvisionnement",
    Title: "Disponibilité accrue des solutions logistiques à la demande",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=22"
  },
  {
    ID: 725,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Gestion de la chaîne d’approvisionnement: Gestion intégrée de la chaîne d’approvisionnement",
    Title: "Des solutions intégrées en matière de chaîne d’approvisionnement pour les opérations humanitaires et les environnements complexes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=23"
  },
  {
    ID: 726,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Gestion de la chaîne d’approvisionnement: Appui au personnel en tenue",
    Title: "Les missions de maintien de la paix ont exécuté des plans d’urgence qui ont permis de réduire les coûts",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des résultats, de la sûreté et de la sécurité des missions de maintien de la paix, y compris pour ce qui est des transitions sans heurt après l’adoption de résolutions par le Conseil de sécurité",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=26"
  },
  {
    ID: 727,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Gestion de la chaîne d’approvisionnement: Appui au personnel en tenue",
    Title: "Un site unique sécurisé permettant aux États Membres de soumettre des demandes et d’accéder à des informations sur leurs déploiements dans le cadre d’opérations de paix",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=26"
  },
  {
    ID: 728,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Gestion de la chaîne d’approvisionnement: Appui au personnel en tenue",
    Title: "Mise à jour des politiques, procédures, normes et définitions relatives au personnel en tenue et au matériel appartenant aux contingents",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=27"
  },
  {
    ID: 729,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Gestion de la chaîne d’approvisionnement: Appui au personnel en tenue",
    Title: "Amélioration de la gestion des munitions appartenant aux contingents",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=28"
  },
  {
    ID: 730,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités spéciales",
    Title: "Création du Bureau d’appui des Nations Unies en Haïti",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "29BDOS21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=31"
  },
  {
    ID: 731,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités spéciales",
    Title: "Amélioration de la gestion des fonctions d’appui opérationnel tout au long du cycle de vie par les entités en cours de transition",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des résultats, de la sûreté et de la sécurité des missions de maintien de la paix, y compris pour ce qui est des transitions sans heurt après l’adoption de résolutions par le Conseil de sécurité",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=32"
  },
  {
    ID: 732,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités spéciales",
    Title: "Amélioration de la prestation de services et de l’efficacité grâce au renforcement des services d’appui et de conseil",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CO,PK,ZW",
    Image: "29BDOS23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=33"
  },
  {
    ID: 733,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Activités spéciales",
    Title: "Renforcement des accords de partenariat d’appui",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=34"
  },
  {
    ID: 734,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Administration (New York)",
    Title: "Recouvrement automatisé des coûts des loyers par retenue sur les traitements",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=36"
  },
  {
    ID: 735,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Administration (New York)",
    Title: "Conservation numérique des documents historiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=37"
  },
  {
    ID: 736,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Administration (New York)",
    Title: "Des espaces de bureaux qui correspondent aux besoins de l’Organisation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=37"
  },
  {
    ID: 737,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Département de l’appui opérationnel",
    Programme: "Département de l’appui opérationnel",
    Subprogramme: "Administration (New York)",
    Title: "Accessibilité des locaux et des installations du Siège accrue pour les personnes handicapées",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Réfugiés, minorités et autres groupes vulnérables",
    BeneficiaryTwo: "Activités d’appui",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=fr#page=38"
  },
  {
    ID: 738,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Stratégie et innovations technologiques",
    Title: "Renforcer la sensibilisation à la sécurité informatique pour protéger le Secrétariat",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=8"
  },
  {
    ID: 739,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Stratégie et innovations technologiques",
    Title: "Efficacité accrue dans l’exécution des mandats grâce à l’intelligence artificielle générative",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=9"
  },
  {
    ID: 740,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Stratégie et innovations technologiques",
    Title: "Utilisation éthique et responsable de l’intelligence artificielle",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=9"
  },
  {
    ID: 741,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Stratégie et innovations technologiques",
    Title: "Aider les entités du Secrétariat à mettre en œuvre efficacement la stratégie Informatique et communications afin d’améliorer l’exécution des mandats",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=10"
  },
  {
    ID: 742,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Appui aux opérations",
    Title: "Une connectivité plus fiable et plus stable pour les représentants et le personnel grâce à l’amélioration du réseau Wi-Fi au Siège",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=13"
  },
  {
    ID: 743,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Appui aux opérations",
    Title: "Renforcement de la gouvernance des technologies qui soutiennent les réunions intergouvernementales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=14"
  },
  {
    ID: 744,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Appui aux opérations",
    Title: "Réduction des risques grâce à la sécurisation des accès au moyen d’outils d’authentification dans le cloud",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=15"
  },
  {
    ID: 745,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Appui aux opérations",
    Title: "Réduction de la fragmentation et renforcement de la résilience informatique, de la sécurité et de la standardisation de l’infrastructure des centres informatiques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=15"
  },
  {
    ID: 746,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Solutions institutionnelles",
    Title: "Amélioration de la disponibilité des sites Web et des applications grâce à leur transfert hors du centre informatique principal de New York",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=18"
  },
  {
    ID: 747,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Solutions institutionnelles",
    Title: "Des solutions informatiques sur mesure et disponibles en temps utile pour l’exécution des mandats",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès de la science, de la technologie et de l’innovation, y compris l’intelligence artificielle, au service du développement durable",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=18"
  },
  {
    ID: 748,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Solutions institutionnelles",
    Title: "Les solutions informatiques intègrent l’intelligence artificielle pour faciliter la prise de décision",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=19"
  },
  {
    ID: 749,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Bureau de l’informatique et des communications",
    Programme: "Bureau de l’informatique et des communications",
    Subprogramme: "Solutions institutionnelles",
    Title: "Amélioration de la sécurité, du multilinguisme et de l’accessibilité des sites Web d’information de l’Organisation et des normes y relatives",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29COICT12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=fr#page=20"
  },
  {
    ID: 750,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Traitement plus rapide des écritures comptables des clients",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=7"
  },
  {
    ID: 751,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Amélioration de la comptabilisation des actifs en ce qui concerne les bâtiments, les installations et les infrastructures de l’Office des Nations Unies à Nairobi",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=8"
  },
  {
    ID: 752,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Réémission plus rapide des paiements rejetés et renvoyés",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KE",
    Image: "29DUNON3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=9"
  },
  {
    ID: 753,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Meilleure tenue des délais pour la présentation des rapports financiers destinés aux donateurs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=9"
  },
  {
    ID: 754,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Les membres du personnel bénéficient d’un meilleur accompagnement en matière de bien-être et de santé mentale",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=11"
  },
  {
    ID: 755,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Les membres du personnel acquièrent de nouvelles connaissances et compétences propres à rendre l’organisation plus efficace",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=12"
  },
  {
    ID: 756,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Fourniture plus rapide des services liés aux avantages et prestations du personnel pour tous les clients",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=13"
  },
  {
    ID: 757,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Meilleur respect des délais par les bureaux clients dans les procédures de présélection",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=14"
  },
  {
    ID: 758,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Services d’appui",
    Title: "Les entités des Nations Unies présentes au Kenya ont accès à un centre de manifestations à l’intérieur du complexe des Nations Unies à Nairobi",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=16"
  },
  {
    ID: 759,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Services d’appui",
    Title: "Nouveaux espaces de réunion et de collaboration destinés aux représentants et aux membres du personnel",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=16"
  },
  {
    ID: 760,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Services d’appui",
    Title: "Le personnel des Nations Unies présent au Kenya et dans la région bénéficie de services efficaces et de qualité de la part du pays hôte",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=17"
  },
  {
    ID: 761,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Services d’appui",
    Title: "Amélioration des installations de conférence, intégrées aux locaux des Nations Unies à Nairobi",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=18"
  },
  {
    ID: 762,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Une plateforme informatique moderne conforme aux normes mondiales de l’Organisation des Nations Unies",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=20"
  },
  {
    ID: 763,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Meilleure harmonisation des politiques et des pratiques en matière d’informatique et de communications dans les entités des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=21"
  },
  {
    ID: 764,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Bon déroulement des délibérations intergouvernementales grâce à la modernisation et à la maintenance des technologies de conférence",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KE",
    Image: "29DUNON15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=21"
  },
  {
    ID: 765,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Office des Nations Unies à Nairobi",
    Programme: "Administration (Nairobi)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Meilleure interopérabilité du réseau grâce à une plateforme unique de prestation de services",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=fr#page=22"
  },
  {
    ID: 766,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Amélioration des délais de paiement des fournisseurs",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=7"
  },
  {
    ID: 767,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Un soutien spécialisé aux entités qui emménagent dans le Palais des Nations ou qui en partent",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=8"
  },
  {
    ID: 768,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Des opérations de gestion de trésorerie solides et efficaces",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=8"
  },
  {
    ID: 769,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Des rapports trimestriels qui renseignent mieux les clients sur la performance de la prestation de service",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=9"
  },
  {
    ID: 770,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Soutien au personnel pour la transition de carrière et la cessation de service anticipée",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=11"
  },
  {
    ID: 771,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Les membres du personnel et les candidats externes comprennent mieux la procédure de recrutement de l’ONU et peuvent faire des choix de carrière en connaissance de cause",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=12"
  },
  {
    ID: 772,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Renforcement de la participation des jeunes et du dialogue intergénérationnel",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Jeunes",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=13"
  },
  {
    ID: 773,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Amélioration de l’appui apporté aux membres du personnel et meilleure préparation organisationnelle tout au long des transitions",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=13"
  },
  {
    ID: 774,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Services d’appui",
    Title: "Les systèmes audiovisuels de la Salle des Assemblées permettent d’organiser de grandes réunions et manifestations intergouvernementales",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=15"
  },
  {
    ID: 775,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Services d’appui",
    Title: "Phase II de la mise en place du centre d’assistance à l’organisation des manifestations – amélioration de l’appui audiovisuel apporté aux États Membres et aux entités clientes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=17"
  },
  {
    ID: 776,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Services d’appui",
    Title: "Des installations modernes mises à la disposition des clients à l’issue des travaux de rénovation menés au titre du Plan stratégique patrimonial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=17"
  },
  {
    ID: 777,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Services d’appui",
    Title: "Amélioration de la gestion énergétique au Palais des Nations",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Climat et environnement",
    SpecificResult: "Gestion durable des ressources ; progrès dans le domaine des énergies renouvelables",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=18"
  },
  {
    ID: 778,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Les clients optimisent l’utilisation de leur ligne téléphonique fixe",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=20"
  },
  {
    ID: 779,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Phase I de la mise en place du centre d’assistance à l’organisation des manifestations – accès des clients à un guichet unique et à un outil en ligne pour l’organisation de rencontres culturelles, de manifestations parallèles et d’autres activités",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Améliorations relatives aux réunions et délibérations multilatérales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=20"
  },
  {
    ID: 780,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Amélioration de l’efficacité, de la sécurité et de l’expérience client grâce à l’Internet des objets",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=21"
  },
  {
    ID: 781,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Des services de réseau plus rapides et plus fiables pour les clients",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=22"
  },
  {
    ID: 782,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Services de bibliothèque",
    Title: "Des collections de bibliothèques historiques et irremplaçables préservées pour les générations futures pendant les travaux de rénovation",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=24"
  },
  {
    ID: 783,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Services de bibliothèque",
    Title: "De plus en plus d’outils permettent aux clients de trouver et d’utiliser des sources d’information de manière efficace et responsable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=25"
  },
  {
    ID: 784,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Services de bibliothèque",
    Title: "L’accès à un ensemble plus vaste de connaissances accumulées par l’ONU est amélioré",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=25"
  },
  {
    ID: 785,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Office des Nations Unies à Genève",
    Programme: "Administration (Genève)",
    Subprogramme: "Services de bibliothèque",
    Title: "Les États Membres et d’autres parties prenantes ont un accès durable aux archives des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=fr#page=26"
  },
  {
    ID: 786,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Poursuite des programmes malgré une interruption imprévue du financement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=7"
  },
  {
    ID: 787,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Amélioration de la comptabilité générale et de l’information financière grâce à la mise en œuvre de la norme IPSAS 47 (Produits)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=7"
  },
  {
    ID: 788,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Moins de problèmes financiers non résolus dans les bureaux extérieurs",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=8"
  },
  {
    ID: 789,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Planification des programmes, finances et budget",
    Title: "Amélioration de la transparence financière et du contrôle de la gestion",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=9"
  },
  {
    ID: 790,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Amélioration des modalités contractuelles applicables au personnel affecté aux projets sur le terrain",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=11"
  },
  {
    ID: 791,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Inclusion des collègues en situation de handicap",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration du recrutement et de la gestion des effectifs dans les entités des Nations Unies, se manifestant notamment par un meilleur équilibre entre les femmes et les hommes et par une représentation géographique plus équitable",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=11"
  },
  {
    ID: 792,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Les clients sont informés et conscients de toutes les politiques et nouveautés pertinentes dans le domaine des ressources humaines",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de la diffusion de l’information et de l’accès à celle-ci",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=12"
  },
  {
    ID: 793,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Gestion des ressources humaines",
    Title: "Meilleure connaissance du Code de conduite pour la prévention du harcèlement, y compris le harcèlement sexuel, lors des événements du système des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Consolidation des mécanismes de justice interne et de médiation pour des comportements plus conformes aux règles déontologiques, des rapports plus harmonieux sur le lieu de travail et un meilleur accès à la justice au sein du système des Nations Unies",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=13"
  },
  {
    ID: 794,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Services d’appui",
    Title: "Renforcement de la gestion des biens",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=15"
  },
  {
    ID: 795,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Services d’appui",
    Title: "Amélioration du suivi des partenaires de réalisation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=16"
  },
  {
    ID: 796,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Services d’appui",
    Title: "Rationalisation du flux de travail relatif à l’enregistrement et la diffusion de la correspondance officielle",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=16"
  },
  {
    ID: 797,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Services d’appui",
    Title: "Meilleure utilisation de l’espace de travail",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=17"
  },
  {
    ID: 798,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Renforcement de la fiabilité des opérations liées à l’informatique et aux communications grâce à la consolidation de l’infrastructure virtuelle et à une moindre dépendance à l’égard des licences par abonnement",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=19"
  },
  {
    ID: 799,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Renforcement de la sécurité informatique sur le terrain",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=19"
  },
  {
    ID: 800,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Transformation numérique des entités clientes aux fins d’une meilleure exécution des mandats",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=20"
  },
  {
    ID: 801,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Office des Nations Unies à Vienne",
    Programme: "Administration (Vienne)",
    Subprogramme: "Aspects opérationnels de l’informatique et des communications",
    Title: "Approche harmonisée de la sécurité informatique dans l’ensemble des lieux d’affectation des départements clients de l’Office des Nations Unies à Vienne",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=fr#page=21"
  },
  {
    ID: 802,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Audit interne",
    Title: "Renforcement de l’application du principe de responsabilité en ce qui concerne le temps de travail et les présences du personnel",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=7"
  },
  {
    ID: 803,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Audit interne",
    Title: "Renforcement des systèmes de suivi pour une meilleure gestion de la performance, à l’appui de l’exécution des programmes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=7"
  },
  {
    ID: 804,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Audit interne",
    Title: "Amélioration de l’exécution des mandats et des programmes des entités des Nations Unies grâce au renforcement des capacités organisationnelles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=8"
  },
  {
    ID: 805,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Audit interne",
    Title: "Amélioration de l’efficacité en matière d’administration de l’Organisation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=9"
  },
  {
    ID: 806,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Inspection et évaluation",
    Title: "Renforcement des capacités d’autoévaluation au Secrétariat",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=11"
  },
  {
    ID: 807,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Inspection et évaluation",
    Title: "Renforcement du système des coordonnatrices et coordonnateurs résidents",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=12"
  },
  {
    ID: 808,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Inspection et évaluation",
    Title: "Amélioration des résultats du programme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=12"
  },
  {
    ID: 809,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Inspection et évaluation",
    Title: "Amélioration de l’exécution des mandats grâce à une meilleure planification des programmes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=13"
  },
  {
    ID: 810,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Investigations",
    Title: "Renforcement de la capacité de l’Organisation à protéger ses ressources et à amener les membres de son personnel à répondre de leurs actes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des mesures de lutte contre l’exploitation et les atteintes sexuelles, le harcèlement sexuel, la fraude et la corruption ; intégration plus systématique d’une approche centrée sur les victimes",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=15"
  },
  {
    ID: 811,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Investigations",
    Title: "Renforcement des procédures d’enquête sur les fautes exigeant des mesures axées sur les victimes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des mesures de lutte contre l’exploitation et les atteintes sexuelles, le harcèlement sexuel, la fraude et la corruption ; intégration plus systématique d’une approche centrée sur les victimes",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=16"
  },
  {
    ID: 812,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Investigations",
    Title: "Amélioration du traitement des plaintes pour fautes et du délai des décisions y relatives",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des mesures de lutte contre l’exploitation et les atteintes sexuelles, le harcèlement sexuel, la fraude et la corruption ; intégration plus systématique d’une approche centrée sur les victimes",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=17"
  },
  {
    ID: 813,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Bureau des services de contrôle interne",
    Programme: "Contrôle interne",
    Subprogramme: "Investigations",
    Title: "Conduite rapide d’enquêtes sur les cas susceptibles d’entraîner des pertes financières pour l’Organisation",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Renforcement des mesures de lutte contre l’exploitation et les atteintes sexuelles, le harcèlement sexuel, la fraude et la corruption ; intégration plus systématique d’une approche centrée sur les victimes",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=fr#page=17"
  },
  {
    ID: 814,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Commission de la fonction publique internationale",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Commission de la fonction publique internationale",
    Title: "Un modèle juste et équitable concernant l’indemnité transitoire",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=4"
  },
  {
    ID: 815,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Commission de la fonction publique internationale",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Commission de la fonction publique internationale",
    Title: "Une plus grande souplesse est prévue pour le personnel travaillant dans des lieux d’affectation où les conditions sont extrêmement difficiles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=5"
  },
  {
    ID: 816,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Commission de la fonction publique internationale",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Commission de la fonction publique internationale",
    Title: "Des normes de conduite révisées visant à aider les organismes à prendre des décisions sur les questions nouvelles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=6"
  },
  {
    ID: 817,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Commission de la fonction publique internationale",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Commission de la fonction publique internationale",
    Title: "Un ensemble de prestations qui correspond aux objectifs, aux critères et aux paramètres approuvés par l’Assemblée générale",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=7"
  },
  {
    ID: 818,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Corps commun d'inspection",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Corps commun d’inspection",
    Title: "Une meilleure prise en compte des recommandations du Corps commun d’inspection grâce à un nouvel outil de suivi des recommandations",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=16"
  },
  {
    ID: 819,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Corps commun d'inspection",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Corps commun d’inspection",
    Title: "Les questions relatives à la gestion et à l’administration et celles relatives aux programmes sont mieux gérées par les entités des Nations Unies grâce à l’application de recommandations stratégiques et opérationnelles formulées par le Corps commun d’inspection",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=17"
  },
  {
    ID: 820,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Corps commun d'inspection",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Corps commun d’inspection",
    Title: "Renforcement de l’incidence des recommandations du Corps commun",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=18"
  },
  {
    ID: 821,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Corps commun d'inspection",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Corps commun d’inspection",
    Title: "Renforcement de la base de connaissances du système et amélioration de la prise de décisions grâce à la formulation de constatations fondées sur des données factuelles lors des opérations de contrôle",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=19"
  },
  {
    ID: 822,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Conseil des chefs de secrétariat des organismes des Nations Unies pour la coordination",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Conseil des chefs de secrétariat des organismes des Nations Unies pour la coordination",
    Title: "Des mesures d’efficience de grande envergure visant à rationaliser collectivement les opérations du système des Nations Unies, à réduire les coûts et à garantir la pérennité de l’impact obtenu",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=27"
  },
  {
    ID: 823,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Conseil des chefs de secrétariat des organismes des Nations Unies pour la coordination",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Conseil des chefs de secrétariat des organismes des Nations Unies pour la coordination",
    Title: "Mise en service de l’identité numérique des Nations Unies, composante essentielle de l’interopérabilité entre les entités des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Progrès technologiques conduisant à une amélioration de la qualité, de la disponibilité, de l’accessibilité et de la sécurité des informations",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=28"
  },
  {
    ID: 824,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Conseil des chefs de secrétariat des organismes des Nations Unies pour la coordination",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Conseil des chefs de secrétariat des organismes des Nations Unies pour la coordination",
    Title: "Amélioration de la cohérence des activités du système des Nations Unies visant à accélérer les progrès vers la réalisation des objectifs de développement durable et la mise en œuvre du Pacte pour l’avenir",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Accélération des progrès dans la réalisation des ODD, notamment par la consolidation des structures de coordination et la prise en compte efficace des liens de corrélation entre ces objectifs",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=28"
  },
  {
    ID: 825,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Conseil des chefs de secrétariat des organismes des Nations Unies pour la coordination",
    Programme: "Activités administratives financées en commun",
    Subprogramme: "Conseil des chefs de secrétariat des organismes des Nations Unies pour la coordination",
    Title: "La coordination et la cohérence au sein du système des Nations Unies permettent une action efficiente, s’inscrivant dans la durée et fondée sur des principes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplification, transparence et facilité d’accès au service d’une meilleure exécution des programmes",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=fr#page=29"
  },
  {
    ID: 826,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Services de sûreté et de sécurité",
    Title: "Un environnement sûr et sécurité est garanti à tous les représentants et participants à la quatre-vingtième session de l’Assemblée générale",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Communauté internationale",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=7"
  },
  {
    ID: 827,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Services de sûreté et de sécurité",
    Title: "Facilité de déplacement des représentants et du personnel d’un lieu d’affectation à l’autre",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=8"
  },
  {
    ID: 828,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Services de sûreté et de sécurité",
    Title: "Amélioration des dispositifs d’enregistrement, de délivrance des cartes d’accès et de sécurité pour les personnes handicapées",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: "Réfugiés, minorités et autres groupes vulnérables",
    SpecificResult: "Amélioration des infrastructures propre à fournir un appui plus efficace et efficient aux opérations des Nations Unies",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=9"
  },
  {
    ID: 829,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Services de sûreté et de sécurité",
    Title: "Amélioration de la prise de décision en matière de sûreté et de sécurité",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=9"
  },
  {
    ID: 830,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Opérations sur le terrain",
    Title: "Gains d’efficience plus importants, l’accent étant mis sur les lieux à haut risque",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=12"
  },
  {
    ID: 831,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Opérations sur le terrain",
    Title: "Amélioration de la préparation et de la réponse aux crises",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=13"
  },
  {
    ID: 832,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Opérations sur le terrain",
    Title: "Amélioration de la prise de décisions en matière de sécurité",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=13"
  },
  {
    ID: 833,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Opérations sur le terrain",
    Title: "Prise de décisions en matière de sûreté et de sécurité fondée sur la connaissance des risques",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=14"
  },
  {
    ID: 834,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Services spécialisés",
    Title: "De nouveaux systèmes numériques ont renforcé la sûreté et la sécurité du personnel des Nations Unies",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration de l’efficience des processus grâce à la science, la technologie et l’innovation",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=16"
  },
  {
    ID: 835,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Services spécialisés",
    Title: "Homogénéité et cohérence des activités menées dans l’ensemble du système de gestion de la sécurité des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=17"
  },
  {
    ID: 836,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Services spécialisés",
    Title: "Renforcement des services de protection individuelle des hauts fonctionnaires des Nations Unies",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=18"
  },
  {
    ID: 837,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Département de la sûreté et de la sécurité",
    Programme: "Sûreté et sécurité",
    Subprogramme: "Services spécialisés",
    Title: "Approche harmonisée du soutien psychosocial après un événement traumatisant",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Contribution aux activités concernant les huit priorités",
    Beneficiary: "Activités d’appui",
    BeneficiaryTwo: " ",
    SpecificResult: "Amélioration des capacités organisationnelles, de l’application du principe de responsabilité et de la réactivité pour une meilleure exécution des mandats",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=fr#page=19"
  }
]